import { HttpClient } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import * as FPA from "src/assets/templates-dev/FONTES_PAGADORAS_ALIQ.json";

import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class DashboardService2Service {

  constructor(private http: HttpClient) { }

  public getJSON(url) {
    return this.http.get(url).toPromise();
  }

  async getTemplate(name: string) {
    switch (name) {
      case "F02 - DARFs":
        return this.getJSON('sistema/assets/templates-dev/F02 - DARFs.json');

      case "F03A - DCTF - PC CUMULATIVO":
        return this.getJSON('sistema/assets/templates-dev/F03A - DCTF - PC CUMULATIVO.json');

      case "F03B - DCTF - PC NAO CUMULATIVO":
        return this.getJSON('sistema/assets/templates-dev/F03B - DCTF - PC NAO CUMULATIVO.json');

      case "F04A - DCTF - IRCS PRESUMIDO":
        return this.getJSON('sistema/assets/templates-dev/F04A - DCTF - IRCS PRESUMIDO.json');

      case "F04B - DCTF - IRCS REAL TRIMEST":
        return this.getJSON('sistema/assets/templates-dev/F04B - DCTF - IRCS REAL TRIMEST.json');

      case "F04C - DCTF - IRCS REAL ANUAL":
        return this.getJSON('sistema/assets/templates-dev/F04C - DCTF - IRCS REAL ANUAL.json');

      case "F05A - SPED CT - PC CUMULATIVO":
        return this.getJSON('sistema/assets/templates-dev/F05A - SPED CT - PC CUMULATIVO.json');

      case "F05B - SPED CT -  PC N CUMULAT":
        return this.getJSON('sistema/assets/templates-dev/F05B - SPED CT -  PC N CUMULAT.json');

      case "F06 - SPED CT - INSUMOS":
        return this.getJSON('sistema/assets/templates-dev/F06 - SPED CT - INSUMOS.json');

      case "F07 - SPED CT - CST":
        return this.getJSON('sistema/assets/templates-dev/F07 - SPED CT - CST.json');

      case "F08 - ECF - IRPJ":
        return this.getJSON('sistema/assets/templates-dev/F08 - ECF - IRPJ.json');

      case "F09 - ECF - CSLL":
        return this.getJSON('sistema/assets/templates-dev/F09 - ECF - CSLL.json');

      case "F10 - COMP FONTES PAGADORAS":
        return this.getJSON('sistema/assets/templates-dev/F10 - COMP FONTES PAGADORAS.json');

      case "F11 - COMPARATIVO DE RECEITAS":
        return this.getJSON('sistema/assets/templates-dev/F11 - COMPARATIVO DE RECEITAS.json');

      case "F12A - DARFxDCTFxSPED PC CUMULA":
        return this.getJSON('sistema/assets/templates-dev/F12A - DARFxDCTFxSPED PC CUMULA.json');

      case "F12B - DARFxDCTFxSPED PC NAOCUM":
        return this.getJSON('sistema/assets/templates-dev/F12B - DARFxDCTFxSPED PC NAOCUM.json');

      case "F13A - DARFxDCTFxECF IRCS PRESU":
        return this.getJSON('sistema/assets/templates-dev/F13A - DARFxDCTFxECF IRCS PRESU.json');

      case "F13B - DARFxDCTFxECF IRCS R TRI":
        return this.getJSON('sistema/assets/templates-dev/F13B - DARFxDCTFxECF IRCS R TRI.json');

      case "F13C - DARFxDCTFxECF IRCS RA":
        return this.getJSON('sistema/assets/templates-dev/F13C - DARFxDCTFxECF IRCS RA.json');

      case "F14a - APURAÇÕES DCTF X SPEDCT":
        return this.getJSON('sistema/assets/templates-dev/F14a - APURAÇÕES DCTF X SPEDCT.json');

      case "F14b - APURAÇÕES DCTF X SPEDECF":
        return this.getJSON('sistema/assets/templates-dev/F14b - APURAÇÕES DCTF X SPEDECF.json');

      default:
        return undefined;
    }
  }

  getSheetNames() {
    let names: Array<string> = [
      "F14b - APURAÇÕES DCTF X SPEDECF",
      "F14a - APURAÇÕES DCTF X SPEDCT",
      "F13C - DARFxDCTFxECF IRCS RA",
      "F13B - DARFxDCTFxECF IRCS R TRI",
      "F13A - DARFxDCTFxECF IRCS PRESU",
      "F12B - DARFxDCTFxSPED PC NAOCUM",
      "F12A - DARFxDCTFxSPED PC CUMULA",
      "F11 - COMPARATIVO DE RECEITAS",
      "F10 - COMP FONTES PAGADORAS",
      "F09 - ECF - CSLL",
      "F08 - ECF - IRPJ",
      "F07 - SPED CT - CST",
      "F06 - SPED CT - INSUMOS",
      "F05B - SPED CT -  PC N CUMULAT",
      "F05A - SPED CT - PC CUMULATIVO",
      "F04C - DCTF - IRCS REAL ANUAL",
      "F04B - DCTF - IRCS REAL TRIMEST",
      "F04A - DCTF - IRCS PRESUMIDO",
      "F03B - DCTF - PC NAO CUMULATIVO",
      "F03A - DCTF - PC CUMULATIVO",
      "F02 - DARFs"
    ];
    return names;
  }

  convertLetterToNumber(n) {
    const res = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[n % 26];
    return n >= 26 ? this.convertLetterToNumber(Math.floor(n / 26) - 1) + res : res;
  }

  getPrescricional() {
    let today = new Date();
    let result: Array<string> = [];
    for (let i = (today.getUTCFullYear() - 5); i < today.getUTCFullYear(); i++) {
      for (let u = 1; u <= 12; u++) {
        result.push("01/" + u.toString().padStart(2, '0') + "/" + i);
      }
    }
    return result;
  }

  getTrimestres() {
    let today = new Date();
    let result: Array<string> = [];
    for (let i = (today.getUTCFullYear() - 5); i < today.getUTCFullYear(); i++) {
      for (let u = 1; u <= 4; u++) {
        result.push(u.toString() + "° T. " + i);
      }
    }
    return result;
  }

  getAnual() {
    let today = new Date();
    let result: Array<string> = [];
    for (let i = (today.getUTCFullYear() - 5); i < today.getUTCFullYear(); i++) {
      result.push(i.toString());
    }
    return result;
  }

  JSDateToExcelDate(date) {
    const parts = date.split('/');
    const serial = new Date(parts[2], parts[1] - 1, parts[0]);
    return 25569.0 + ((serial.getTime() - (serial.getTimezoneOffset() * 60 * 1000)) / (1000 * 60 * 60 * 24));
  }

  getJsDateFromExcel(excelDate) {
    return new Date((excelDate - (25567 + 1)) * 86400 * 1000).toLocaleDateString();
  }

  fromUS(date) {
    const parts = date.split('-');
    return parts[2] + '/' + parts[1] + '/' + parts[0]
  }

  F02(template: any, dashData: any, configuracoes: any): any {
    const prescricional = this.getPrescricional();
    const trimestres = this.getTrimestres();
    const anos = this.getAnual();

    template.data[1][1] = configuracoes.header;
    template.data[71][1] = configuracoes.footer;

    let keys: any = {};
    const tmp = dashData.find(element => element.worksheetName === 'DARFs');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "Período de Apuração") {
          keys['apuracao'] = u;
        }
        if (tmp.columns[u].title === "Código de Receita") {
          keys['cod_receita'] = u;
        }
        if (tmp.columns[u].title === "Valor Total") {
          keys['principal'] = u;
        }
        if (tmp.columns[u].title === "Multa") {
          keys['multa'] = u;
        }
        if (tmp.columns[u].title === "Juros") {
          keys['juros'] = u;
        }
      }

      let darfs = {};
      for (let i = 10; i < 70; i++) {
        template.data[i][0] = this.JSDateToExcelDate(prescricional[i - 10])
        template.data[i][10] = this.JSDateToExcelDate(prescricional[i - 10])
        darfs[prescricional[i - 10].split('/')[1] + '/' + prescricional[i - 10].split('/')[2]] = [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]];
      }

      for (let i = 10; i < 30; i++) {
        template.data[i][16] = trimestres[i - 10];
        template.data[i][22] = trimestres[i - 10];
        darfs[trimestres[i - 10]] = [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]];
      }

      for (let i = 10; i < 15; i++) {
        template.data[i][28] = anos[i - 10];
        darfs[anos[i - 10]] = [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = '';
        switch (tmp.data[u][keys['cod_receita']]) {
          case "8109":
            x = tmp.data[u][keys['apuracao']].split("-")
            if (darfs[x[1] + '/' + x[0]]) {
              darfs[x[1] + '/' + x[0]][0][0] = darfs[x[1] + '/' + x[0]][0][0] + tmp.data[u][keys['principal']].fix()
              darfs[x[1] + '/' + x[0]][0][1] = darfs[x[1] + '/' + x[0]][0][1] + tmp.data[u][keys['multa']].fix() + tmp.data[u][keys['juros']].fix()
            }
            break;
          case "2172":
            x = tmp.data[u][keys['apuracao']].split("-");
            if (darfs[x[1] + '/' + x[0]]) {
              darfs[x[1] + '/' + x[0]][1][0] = darfs[x[1] + '/' + x[0]][1][0] + tmp.data[u][keys['principal']].fix()
              darfs[x[1] + '/' + x[0]][1][1] = darfs[x[1] + '/' + x[0]][1][1] + tmp.data[u][keys['multa']].fix() + tmp.data[u][keys['juros']].fix()
            }
            break
          case "6912":
            x = tmp.data[u][keys['apuracao']].split("-");
            if (darfs[x[1] + '/' + x[0]]) {
              darfs[x[1] + '/' + x[0]][2][0] = darfs[x[1] + '/' + x[0]][2][0] + tmp.data[u][keys['principal']].fix()
              darfs[x[1] + '/' + x[0]][2][1] = darfs[x[1] + '/' + x[0]][2][1] + tmp.data[u][keys['multa']].fix() + tmp.data[u][keys['juros']].fix()
            }
            break
          case "5856":
            x = tmp.data[u][keys['apuracao']].split("-");
            if (darfs[x[1] + '/' + x[0]]) {
              darfs[x[1] + '/' + x[0]][3][0] = darfs[x[1] + '/' + x[0]][3][0] + tmp.data[u][keys['principal']].fix()
              darfs[x[1] + '/' + x[0]][3][1] = darfs[x[1] + '/' + x[0]][3][1] + tmp.data[u][keys['multa']].fix() + tmp.data[u][keys['juros']].fix()
            }
            break
          case "5993":
            x = tmp.data[u][keys['apuracao']].split("-");
            if (darfs[x[1] + '/' + x[0]]) {
              darfs[x[1] + '/' + x[0]][4][0] = darfs[x[1] + '/' + x[0]][4][0] + tmp.data[u][keys['principal']].fix()
              darfs[x[1] + '/' + x[0]][4][1] = darfs[x[1] + '/' + x[0]][4][1] + tmp.data[u][keys['multa']].fix() + tmp.data[u][keys['juros']].fix()
            }
            break
          case "2362":
            x = tmp.data[u][keys['apuracao']].split("-");
            if (darfs[x[1] + '/' + x[0]]) {
              darfs[x[1] + '/' + x[0]][4][0] = darfs[x[1] + '/' + x[0]][4][0] + tmp.data[u][keys['principal']].fix()
              darfs[x[1] + '/' + x[0]][4][1] = darfs[x[1] + '/' + x[0]][4][1] + tmp.data[u][keys['multa']].fix() + tmp.data[u][keys['juros']].fix()
            }
            break
          case "2484":
            x = tmp.data[u][keys['apuracao']].split("-");
            if (darfs[x[1] + '/' + x[0]]) {
              darfs[x[1] + '/' + x[0]][5][0] = darfs[x[1] + '/' + x[0]][5][0] + tmp.data[u][keys['principal']].fix()
              darfs[x[1] + '/' + x[0]][5][1] = darfs[x[1] + '/' + x[0]][5][1] + tmp.data[u][keys['multa']].fix() + tmp.data[u][keys['juros']].fix()
            }
            break
          case "2089":
            x = tmp.data[u][keys['apuracao']].split("-");
            x = Math.ceil(Number(x[1]) / 3).toString() + '° T. ' + x[0]
            if (darfs[x]) {
              darfs[x][6][0] = darfs[x][6][0] + tmp.data[u][keys['principal']].fix()
              darfs[x][6][1] = darfs[x][6][1] + tmp.data[u][keys['multa']].fix() + tmp.data[u][keys['juros']].fix()
            }
            break
          case "2372":
            x = tmp.data[u][keys['apuracao']].split("-");
            x = Math.ceil(Number(x[1]) / 3).toString() + '° T. ' + x[0]
            if (darfs[x]) {
              darfs[x][7][0] = darfs[x][7][0] + tmp.data[u][keys['principal']].fix()
              darfs[x][7][1] = darfs[x][7][1] + tmp.data[u][keys['multa']].fix() + tmp.data[u][keys['juros']].fix()
            }
            break
          case "3373":
            x = tmp.data[u][keys['apuracao']].split("-");
            x = Math.ceil(Number(x[1]) / 3).toString() + '° T. ' + x[0]
            if (darfs[x]) {
              darfs[x][8][0] = darfs[x][8][0] + tmp.data[u][keys['principal']].fix()
              darfs[x][8][1] = darfs[x][8][1] + tmp.data[u][keys['multa']].fix() + tmp.data[u][keys['juros']].fix()
            }
            break
          case "0220":
            x = tmp.data[u][keys['apuracao']].split("-");
            x = Math.ceil(Number(x[1]) / 3).toString() + '° T. ' + x[0]
            if (darfs[x]) {
              darfs[x][8][0] = darfs[x][8][0] + tmp.data[u][keys['principal']].fix()
              darfs[x][8][1] = darfs[x][8][1] + tmp.data[u][keys['multa']].fix() + tmp.data[u][keys['juros']].fix()
            }
            break
          case "6012":
            x = tmp.data[u][keys['apuracao']].split("-");
            x = Math.ceil(Number(x[1]) / 3).toString() + '° T. ' + x[0]
            if (darfs[x]) {
              darfs[x][9][0] = darfs[x][9][0] + tmp.data[u][keys['principal']].fix()
              darfs[x][9][1] = darfs[x][9][1] + tmp.data[u][keys['multa']].fix() + tmp.data[u][keys['juros']].fix()
            }
            break
          case "2430":
            x = tmp.data[u][keys['apuracao']].split("-")[0];
            if (darfs[x]) {
              darfs[x][10][0] = darfs[x][10][0] + tmp.data[u][keys['principal']].fix()
              darfs[x][10][1] = darfs[x][10][1] + tmp.data[u][keys['multa']].fix() + tmp.data[u][keys['juros']].fix()
            }
            break
          case "2456":
            x = tmp.data[u][keys['apuracao']].split("-")[0];
            if (darfs[x]) {
              darfs[x][10][0] = darfs[x][10][0] + tmp.data[u][keys['principal']].fix()
              darfs[x][10][1] = darfs[x][10][1] + tmp.data[u][keys['multa']].fix() + tmp.data[u][keys['juros']].fix()
            }
            break
          case "2390":
            x = tmp.data[u][keys['apuracao']].split("-")[0];
            if (darfs[x]) {
              darfs[x][10][0] = darfs[x][10][0] + tmp.data[u][keys['principal']].fix()
              darfs[x][10][1] = darfs[x][10][1] + tmp.data[u][keys['multa']].fix() + tmp.data[u][keys['juros']].fix()
            }
            break
          case "6773":
            x = tmp.data[u][keys['apuracao']].split("-")[0];
            if (darfs[x]) {
              darfs[x][11][0] = darfs[x][11][0] + tmp.data[u][keys['principal']].fix()
              darfs[x][11][1] = darfs[x][11][1] + tmp.data[u][keys['multa']].fix() + tmp.data[u][keys['juros']].fix()
            }
            break
          case "6758":
            x = tmp.data[u][keys['apuracao']].split("-")[0];
            if (darfs[x]) {
              darfs[x][11][0] = darfs[x][11][0] + tmp.data[u][keys['principal']].fix()
              darfs[x][11][1] = darfs[x][11][1] + tmp.data[u][keys['multa']].fix() + tmp.data[u][keys['juros']].fix()
            }
            break
        }
      }

      for (let i = 10; i < 70; i++) {
        let x: any = this.getJsDateFromExcel(template.data[i][0]).split('/');
        x = x[1] + '/' + x[2];
        if (darfs[x]) {
          template.data[i][1] = (darfs[x][0][0] - darfs[x][0][1]);
          template.data[i][2] = darfs[x][0][1];

          template.data[i][3] = (darfs[x][1][0] - darfs[x][1][1]);
          template.data[i][4] = darfs[x][1][1];

          template.data[i][5] = (darfs[x][2][0] - darfs[x][2][1]);
          template.data[i][6] = darfs[x][2][1];

          template.data[i][7] = (darfs[x][3][0] - darfs[x][3][1]);
          template.data[i][8] = darfs[x][3][1];

          template.data[i][11] = (darfs[x][4][0] - darfs[x][4][1]);
          template.data[i][12] = darfs[x][4][1];

          template.data[i][13] = (darfs[x][5][0] - darfs[x][5][1]);
          template.data[i][14] = darfs[x][5][1];
        }
      }

      for (let i = 10; i < 30; i++) {
        let x = template.data[i][16];
        if (darfs[x]) {
          template.data[i][17] = (darfs[x][6][0] - darfs[x][6][1]);
          template.data[i][18] = darfs[x][6][1];

          template.data[i][19] = (darfs[x][7][0] - darfs[x][7][1]);
          template.data[i][20] = darfs[x][7][1];

          template.data[i][23] = (darfs[x][8][0] - darfs[x][8][1]);
          template.data[i][24] = darfs[x][8][1];

          template.data[i][25] = (darfs[x][9][0] - darfs[x][9][1]);
          template.data[i][26] = darfs[x][9][1];
        }
      }

      for (let i = 10; i < 15; i++) {
        let x = template.data[i][28];
        if (darfs[x]) {
          template.data[i][29] = (darfs[x][10][0] - darfs[x][10][1]);
          template.data[i][30] = darfs[x][10][1];

          template.data[i][31] = (darfs[x][11][0] - darfs[x][11][1]);
          template.data[i][32] = darfs[x][11][1];
        }
      }
    }

    return JSON.parse(JSON.stringify(template).replace(/#2e3757/g, configuracoes.data.toString()));
  }

  F03A(template: any, dashData: any, configuracoes: any): any {
    template.data[1][1] = configuracoes.header;
    template.data[70][1] = configuracoes.footer;

    const prescricional = this.getPrescricional();
    for (let i = 9; i < 69; i++) {
      template.data[i][0] = this.JSDateToExcelDate(prescricional[i - 9]);
      template.data[i][10] = this.JSDateToExcelDate(prescricional[i - 9]);
    }

    let keys: any = {};
    let tmp = dashData.find(element => element.worksheetName === 'DCTF - R10');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "MOFG - Mês de Ocorrência do Fato Gerador") {
          keys['mofg'] = u;
        }
        if (tmp.columns[u].title === "Código da Receita") {
          keys['cod_receita'] = u;
        }
        if (tmp.columns[u].title === "Valor do Débito") {
          keys['vdebito'] = u;
        }
      }

      let r10 = {};

      for (let i = 9; i < 69; i++) {
        let x = this.getJsDateFromExcel(template.data[i][0]).split('/');
        r10[x[1] + '/' + x[2]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = tmp.data[u][keys['mofg']].substr(-2) + '/' + tmp.data[u][keys['mofg']].substr(0, 4);
        if (r10[x]) {
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "8109") {
            r10[x][0] = r10[x][0] + tmp.data[u][keys['vdebito']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "2172") {
            r10[x][1] = r10[x][1] + tmp.data[u][keys['vdebito']].fix();
          }
        }
      }

      for (let i = 9; i < 69; i++) {
        let x: any = this.getJsDateFromExcel(template.data[i][0]).split('/');
        x = x[1] + '/' + x[2];
        if (r10[x]) {
          template.data[i][1] = r10[x][0].two();
          template.data[i][11] = r10[x][1].two();
        }
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'DCTF - R11');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "MOFG - Mês de Ocorrência do Fato Gerador") {
          keys['mofg'] = u;
        }
        if (tmp.columns[u].title === "Código da Receita") {
          keys['cod_receita'] = u;
        }
        if (tmp.columns[u].title === "Valor do Principal") {
          keys['vprincipal'] = u;
        }
      }

      let r11 = {};

      for (let i = 9; i < 69; i++) {
        let x = this.getJsDateFromExcel(template.data[i][0]).split('/');
        r11[x[1] + '/' + x[2]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = tmp.data[u][keys['mofg']].substr(-2) + '/' + tmp.data[u][keys['mofg']].substr(0, 4);
        if (r11[x]) {
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "8109") {
            r11[x][0] = r11[x][0] + tmp.data[u][keys['vprincipal']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "2172") {
            r11[x][1] = r11[x][1] + tmp.data[u][keys['vprincipal']].fix();
          }
        }
      }

      for (let i = 9; i < 69; i++) {
        let x: any = this.getJsDateFromExcel(template.data[i][0]).split('/');
        x = x[1] + '/' + x[2];
        if (r11[x]) {
          template.data[i][2] = r11[x][0].two();
          template.data[i][12] = r11[x][1].two();
        }
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'DCTF - R12');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "MOFG - Mês de Ocorrência do Fato Gerador") {
          keys['mofg'] = u;
        }
        if (tmp.columns[u].title === "Código da Receita") {
          keys['cod_receita'] = u;
        }
        if (tmp.columns[u].title === "Valor Compensado do Débito") {
          keys['vcompensado'] = u;
        }
      }

      let r12 = {};

      for (let i = 9; i < 69; i++) {
        let x = this.getJsDateFromExcel(template.data[i][0]).split('/');
        r12[x[1] + '/' + x[2]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = tmp.data[u][keys['mofg']].substr(-2) + '/' + tmp.data[u][keys['mofg']].substr(0, 4);
        if (r12[x]) {
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "8109") {
            r12[x][0] = r12[x][0] + tmp.data[u][keys['vcompensado']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "2172") {
            r12[x][1] = r12[x][1] + tmp.data[u][keys['vcompensado']].fix();
          }
        }
      }

      for (let i = 9; i < 69; i++) {
        let x: any = this.getJsDateFromExcel(template.data[i][0]).split('/');
        x = x[1] + '/' + x[2];
        if (r12[x]) {
          template.data[i][3] = r12[x][0].two();
          template.data[i][13] = r12[x][1].two();
        }
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'DCTF - R14');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "MOFG - Mês de Ocorrência do Fato Gerador") {
          keys['mofg'] = u;
        }
        if (tmp.columns[u].title === "Código da Receita") {
          if (keys['cod_receita'] === undefined) {
            keys['cod_receita'] = u;
          }
        }
        if (tmp.columns[u].title === "Valor Suspenso do Débito") {
          keys['vsuspenso'] = u;
        }
      }

      let r14 = {};

      for (let i = 9; i < 69; i++) {
        let x = this.getJsDateFromExcel(template.data[i][0]).split('/');
        r14[x[1] + '/' + x[2]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = tmp.data[u][keys['mofg']].substr(-2) + '/' + tmp.data[u][keys['mofg']].substr(0, 4);
        if (r14[x]) {
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "8109") {
            r14[x][0] = r14[x][0] + tmp.data[u][keys['vsuspenso']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "2172") {
            r14[x][1] = r14[x][1] + tmp.data[u][keys['vsuspenso']].fix();
          }
        }
      }

      for (let i = 9; i < 69; i++) {
        let x: any = this.getJsDateFromExcel(template.data[i][0]).split('/');
        x = x[1] + '/' + x[2];
        if (r14[x]) {
          template.data[i][4] = r14[x][0].two();
          template.data[i][14] = r14[x][1].two();
        }
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F02 - DARFs');
    if (tmp !== undefined) {
      for (let i = 10; i < 70; i++) {
        template.data[i - 1][5] = tmp.data[i][1].two();
        template.data[i - 1][15] = tmp.data[i][3].two();
      }
    }

    for (let i = 9; i < 69; i++) {
      if (template.data[i][3].length === 0) {
        template.data[i][3] = 0;
      }
      if (template.data[i][4].length === 0) {
        template.data[i][4] = 0;
      }
      if (template.data[i][13].length === 0) {
        template.data[i][13] = 0;
      }
      if (template.data[i][14].length === 0) {
        template.data[i][14] = 0;
      }
    }

    return JSON.parse(JSON.stringify(template).replace(/#2e3757/g, configuracoes.data.toString()));
  }

  F03B(template: any, dashData: any, configuracoes: any): any {
    template.data[1][1] = configuracoes.header;
    template.data[70][1] = configuracoes.footer;

    const prescricional = this.getPrescricional();
    for (let i = 9; i < 69; i++) {
      template.data[i][0] = this.JSDateToExcelDate(prescricional[i - 9]);
      template.data[i][10] = this.JSDateToExcelDate(prescricional[i - 9]);
    }

    let keys: any = {};
    let tmp = dashData.find(element => element.worksheetName === 'DCTF - R10');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "MOFG - Mês de Ocorrência do Fato Gerador") {
          keys['mofg'] = u;
        }
        if (tmp.columns[u].title === "Código da Receita") {
          keys['cod_receita'] = u;
        }
        if (tmp.columns[u].title === "Valor do Débito") {
          keys['vdebito'] = u;
        }
      }

      let r10 = {};

      for (let i = 9; i < 69; i++) {
        let x = this.getJsDateFromExcel(template.data[i][0]).split('/');
        r10[x[1] + '/' + x[2]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = tmp.data[u][keys['mofg']].substr(-2) + '/' + tmp.data[u][keys['mofg']].substr(0, 4);
        if (r10[x]) {
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "6912") {
            r10[x][0] = r10[x][0] + tmp.data[u][keys['vdebito']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "5856") {
            r10[x][1] = r10[x][1] + tmp.data[u][keys['vdebito']].fix();
          }
        }
      }

      for (let i = 9; i < 69; i++) {
        let x: any = this.getJsDateFromExcel(template.data[i][0]).split('/');
        x = x[1] + '/' + x[2];
        if (r10[x]) {
          template.data[i][1] = r10[x][0].two();
          template.data[i][11] = r10[x][1].two();
        }
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'DCTF - R11');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "MOFG - Mês de Ocorrência do Fato Gerador") {
          keys['mofg'] = u;
        }
        if (tmp.columns[u].title === "Código da Receita") {
          keys['cod_receita'] = u;
        }
        if (tmp.columns[u].title === "Valor do Principal") {
          keys['vprincipal'] = u;
        }
      }

      let r11 = {};

      for (let i = 9; i < 69; i++) {
        let x = this.getJsDateFromExcel(template.data[i][0]).split('/');
        r11[x[1] + '/' + x[2]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = tmp.data[u][keys['mofg']].substr(-2) + '/' + tmp.data[u][keys['mofg']].substr(0, 4);
        if (r11[x]) {
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "6912") {
            r11[x][0] = r11[x][0] + tmp.data[u][keys['vprincipal']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "5856") {
            r11[x][1] = r11[x][1] + tmp.data[u][keys['vprincipal']].fix();
          }
        }
      }

      for (let i = 9; i < 69; i++) {
        let x: any = this.getJsDateFromExcel(template.data[i][0]).split('/');
        x = x[1] + '/' + x[2];
        if (r11[x]) {
          template.data[i][2] = r11[x][0].two();
          template.data[i][12] = r11[x][1].two();
        }
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'DCTF - R12');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "MOFG - Mês de Ocorrência do Fato Gerador") {
          keys['mofg'] = u;
        }
        if (tmp.columns[u].title === "Código da Receita") {
          keys['cod_receita'] = u;
        }
        if (tmp.columns[u].title === "Valor Compensado do Débito") {
          keys['vcompensado'] = u;
        }
      }

      let r12 = {};

      for (let i = 9; i < 69; i++) {
        let x = this.getJsDateFromExcel(template.data[i][0]).split('/');
        r12[x[1] + '/' + x[2]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = tmp.data[u][keys['mofg']].substr(-2) + '/' + tmp.data[u][keys['mofg']].substr(0, 4);
        if (r12[x]) {
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "6912") {
            r12[x][0] = r12[x][0] + tmp.data[u][keys['vcompensado']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "5856") {
            r12[x][1] = r12[x][1] + tmp.data[u][keys['vcompensado']].fix();
          }
        }
      }

      for (let i = 9; i < 69; i++) {
        let x: any = this.getJsDateFromExcel(template.data[i][0]).split('/');
        x = x[1] + '/' + x[2];
        if (r12[x]) {
          template.data[i][3] = r12[x][0].two();
          template.data[i][13] = r12[x][1].two();
        }
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'DCTF - R14');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "MOFG - Mês de Ocorrência do Fato Gerador") {
          keys['mofg'] = u;
        }
        if (tmp.columns[u].title === "Código da Receita") {
          if (keys['cod_receita'] === undefined) {
            keys['cod_receita'] = u;
          }
        }
        if (tmp.columns[u].title === "Valor Suspenso do Débito") {
          keys['vsuspenso'] = u;
        }
      }

      let r14 = {};

      for (let i = 9; i < 69; i++) {
        let x = this.getJsDateFromExcel(template.data[i][0]).split('/');
        r14[x[1] + '/' + x[2]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = tmp.data[u][keys['mofg']].substr(-2) + '/' + tmp.data[u][keys['mofg']].substr(0, 4);
        if (r14[x]) {
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "6912") {
            r14[x][0] = r14[x][0] + tmp.data[u][keys['vsuspenso']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "5856") {
            r14[x][1] = r14[x][1] + tmp.data[u][keys['vsuspenso']].fix();
          }
        }
      }

      for (let i = 9; i < 69; i++) {
        let x: any = this.getJsDateFromExcel(template.data[i][0]).split('/');
        x = x[1] + '/' + x[2];
        if (r14[x]) {
          template.data[i][4] = r14[x][0].two();
          template.data[i][14] = r14[x][1].two();
        }
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F02 - DARFs');
    if (tmp !== undefined) {
      for (let i = 10; i < 70; i++) {
        template.data[i - 1][5] = tmp.data[i][5].two();
        template.data[i - 1][15] = tmp.data[i][7].two();
      }
    }

    for (let i = 9; i < 69; i++) {
      if (template.data[i][3].length === 0) {
        template.data[i][3] = 0;
      }
      if (template.data[i][4].length === 0) {
        template.data[i][4] = 0;
      }
      if (template.data[i][13].length === 0) {
        template.data[i][13] = 0;
      }
      if (template.data[i][14].length === 0) {
        template.data[i][14] = 0;
      }
    }

    return JSON.parse(JSON.stringify(template).replace(/#2e3757/g, configuracoes.data.toString()));
  }

  F04A(template: any, dashData: any, configuracoes: any): any {
    const trimestres = this.getTrimestres();
    for (let i = 9; i < 29; i++) {
      template.data[i][0] = trimestres[i - 9];
      template.data[i + 24][0] = trimestres[i - 9];
    }
    let keys: any = {};
    let tmp = dashData.find(element => element.worksheetName === 'DCTF - R10');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "MOFG - Mês de Ocorrência do Fato Gerador") {
          keys['mofg'] = u;
        }
        if (tmp.columns[u].title === "Código da Receita") {
          keys['cod_receita'] = u;
        }
        if (tmp.columns[u].title === "Valor do Débito") {
          keys['vdebito'] = u;
        }
      }

      let r10 = {};

      for (let i = 9; i < 29; i++) {
        r10[template.data[i][0]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = Math.ceil(Number(tmp.data[u][keys['mofg']].substr(-2)) / 3).toString()
        x = x + '° T. ' + tmp.data[u][keys['mofg']].substr(0, 4);
        if (r10[x]) {
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "2089") {
            r10[x][0] = r10[x][0] + tmp.data[u][keys['vdebito']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "2372") {
            r10[x][1] = r10[x][1] + tmp.data[u][keys['vdebito']].fix();
          }
        }
      }

      for (let i = 9; i < 29; i++) {
        let x = template.data[i][0]
        if (r10[x]) {
          template.data[i][1] = r10[x][0].two();
          template.data[i + 24][1] = r10[x][1].two();
        }
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'DCTF - R11');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "MOFG - Mês de Ocorrência do Fato Gerador") {
          keys['mofg'] = u;
        }
        if (tmp.columns[u].title === "Código da Receita") {
          keys['cod_receita'] = u;
        }
        if (tmp.columns[u].title === "Valor do Principal") {
          keys['vprincipal'] = u;
        }
      }

      let r11 = {};

      for (let i = 9; i < 29; i++) {
        r11[template.data[i][0]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = Math.ceil(Number(tmp.data[u][keys['mofg']].substr(-2)) / 3).toString()
        x = x + '° T. ' + tmp.data[u][keys['mofg']].substr(0, 4);
        if (r11[x]) {
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "2089") {
            r11[x][0] = r11[x][0] + tmp.data[u][keys['vprincipal']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "2372") {
            r11[x][1] = r11[x][1] + tmp.data[u][keys['vprincipal']].fix();
          }
        }
      }

      for (let i = 9; i < 29; i++) {
        let x = template.data[i][0]
        if (r11[x]) {
          template.data[i][2] = r11[x][0].two();
          template.data[i + 24][2] = r11[x][1].two();
        }
      }
    }
    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'DCTF - R31');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "Ano do Período de Apuração") {
          keys['ano'] = u;
        }
        if (tmp.columns[u].title === "Trimestre do Período de Apuração") {
          keys['tri'] = u;
        }
        if (tmp.columns[u].title === "Código da Receita") {
          keys['cod_receita'] = u;
        }
        if (tmp.columns[u].title === "Valor pago da Quota") {
          keys['vprincipal'] = u;
        }
      }

      let r31 = {};

      for (let i = 9; i < 29; i++) {
        r31[template.data[i][0]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = tmp.data[u][keys['tri']].substr(1, 1) + '° T. ' + tmp.data[u][keys['ano']]
        if (r31[x]) {
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "2089") {
            r31[x][0] = r31[x][0] + tmp.data[u][keys['vprincipal']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "2372") {
            r31[x][1] = r31[x][1] + tmp.data[u][keys['vprincipal']].fix();
          }
        }
      }

      for (let i = 9; i < 29; i++) {
        let x = template.data[i][0]
        if (r31[x]) {
          let _tmp = template.data[i][2].fix();
          template.data[i][2] = (_tmp + r31[x][0]).two();
          _tmp = template.data[i + 24][2].fix();
          template.data[i + 24][2] = (_tmp + r31[x][1]).two();
        }
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'DCTF - R12');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "MOFG - Mês de Ocorrência do Fato Gerador") {
          keys['mofg'] = u;
        }
        if (tmp.columns[u].title === "Código da Receita") {
          keys['cod_receita'] = u;
        }
        if (tmp.columns[u].title === "Valor Compensado do Débito") {
          keys['vcompensado'] = u;
        }
      }

      let r12 = {};

      for (let i = 9; i < 29; i++) {
        r12[template.data[i][0]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = Math.ceil(Number(tmp.data[u][keys['mofg']].substr(-2)) / 3).toString()
        x = x + '° T. ' + tmp.data[u][keys['mofg']].substr(0, 4);
        if (r12[x]) {
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "2089") {
            r12[x][0] = r12[x][0] + tmp.data[u][keys['vcompensado']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "2372") {
            r12[x][1] = r12[x][1] + tmp.data[u][keys['vcompensado']].fix();
          }
        }
      }

      for (let i = 9; i < 29; i++) {
        let x = template.data[i][0]
        if (r12[x]) {
          template.data[i][3] = r12[x][0].two();
          template.data[i + 24][3] = r12[x][1].two();
        }
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'DCTF - R32');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "Ano do Período de Apuração") {
          keys['ano'] = u;
        }
        if (tmp.columns[u].title === "Trimestre do Período de Apuração") {
          keys['tri'] = u;
        }
        if (tmp.columns[u].title === "Código da Receita") {
          keys['cod_receita'] = u;
        }
        if (tmp.columns[u].title === "Valor Compensado da Quota") {
          keys['vprincipal'] = u;
        }
      }

      let r32 = {};

      for (let i = 9; i < 29; i++) {
        r32[template.data[i][0]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = tmp.data[u][keys['tri']].substr(1, 1) + '° T. ' + tmp.data[u][keys['ano']]
        if (r32[x]) {
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "2089") {
            r32[x][0] = r32[x][0] + tmp.data[u][keys['vprincipal']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "2372") {
            r32[x][1] = r32[x][1] + tmp.data[u][keys['vprincipal']].fix();
          }
        }
      }

      for (let i = 9; i < 29; i++) {
        let x = template.data[i][0]
        if (r32[x]) {
          let _tmp = template.data[i][3].fix();
          template.data[i][3] = (_tmp + r32[x][0]).two();
          _tmp = template.data[i + 24][3].fix();
          template.data[i + 24][3] = (_tmp + r32[x][1]).two();
        }
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'DCTF - R14');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "MOFG - Mês de Ocorrência do Fato Gerador") {
          keys['mofg'] = u;
        }
        if (tmp.columns[u].title === "Código da Receita") {
          if (keys['cod_receita'] === undefined) {
            keys['cod_receita'] = u;
          }
        }
        if (tmp.columns[u].title === "Valor Suspenso do Débito") {
          keys['vsuspenso'] = u;
        }
      }

      let r14 = {};

      for (let i = 9; i < 29; i++) {
        r14[template.data[i][0]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = Math.ceil(Number(tmp.data[u][keys['mofg']].substr(-2)) / 3).toString()
        x = x + '° T. ' + tmp.data[u][keys['mofg']].substr(0, 4);
        if (r14[x]) {
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "2089") {
            r14[x][0] = r14[x][0] + tmp.data[u][keys['vsuspenso']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "2372") {
            r14[x][1] = r14[x][1] + tmp.data[u][keys['vsuspenso']].fix();
          }
        }
      }

      for (let i = 9; i < 29; i++) {
        let x = template.data[i][0]
        if (r14[x]) {
          template.data[i][4] = r14[x][0].two();
          template.data[i + 24][4] = r14[x][1].two();
        }
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F02 - DARFs');
    if (tmp !== undefined) {
      for (let i = 10; i < 30; i++) {
        template.data[i - 1][5] = tmp.data[i][17];
        template.data[i + 23][5] = tmp.data[i][19];
      }
    }

    for (let i = 9; i < 29; i++) {
      if (template.data[i][3].length === 0) {
        template.data[i][3] = 0;
      }
      if (template.data[i][4].length === 0) {
        template.data[i][4] = 0;
      }
      if (template.data[i + 24][3].length === 0) {
        template.data[i + 24][3] = 0;
      }
      if (template.data[i + 24][4].length === 0) {
        template.data[i + 24][4] = 0;
      }
    }

    template.data[1][1] = configuracoes.header;
    template.data[54][1] = configuracoes.footer;

    return JSON.parse(JSON.stringify(template).replace(/#2e3757/g, configuracoes.data.toString()));
  }

  F04B(template: any, dashData: any, configuracoes: any): any {
    const trimestres = this.getTrimestres();
    for (let i = 9; i < 29; i++) {
      template.data[i][0] = trimestres[i - 9];
      template.data[i + 24][0] = trimestres[i - 9];
    }
    let keys: any = {};
    let tmp = dashData.find(element => element.worksheetName === 'DCTF - R10');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "MOFG - Mês de Ocorrência do Fato Gerador") {
          keys['mofg'] = u;
        }
        if (tmp.columns[u].title === "Código da Receita") {
          keys['cod_receita'] = u;
        }
        if (tmp.columns[u].title === "Valor do Débito") {
          keys['vdebito'] = u;
        }
      }

      let r10 = {};

      for (let i = 9; i < 29; i++) {
        r10[template.data[i][0]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = Math.ceil(Number(tmp.data[u][keys['mofg']].substr(-2)) / 3).toString()
        x = x + '° T. ' + tmp.data[u][keys['mofg']].substr(0, 4);
        if (r10[x]) {
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "0220") {
            r10[x][0] = r10[x][0] + tmp.data[u][keys['vdebito']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "3373") {
            r10[x][0] = r10[x][0] + tmp.data[u][keys['vdebito']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "6012") {
            r10[x][1] = r10[x][1] + tmp.data[u][keys['vdebito']].fix();
          }
        }
      }

      for (let i = 9; i < 29; i++) {
        let x = template.data[i][0]
        if (r10[x]) {
          template.data[i][1] = r10[x][0].two();
          template.data[i + 24][1] = r10[x][1].two();
        }
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'DCTF - R11');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "MOFG - Mês de Ocorrência do Fato Gerador") {
          keys['mofg'] = u;
        }
        if (tmp.columns[u].title === "Código da Receita") {
          keys['cod_receita'] = u;
        }
        if (tmp.columns[u].title === "Valor do Principal") {
          keys['vprincipal'] = u;
        }
      }

      let r11 = {};

      for (let i = 9; i < 29; i++) {
        r11[template.data[i][0]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = Math.ceil(Number(tmp.data[u][keys['mofg']].substr(-2)) / 3).toString()
        x = x + '° T. ' + tmp.data[u][keys['mofg']].substr(0, 4);
        if (r11[x]) {
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "0220") {
            r11[x][0] = r11[x][0] + tmp.data[u][keys['vprincipal']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "3373") {
            r11[x][0] = r11[x][0] + tmp.data[u][keys['vprincipal']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "6012") {
            r11[x][1] = r11[x][1] + tmp.data[u][keys['vprincipal']].fix();
          }
        }
      }

      for (let i = 9; i < 29; i++) {
        let x = template.data[i][0]
        if (r11[x]) {
          template.data[i][2] = r11[x][0].two();
          template.data[i + 24][2] = r11[x][1].two();
        }
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'DCTF - R31');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "Ano do Período de Apuração") {
          keys['ano'] = u;
        }
        if (tmp.columns[u].title === "Trimestre do Período de Apuração") {
          keys['tri'] = u;
        }
        if (tmp.columns[u].title === "Código da Receita") {
          keys['cod_receita'] = u;
        }
        if (tmp.columns[u].title === "Valor pago da Quota") {
          keys['vprincipal'] = u;
        }
      }

      let r31 = {};

      for (let i = 9; i < 29; i++) {
        r31[template.data[i][0]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = tmp.data[u][keys['tri']].substr(1, 1) + '° T. ' + tmp.data[u][keys['ano']]
        if (r31[x]) {
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "0220") {
            r31[x][0] = r31[x][0] + tmp.data[u][keys['vprincipal']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "3373") {
            r31[x][0] = r31[x][0] + tmp.data[u][keys['vprincipal']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "6012") {
            r31[x][1] = r31[x][1] + tmp.data[u][keys['vprincipal']].fix();
          }
        }
      }

      for (let i = 9; i < 29; i++) {
        let x = template.data[i][0]
        if (r31[x]) {
          let _tmp = template.data[i][2].fix();
          template.data[i][2] = (_tmp + r31[x][0]).two();
          _tmp = template.data[i + 24][2].fix();
          template.data[i + 24][2] = (_tmp + r31[x][1]).two();
        }
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'DCTF - R12');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "MOFG - Mês de Ocorrência do Fato Gerador") {
          keys['mofg'] = u;
        }
        if (tmp.columns[u].title === "Código da Receita") {
          keys['cod_receita'] = u;
        }
        if (tmp.columns[u].title === "Valor Compensado do Débito") {
          keys['vcompensado'] = u;
        }
      }

      let r12 = {};

      for (let i = 9; i < 29; i++) {
        r12[template.data[i][0]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = Math.ceil(Number(tmp.data[u][keys['mofg']].substr(-2)) / 3).toString()
        x = x + '° T. ' + tmp.data[u][keys['mofg']].substr(0, 4);
        if (r12[x]) {
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "0220") {
            r12[x][0] = r12[x][0] + tmp.data[u][keys['vcompensado']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "3373") {
            r12[x][0] = r12[x][0] + tmp.data[u][keys['vcompensado']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "6012") {
            r12[x][1] = r12[x][1] + tmp.data[u][keys['vcompensado']].fix();
          }
        }
      }

      for (let i = 9; i < 29; i++) {
        let x = template.data[i][0]
        if (r12[x]) {
          template.data[i][3] = r12[x][0].two();
          template.data[i + 24][3] = r12[x][1].two();
        }
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'DCTF - R32');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "Ano do Período de Apuração") {
          keys['ano'] = u;
        }
        if (tmp.columns[u].title === "Trimestre do Período de Apuração") {
          keys['tri'] = u;
        }
        if (tmp.columns[u].title === "Código da Receita") {
          keys['cod_receita'] = u;
        }
        if (tmp.columns[u].title === "Valor Compensado da Quota") {
          keys['vprincipal'] = u;
        }
      }

      let r32 = {};

      for (let i = 9; i < 29; i++) {
        r32[template.data[i][0]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = tmp.data[u][keys['tri']].substr(1, 1) + '° T. ' + tmp.data[u][keys['ano']]
        if (r32[x]) {
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "0220") {
            r32[x][0] = r32[x][0] + tmp.data[u][keys['vprincipal']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "3373") {
            r32[x][0] = r32[x][0] + tmp.data[u][keys['vprincipal']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "6012") {
            r32[x][1] = r32[x][1] + tmp.data[u][keys['vprincipal']].fix();
          }
        }
      }

      for (let i = 9; i < 29; i++) {
        let x = template.data[i][0]
        if (r32[x]) {
          let _tmp = template.data[i][3].fix();
          template.data[i][3] = (_tmp + r32[x][0]).two();
          _tmp = template.data[i + 24][3].fix();
          template.data[i + 24][3] = (_tmp + r32[x][1]).two();
        }
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'DCTF - R14');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "MOFG - Mês de Ocorrência do Fato Gerador") {
          keys['mofg'] = u;
        }
        if (tmp.columns[u].title === "Código da Receita") {
          if (keys['cod_receita'] === undefined) {
            keys['cod_receita'] = u;
          }
        }
        if (tmp.columns[u].title === "Valor Suspenso do Débito") {
          keys['vsuspenso'] = u;
        }
      }

      let r14 = {};

      for (let i = 9; i < 29; i++) {
        r14[template.data[i][0]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = Math.ceil(Number(tmp.data[u][keys['mofg']].substr(-2)) / 3).toString()
        x = x + '° T. ' + tmp.data[u][keys['mofg']].substr(0, 4);
        if (r14[x]) {
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "0220") {
            r14[x][0] = r14[x][0] + tmp.data[u][keys['vsuspenso']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "3373") {
            r14[x][0] = r14[x][0] + tmp.data[u][keys['vsuspenso']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "6012") {
            r14[x][1] = r14[x][1] + tmp.data[u][keys['vsuspenso']].fix();
          }
        }
      }

      for (let i = 9; i < 29; i++) {
        let x = template.data[i][0]
        if (r14[x]) {
          template.data[i][4] = r14[x][0].two();
          template.data[i + 24][4] = r14[x][1].two();
        }
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F02 - DARFs');
    if (tmp !== undefined) {
      for (let i = 10; i < 30; i++) {
        template.data[i - 1][5] = tmp.data[i][23];
        template.data[i + 23][5] = tmp.data[i][25];
      }
    }

    for (let i = 9; i < 29; i++) {
      if (template.data[i][3].length === 0) {
        template.data[i][3] = 0;
      }
      if (template.data[i][4].length === 0) {
        template.data[i][4] = 0;
      }
      if (template.data[i + 24][3].length === 0) {
        template.data[i + 24][3] = 0;
      }
      if (template.data[i + 24][4].length === 0) {
        template.data[i + 24][4] = 0;
      }
    }

    template.data[1][1] = configuracoes.header;
    template.data[54][1] = configuracoes.footer;

    return JSON.parse(JSON.stringify(template).replace(/#2e3757/g, configuracoes.data.toString()));
  }

  F04C(template: any, dashData: any, configuracoes: any): any {
    const prescricional = this.getPrescricional();
    for (let i = 9; i < 69; i++) {
      template.data[i][0] = this.JSDateToExcelDate(prescricional[i - 9])
      template.data[i][10] = this.JSDateToExcelDate(prescricional[i - 9])
    }

    let keys: any = {};
    let tmp = dashData.find(element => element.worksheetName === 'DCTF - R10');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "MOFG - Mês de Ocorrência do Fato Gerador") {
          keys['mofg'] = u;
        }
        if (tmp.columns[u].title === "Código da Receita") {
          keys['cod_receita'] = u;
        }
        if (tmp.columns[u].title === "Valor do Débito") {
          keys['vdebito'] = u;
        }
      }

      let r10 = {};

      for (let i = 9; i < 69; i++) {
        let x = this.getJsDateFromExcel(template.data[i][0]);
        r10[x.split('/')[1] + '/' + x.split('/')[2]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = tmp.data[u][keys['mofg']].substr(0, 4);
        x = tmp.data[u][keys['mofg']].substr(-2) + '/' + x;
        if (r10[x]) {
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "2362") {
            r10[x][0] = r10[x][0] + tmp.data[u][keys['vdebito']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "5993") {
            r10[x][0] = r10[x][0] + tmp.data[u][keys['vdebito']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "2484") {
            r10[x][1] = r10[x][1] + tmp.data[u][keys['vdebito']].fix();
          }
        }
      }

      for (let i = 9; i < 69; i++) {
        let x = this.getJsDateFromExcel(template.data[i][0]);
        x = x.split('/')[1] + '/' + x.split('/')[2];
        if (r10[x]) {
          template.data[i][1] = r10[x][0].two();
          template.data[i][11] = r10[x][1].two();
        }
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'DCTF - R11');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "MOFG - Mês de Ocorrência do Fato Gerador") {
          keys['mofg'] = u;
        }
        if (tmp.columns[u].title === "Código da Receita") {
          keys['cod_receita'] = u;
        }
        if (tmp.columns[u].title === "Valor do Principal") {
          keys['vprincipal'] = u;
        }
      }

      let r11 = {};

      for (let i = 9; i < 69; i++) {
        let x = this.getJsDateFromExcel(template.data[i][0]);
        r11[x.split('/')[1] + '/' + x.split('/')[2]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = tmp.data[u][keys['mofg']].substr(0, 4);
        x = tmp.data[u][keys['mofg']].substr(-2) + '/' + x;
        if (r11[x]) {
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "2362") {
            r11[x][0] = r11[x][0] + tmp.data[u][keys['vprincipal']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "5993") {
            r11[x][0] = r11[x][0] + tmp.data[u][keys['vprincipal']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "2484") {
            r11[x][1] = r11[x][1] + tmp.data[u][keys['vprincipal']].fix();
          }
        }
      }

      for (let i = 9; i < 69; i++) {
        let x = this.getJsDateFromExcel(template.data[i][0]);
        x = x.split('/')[1] + '/' + x.split('/')[2];
        if (r11[x]) {
          template.data[i][2] = r11[x][0].two();
          template.data[i][12] = r11[x][1].two();
        }
      }
    }


    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'DCTF - R12');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "MOFG - Mês de Ocorrência do Fato Gerador") {
          keys['mofg'] = u;
        }
        if (tmp.columns[u].title === "Código da Receita") {
          keys['cod_receita'] = u;
        }
        if (tmp.columns[u].title === "Valor Compensado do Débito") {
          keys['vcompensado'] = u;
        }
      }

      let r12 = {};

      for (let i = 9; i < 69; i++) {
        let x = this.getJsDateFromExcel(template.data[i][0]);
        r12[x.split('/')[1] + '/' + x.split('/')[2]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = tmp.data[u][keys['mofg']].substr(0, 4);
        x = tmp.data[u][keys['mofg']].substr(-2) + '/' + x;
        if (r12[x]) {
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "2362") {
            r12[x][0] = r12[x][0] + tmp.data[u][keys['vcompensado']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "5993") {
            r12[x][0] = r12[x][0] + tmp.data[u][keys['vcompensado']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "2484") {
            r12[x][1] = r12[x][1] + tmp.data[u][keys['vcompensado']].fix();
          }
        }
      }

      for (let i = 9; i < 69; i++) {
        let x = this.getJsDateFromExcel(template.data[i][0]);
        x = x.split('/')[1] + '/' + x.split('/')[2];
        if (r12[x]) {
          template.data[i][3] = r12[x][0].two();
          template.data[i][13] = r12[x][1].two();
        }
      }
    } else {
      for (let i = 9; i < 69; i++) {
        template.data[i][3] = 0;
        template.data[i][13] = 0;
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'DCTF - R14');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "MOFG - Mês de Ocorrência do Fato Gerador") {
          keys['mofg'] = u;
        }
        if (tmp.columns[u].title === "Código da Receita") {
          if (keys['cod_receita'] === undefined) {
            keys['cod_receita'] = u;
          }
        }
        if (tmp.columns[u].title === "Valor Suspenso do Débito") {
          keys['vsuspenso'] = u;
        }
      }

      let r14 = {};

      for (let i = 9; i < 69; i++) {
        let x = this.getJsDateFromExcel(template.data[i][0]);
        r14[x.split('/')[1] + '/' + x.split('/')[2]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = tmp.data[u][keys['mofg']].substr(0, 4);
        x = tmp.data[u][keys['mofg']].substr(-2) + '/' + x;
        if (r14[x]) {
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "2362") {
            r14[x][0] = r14[x][0] + tmp.data[u][keys['vsuspenso']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "5993") {
            r14[x][0] = r14[x][0] + tmp.data[u][keys['vsuspenso']].fix();
          }
          if (tmp.data[u][keys['cod_receita']].substr(0, 4) === "2484") {
            r14[x][1] = r14[x][1] + tmp.data[u][keys['vsuspenso']].fix();
          }
        }
      }

      for (let i = 9; i < 69; i++) {
        let x = this.getJsDateFromExcel(template.data[i][0]);
        x = x.split('/')[1] + '/' + x.split('/')[2];
        if (r14[x]) {
          template.data[i][4] = r14[x][0].two();
          template.data[i][14] = r14[x][1].two();
        }
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F02 - DARFs');
    if (tmp !== undefined) {
      for (let i = 10; i < 70; i++) {
        template.data[i - 1][5] = tmp.data[i][11];
        template.data[i - 1][15] = tmp.data[i][13];
      }
    }

    for (let i = 9; i < 69; i++) {
      if (template.data[i][4].length === 0) {
        template.data[i][4] = 0;
      }
      if (template.data[i][14].length === 0) {
        template.data[i][14] = 0;
      }
    }

    template.data[1][1] = configuracoes.header;
    template.data[70][1] = configuracoes.footer;

    return JSON.parse(JSON.stringify(template).replace(/#2e3757/g, configuracoes.data.toString()));
  }

  F05A(template: any, dashData: any, configuracoes: any): any {
    const prescricional = this.getPrescricional();
    for (let i = 10; i < 70; i++) {
      template.data[i][0] = this.JSDateToExcelDate(prescricional[i - 10])
      template.data[i][20] = this.JSDateToExcelDate(prescricional[i - 10])
    }

    let research = ['EFD - M210', 'EFD - M215', 'EFD - M220', 'EFD - M225', 'EFD - M230']
    for (let current of research) {
      let keys: any = {};
      let tmp = dashData.find(element => element.worksheetName === current);
      if (tmp !== undefined) {
        for (let u = 0; u < tmp.columns.length; u++) {
          if (tmp.columns[u].title === "ID_DT_INI") {
            keys['periodo'] = u;
          }
          if (tmp.columns[u].title === "COD_CONT") {
            keys['cod'] = u;
          }
          if (tmp.columns[u].title === "ALIQ_PIS") {
            keys['aliq'] = u;
          }
          if (tmp.columns[u].title === "VL_BC_CONT") {
            keys['vl1'] = u;
          }
          if (tmp.columns[u].title === "VL_CONT_CUM_REC") {
            keys['vl2'] = u;
          }
          if (tmp.columns[u].title === "VL_RET_CUM") {
            keys['vl3'] = u;
          }
          if (tmp.columns[u].title === "VL_OUT_DED_CUM") {
            keys['vl4'] = u;
          }
          if (tmp.columns[u].title === "VL_AJUS_ACRES") {
            keys['vl5'] = u;
          }
          if (tmp.columns[u].title === "VL_AJUS_REDUC") {
            keys['vl6'] = u;
          }
          if (tmp.columns[u].title === "VL_CONT_DIFER") {
            keys['vl7'] = u;
          }
          if (tmp.columns[u].title === "VL_CONT_DIFER_ANT") {
            keys['vl8'] = u;
          }
          if (tmp.columns[u].title === "VL_AJUS_ACRES_BC_PIS") {
            keys['vl9'] = u;
          }
          if (tmp.columns[u].title === "VL_AJUS_REDUC_BC_PIS") {
            keys['vl10'] = u;
          }
        }

        let data = {};

        for (let i = 10; i < 70; i++) {
          data[this.getJsDateFromExcel(template.data[i][0])] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        }

        for (let u = 0; u < tmp.data.length; u++) {
          if (data[this.fromUS(tmp.data[u][keys['periodo']])]) {
            if (tmp.data[u][keys['cod']] === "51") {
              if (tmp.data[u][keys['aliq']].replace(",", ".").fix() === 0.65) {
                data[this.fromUS(tmp.data[u][keys['periodo']])][0] = tmp.data[u][keys['vl1']].fix();
                data[this.fromUS(tmp.data[u][keys['periodo']])][4] = tmp.data[u][keys['vl2']].fix();
                data[this.fromUS(tmp.data[u][keys['periodo']])][7] = tmp.data[u][keys['vl5']].fix();
                data[this.fromUS(tmp.data[u][keys['periodo']])][8] = tmp.data[u][keys['vl6']].fix();
                data[this.fromUS(tmp.data[u][keys['periodo']])][9] = tmp.data[u][keys['vl7']].fix();
                data[this.fromUS(tmp.data[u][keys['periodo']])][10] = tmp.data[u][keys['vl8']].fix();
                data[this.fromUS(tmp.data[u][keys['periodo']])][11] = tmp.data[u][keys['vl9']].fix();
                data[this.fromUS(tmp.data[u][keys['periodo']])][12] = tmp.data[u][keys['vl10']].fix();
              }
            }
            if (tmp.data[u][keys['cod']] === "52") {
              if (tmp.data[u][keys['aliq']].replace(",", ".").fix() === 0.65) {
                data[this.fromUS(tmp.data[u][keys['periodo']])][1] = tmp.data[u][keys['vl1']].fix();
              }
            }
            if (tmp.data[u][keys['cod']] === "53") {
              if (tmp.data[u][keys['aliq']].replace(",", ".").fix() === 0.65) {
                data[this.fromUS(tmp.data[u][keys['periodo']])][2] = tmp.data[u][keys['vl1']].fix();
              }
            }
            if (tmp.data[u][keys['cod']] === "54") {
              if (tmp.data[u][keys['aliq']].replace(",", ".").fix() === 0.65) {
                data[this.fromUS(tmp.data[u][keys['periodo']])][3] = tmp.data[u][keys['vl1']].fix();
              }
            }

            data[this.fromUS(tmp.data[u][keys['periodo']])][5] = tmp.data[u][keys['vl3']].fix()
            data[this.fromUS(tmp.data[u][keys['periodo']])][6] = tmp.data[u][keys['vl4']].fix();
          }
        }

        for (let i = 10; i < 70; i++) {
          if (data[this.getJsDateFromExcel(template.data[i][0])]) {
            data[this.getJsDateFromExcel(template.data[i][0])][0] > 0 ? template.data[i][1] = data[this.getJsDateFromExcel(template.data[i][0])][0].two() : null
            data[this.getJsDateFromExcel(template.data[i][0])][1] > 0 ? template.data[i][2] = data[this.getJsDateFromExcel(template.data[i][0])][1].two() : null
            data[this.getJsDateFromExcel(template.data[i][0])][2] > 0 ? template.data[i][3] = data[this.getJsDateFromExcel(template.data[i][0])][2].two() : null
            data[this.getJsDateFromExcel(template.data[i][0])][3] > 0 ? template.data[i][4] = data[this.getJsDateFromExcel(template.data[i][0])][3].two() : null
            data[this.getJsDateFromExcel(template.data[i][0])][4] > 0 ? template.data[i][5] = data[this.getJsDateFromExcel(template.data[i][0])][4].two() : null

            data[this.getJsDateFromExcel(template.data[i][0])][5] > 0 ? template.data[i][7] = data[this.getJsDateFromExcel(template.data[i][0])][5].two() : null
            data[this.getJsDateFromExcel(template.data[i][0])][6] > 0 ? template.data[i][8] = data[this.getJsDateFromExcel(template.data[i][0])][6].two() : null

            data[this.getJsDateFromExcel(template.data[i][0])][7] > 0 ? template.data[i][10] = data[this.getJsDateFromExcel(template.data[i][0])][7].two() : null
            data[this.getJsDateFromExcel(template.data[i][0])][8] > 0 ? template.data[i][11] = data[this.getJsDateFromExcel(template.data[i][0])][8].two() : null
            data[this.getJsDateFromExcel(template.data[i][0])][9] > 0 ? template.data[i][12] = data[this.getJsDateFromExcel(template.data[i][0])][9].two() : null
            data[this.getJsDateFromExcel(template.data[i][0])][10] > 0 ? template.data[i][13] = data[this.getJsDateFromExcel(template.data[i][0])][10].two() : null

            data[this.getJsDateFromExcel(template.data[i][0])][11] > 0 ? template.data[i][15] = data[this.getJsDateFromExcel(template.data[i][0])][11].two() : null
            data[this.getJsDateFromExcel(template.data[i][0])][12] > 0 ? template.data[i][16] = data[this.getJsDateFromExcel(template.data[i][0])][12].two() : null
          }
        }
      }
    }

    research = ['EFD - M610', 'EFD - M615', 'EFD - M620', 'EFD - M625', 'EFD - M630']
    for (let current of research) {
      let keys: any = {};
      let tmp = dashData.find(element => element.worksheetName === current);
      if (tmp !== undefined) {
        for (let u = 0; u < tmp.columns.length; u++) {
          if (tmp.columns[u].title === "ID_DT_INI") {
            keys['periodo'] = u;
          }
          if (tmp.columns[u].title === "COD_CONT") {
            keys['cod'] = u;
          }
          if (tmp.columns[u].title === "ALIQ_COFINS") {
            keys['aliq'] = u;
          }
          if (tmp.columns[u].title === "VL_BC_CONT") {
            keys['vl1'] = u;
          }
          if (tmp.columns[u].title === "VL_CONT_CUM_REC") {
            keys['vl2'] = u;
          }
          if (tmp.columns[u].title === "VL_RET_CUM") {
            keys['vl3'] = u;
          }
          if (tmp.columns[u].title === "VL_OUT_DED_CUM") {
            keys['vl4'] = u;
          }
          if (tmp.columns[u].title === "VL_AJUS_ACRES") {
            keys['vl5'] = u;
          }
          if (tmp.columns[u].title === "VL_AJUS_REDUC") {
            keys['vl6'] = u;
          }
          if (tmp.columns[u].title === "VL_CONT_DIFER") {
            keys['vl7'] = u;
          }
          if (tmp.columns[u].title === "VL_CONT_DIFER_ANT") {
            keys['vl8'] = u;
          }
          if (tmp.columns[u].title === "VL_AJUS_ACRES_BC_COFINS") {
            keys['vl9'] = u;
          }
          if (tmp.columns[u].title === "VL_AJUS_REDUC_BC_COFINS") {
            keys['vl10'] = u;
          }
        }

        let data = {};

        for (let i = 10; i < 70; i++) {
          data[this.getJsDateFromExcel(template.data[i][0])] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        }

        for (let u = 0; u < tmp.data.length; u++) {
          if (data[this.fromUS(tmp.data[u][keys['periodo']])]) {
            if (tmp.data[u][keys['cod']] === "51") {
              if (tmp.data[u][keys['aliq']].replace(",", ".").fix() === 3) {
                data[this.fromUS(tmp.data[u][keys['periodo']])][0] = tmp.data[u][keys['vl1']].fix();
                data[this.fromUS(tmp.data[u][keys['periodo']])][4] = tmp.data[u][keys['vl2']].fix();
                data[this.fromUS(tmp.data[u][keys['periodo']])][7] = tmp.data[u][keys['vl5']].fix();
                data[this.fromUS(tmp.data[u][keys['periodo']])][8] = tmp.data[u][keys['vl6']].fix();
                data[this.fromUS(tmp.data[u][keys['periodo']])][9] = tmp.data[u][keys['vl7']].fix();
                data[this.fromUS(tmp.data[u][keys['periodo']])][10] = tmp.data[u][keys['vl8']].fix();
                data[this.fromUS(tmp.data[u][keys['periodo']])][11] = tmp.data[u][keys['vl9']].fix();
                data[this.fromUS(tmp.data[u][keys['periodo']])][12] = tmp.data[u][keys['vl10']].fix();
              }
            }
            if (tmp.data[u][keys['cod']] === "52") {
              if (tmp.data[u][keys['aliq']].replace(",", ".").fix() === 3) {
                data[this.fromUS(tmp.data[u][keys['periodo']])][1] = tmp.data[u][keys['vl1']].fix();
              }
            }
            if (tmp.data[u][keys['cod']] === "53") {
              if (tmp.data[u][keys['aliq']].replace(",", ".").fix() === 3) {
                data[this.fromUS(tmp.data[u][keys['periodo']])][2] = tmp.data[u][keys['vl1']].fix();
              }
            }
            if (tmp.data[u][keys['cod']] === "54") {
              if (tmp.data[u][keys['aliq']].replace(",", ".").fix() === 3) {
                data[this.fromUS(tmp.data[u][keys['periodo']])][3] = tmp.data[u][keys['vl1']].fix();
              }
            }

            data[this.fromUS(tmp.data[u][keys['periodo']])][5] = tmp.data[u][keys['vl3']].fix()
            data[this.fromUS(tmp.data[u][keys['periodo']])][6] = tmp.data[u][keys['vl4']].fix();
          }
        }

        for (let i = 10; i < 70; i++) {
          if (data[this.getJsDateFromExcel(template.data[i][0])]) {
            data[this.getJsDateFromExcel(template.data[i][0])][0] > 0 ? template.data[i][21] = data[this.getJsDateFromExcel(template.data[i][0])][0].two() : null
            data[this.getJsDateFromExcel(template.data[i][0])][1] > 0 ? template.data[i][22] = data[this.getJsDateFromExcel(template.data[i][0])][1].two() : null
            data[this.getJsDateFromExcel(template.data[i][0])][2] > 0 ? template.data[i][23] = data[this.getJsDateFromExcel(template.data[i][0])][2].two() : null
            data[this.getJsDateFromExcel(template.data[i][0])][3] > 0 ? template.data[i][24] = data[this.getJsDateFromExcel(template.data[i][0])][3].two() : null
            data[this.getJsDateFromExcel(template.data[i][0])][4] > 0 ? template.data[i][25] = data[this.getJsDateFromExcel(template.data[i][0])][4].two() : null

            data[this.getJsDateFromExcel(template.data[i][0])][5] > 0 ? template.data[i][27] = data[this.getJsDateFromExcel(template.data[i][0])][5].two() : null
            data[this.getJsDateFromExcel(template.data[i][0])][6] > 0 ? template.data[i][28] = data[this.getJsDateFromExcel(template.data[i][0])][6].two() : null

            data[this.getJsDateFromExcel(template.data[i][0])][7] > 0 ? template.data[i][30] = data[this.getJsDateFromExcel(template.data[i][0])][7].two() : null
            data[this.getJsDateFromExcel(template.data[i][0])][8] > 0 ? template.data[i][31] = data[this.getJsDateFromExcel(template.data[i][0])][8].two() : null
            data[this.getJsDateFromExcel(template.data[i][0])][9] > 0 ? template.data[i][32] = data[this.getJsDateFromExcel(template.data[i][0])][9].two() : null
            data[this.getJsDateFromExcel(template.data[i][0])][10] > 0 ? template.data[i][33] = data[this.getJsDateFromExcel(template.data[i][0])][10].two() : null

            data[this.getJsDateFromExcel(template.data[i][0])][11] > 0 ? template.data[i][35] = data[this.getJsDateFromExcel(template.data[i][0])][11].two() : null
            data[this.getJsDateFromExcel(template.data[i][0])][12] > 0 ? template.data[i][36] = data[this.getJsDateFromExcel(template.data[i][0])][12].two() : null
          }
        }
      }
    }

    for (let i = 10; i < 70; i++) {
      if (template.data[i][1].length === 0) {
        template.data[i][1] = 0;
      }
      if (template.data[i][2].length === 0) {
        template.data[i][2] = 0;
      }
      if (template.data[i][3].length === 0) {
        template.data[i][3] = 0;
      }
      if (template.data[i][4].length === 0) {
        template.data[i][4] = 0;
      }
      if (template.data[i][5].length === 0) {
        template.data[i][5] = 0;
      }

      if (template.data[i][7].length === 0) {
        template.data[i][7] = 0;
      }
      if (template.data[i][8].length === 0) {
        template.data[i][8] = 0;
      }

      if (template.data[i][10].length === 0) {
        template.data[i][10] = 0;
      }
      if (template.data[i][11].length === 0) {
        template.data[i][11] = 0;
      }
      if (template.data[i][12].length === 0) {
        template.data[i][12] = 0;
      }
      if (template.data[i][13].length === 0) {
        template.data[i][13] = 0;
      }

      if (template.data[i][15].length === 0) {
        template.data[i][15] = 0;
      }
      if (template.data[i][16].length === 0) {
        template.data[i][16] = 0;
      }

      if (template.data[i][21].length === 0) {
        template.data[i][21] = 0;
      }
      if (template.data[i][22].length === 0) {
        template.data[i][22] = 0;
      }
      if (template.data[i][23].length === 0) {
        template.data[i][23] = 0;
      }
      if (template.data[i][24].length === 0) {
        template.data[i][24] = 0;
      }
      if (template.data[i][25].length === 0) {
        template.data[i][25] = 0;
      }

      if (template.data[i][27].length === 0) {
        template.data[i][27] = 0;
      }
      if (template.data[i][28].length === 0) {
        template.data[i][28] = 0;
      }

      if (template.data[i][30].length === 0) {
        template.data[i][30] = 0;
      }
      if (template.data[i][31].length === 0) {
        template.data[i][31] = 0;
      }
      if (template.data[i][32].length === 0) {
        template.data[i][32] = 0;
      }
      if (template.data[i][33].length === 0) {
        template.data[i][33] = 0;
      }

      if (template.data[i][35].length === 0) {
        template.data[i][35] = 0;
      }
      if (template.data[i][36].length === 0) {
        template.data[i][36] = 0;
      }
    }

    template.data[1][1] = configuracoes.header;
    template.data[71][1] = configuracoes.footer;

    return JSON.parse(JSON.stringify(template).replace(/#2e3757/g, configuracoes.data.toString()));
  }

  F05B(template: any, dashData: any, configuracoes: any): any {
    const prescricional = this.getPrescricional();

    let pis_aliq: Array<string> = [];
    let cofins_aliq: Array<string> = [];
    for (let i = 10; i < 70; i++) {
      template.data[i][0] = this.JSDateToExcelDate(prescricional[i - 10])
      template.data[i][41] = this.JSDateToExcelDate(prescricional[i - 10])
    }

    let tmp_pis_aliq: Array<number> = [];
    let research = ['EFD - M210', 'EFD - M215', 'EFD - M220', 'EFD - M225', 'EFD - M230']
    aliquotas:
    for (let current of research) {
      let keys: any = {};
      let tmp = dashData.find(element => element.worksheetName === current);
      if (tmp !== undefined) {
        for (let u = 0; u < tmp.columns.length; u++) {
          if (tmp.columns[u].title === "COD_CONT") {
            keys['cod'] = u;
          }
          if (tmp.columns[u].title === "ALIQ_PIS") {
            keys['aliq'] = u;
          }
        }

        for (let u = 0; u < tmp.data.length; u++) {
          if (tmp_pis_aliq.length > 8) {
            break aliquotas;
          }
          if (tmp.data[u][keys['cod']] === "02") {
            let _tmp = tmp.data[u][keys['aliq']].replace(",", ".").fix();
            if (_tmp !== 0.65 && _tmp > 0) {
              if (tmp_pis_aliq.includes(_tmp) === false) {
                tmp_pis_aliq.push(_tmp);
              }
            }
          }
        }
      }
    }

    for (let i = 0; i < tmp_pis_aliq.length; i++) {
      template.data[9][i + 3] = tmp_pis_aliq[i].fix().two()
    }
    for (let i = 1; i < 12; i++) {
      if (template.data[9][i] !== 0) {
        pis_aliq.push(template.data[9][i].fix());
      }
    }

    for (let current of research) {
      let keys: any = {};
      let tmp = dashData.find(element => element.worksheetName === current);
      if (tmp !== undefined) {
        for (let u = 0; u < tmp.columns.length; u++) {
          if (tmp.columns[u].title === "ID_DT_INI") {
            keys['periodo'] = u;
          }
          if (tmp.columns[u].title === "COD_CONT") {
            keys['cod'] = u;
          }
          if (tmp.columns[u].title === "ALIQ_PIS") {
            keys['aliq'] = u;
          }
          if (tmp.columns[u].title === "VL_BC_CONT_AJUS") {
            keys['vl1'] = u;
          }
          if (tmp.columns[u].title === "VL_BC_CONT") {
            keys['vl1f'] = u;
          }
          if (tmp.columns[u].title === "VL_CONT_NC_REC") {
            keys['vl2'] = u;
          }
          if (tmp.columns[u].title === "VL_RET_NC") {
            keys['vl3'] = u;
          }
          if (tmp.columns[u].title === "VL_TOT_CRED_DESC_ANT") {
            keys['vl4'] = u;
          }
          if (tmp.columns[u].title === "VL_TOT_CRED_DESC") {
            keys['vl5'] = u;
          }
          if (tmp.columns[u].title === "VL_OUT_DED_NC") {
            keys['vl6'] = u;
          }
          if (tmp.columns[u].title === "VL_AJUS_ACRES") {
            keys['vl7'] = u;
          }
          if (tmp.columns[u].title === "VL_AJUS_REDUC") {
            keys['vl8'] = u;
          }
          if (tmp.columns[u].title === "VL_CONT_DIFER") {
            keys['vl9'] = u;
          }
          if (tmp.columns[u].title === "VL_CONT_DIFER_ANT") {
            keys['vl10'] = u;
          }
          if (tmp.columns[u].title === "VL_AJUS_ACRES_BC_PIS") {
            keys['vl11'] = u;
          }
          if (tmp.columns[u].title === "VL_AJUS_REDUC_BC_PIS") {
            keys['vl12'] = u;
          }
        }

        let data = {};

        for (let i = 10; i < 70; i++) {
          const aliq = new Array(pis_aliq.length).fill(0);
          data[this.getJsDateFromExcel(template.data[i][0])] = [aliq, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        }

        let repetidos: Array<string> = [];

        for (let u = 0; u < tmp.data.length; u++) {
          if (data[this.fromUS(tmp.data[u][keys['periodo']])]) {
            if (tmp.data[u][keys['cod']] === "01") {
              if (tmp.data[u][keys['aliq']].replace(',', '.').fix() === pis_aliq[0]) {
                let _tmp = tmp.data[u][keys['vl1']].fix();
                if (_tmp > 0) {
                  data[this.fromUS(tmp.data[u][keys['periodo']])][0][0] = _tmp
                } else {
                  _tmp = tmp.data[u][keys['vl1f']].fix();
                  if (_tmp > 0) {
                    data[this.fromUS(tmp.data[u][keys['periodo']])][0][0] = _tmp
                  }
                }
              }
            }

            if (tmp.data[u][keys['cod']] === "02") {
              for (let z = 1; z < pis_aliq.length; z++) {
                if (tmp.data[u][keys['aliq']].replace(',', '.').fix() === pis_aliq[z]) {
                  let _tmp = tmp.data[u][keys['vl1']].fix();
                  if (_tmp > 0) {
                    data[this.fromUS(tmp.data[u][keys['periodo']])][0][z] = _tmp
                  } else {
                    _tmp = tmp.data[u][keys['vl1f']].fix();
                    if (_tmp > 0) {
                      data[this.fromUS(tmp.data[u][keys['periodo']])][0][z] = _tmp
                    }
                  }
                  break;
                }
              }
            }

            data[this.fromUS(tmp.data[u][keys['periodo']])][1] = tmp.data[u][keys['vl2']].fix();
            data[this.fromUS(tmp.data[u][keys['periodo']])][2] = tmp.data[u][keys['vl3']].fix();
            data[this.fromUS(tmp.data[u][keys['periodo']])][3] = tmp.data[u][keys['vl4']].fix();
            data[this.fromUS(tmp.data[u][keys['periodo']])][4] = tmp.data[u][keys['vl5']].fix();
            data[this.fromUS(tmp.data[u][keys['periodo']])][5] = tmp.data[u][keys['vl6']].fix();

            if (repetidos.includes(this.fromUS(tmp.data[u][keys['periodo']]) + tmp.data[u][keys['cod']] + parseFloat(tmp.data[u][keys['aliq']].replace(',', '.')).toFixed(2)) === false) {
              repetidos.push(this.fromUS(tmp.data[u][keys['periodo']]) + tmp.data[u][keys['cod']] + parseFloat(tmp.data[u][keys['aliq']].replace(',', '.')).toFixed(2));

              for (let z = 0; z < pis_aliq.length; z++) {
                if (
                  (z === 0 && tmp.data[u][keys['cod']] === "01") ||
                  (z > 0 && tmp.data[u][keys['cod']] === "02")
                ) {
                  if (tmp.data[u][keys['aliq']].replace(',', '.').fix() === pis_aliq[z]) {
                    data[this.fromUS(tmp.data[u][keys['periodo']])][6] = data[this.fromUS(tmp.data[u][keys['periodo']])][6] + tmp.data[u][keys['vl7']].fix()
                  }
                  if (tmp.data[u][keys['aliq']].replace(',', '.').fix() === pis_aliq[z]) {
                    data[this.fromUS(tmp.data[u][keys['periodo']])][7] = data[this.fromUS(tmp.data[u][keys['periodo']])][7] + tmp.data[u][keys['vl8']].fix()
                  }
                  if (tmp.data[u][keys['aliq']].replace(',', '.').fix() === pis_aliq[z]) {
                    data[this.fromUS(tmp.data[u][keys['periodo']])][8] = data[this.fromUS(tmp.data[u][keys['periodo']])][8] + tmp.data[u][keys['vl9']].fix()
                  }
                  if (tmp.data[u][keys['aliq']].replace(',', '.').fix() === pis_aliq[z]) {
                    data[this.fromUS(tmp.data[u][keys['periodo']])][9] = data[this.fromUS(tmp.data[u][keys['periodo']])][9] + tmp.data[u][keys['vl10']].fix()
                  }
                  if (tmp.data[u][keys['aliq']].replace(',', '.').fix() === pis_aliq[z]) {
                    data[this.fromUS(tmp.data[u][keys['periodo']])][10] = data[this.fromUS(tmp.data[u][keys['periodo']])][10] + tmp.data[u][keys['vl11']].fix()
                  }
                  if (tmp.data[u][keys['aliq']].replace(',', '.').fix() === pis_aliq[z]) {
                    data[this.fromUS(tmp.data[u][keys['periodo']])][11] = data[this.fromUS(tmp.data[u][keys['periodo']])][11] + tmp.data[u][keys['vl12']].fix()
                  }
                }
              }
            }
          }
        }

        for (let i = 10; i < 70; i++) {
          if (data[this.getJsDateFromExcel(template.data[i][0])]) {
            for (let u = 0; u < data[this.getJsDateFromExcel(template.data[i][0])][0].length; u++) {
              if (data[this.getJsDateFromExcel(template.data[i][0])][0][u] > 0) {
                template.data[i][u + 1] = data[this.getJsDateFromExcel(template.data[i][0])][0][u].two()
              }
            }

            if (data[this.getJsDateFromExcel(template.data[i][0])][1] > 0)
              template.data[i][12] = data[this.getJsDateFromExcel(template.data[i][0])][1].two()
            if (data[this.getJsDateFromExcel(template.data[i][0])][2] > 0)
              template.data[i][14] = data[this.getJsDateFromExcel(template.data[i][0])][2].two()
            if (data[this.getJsDateFromExcel(template.data[i][0])][3] > 0)
              template.data[i][15] = data[this.getJsDateFromExcel(template.data[i][0])][3].two()
            if (data[this.getJsDateFromExcel(template.data[i][0])][4] > 0)
              template.data[i][16] = data[this.getJsDateFromExcel(template.data[i][0])][4].two()
            if (data[this.getJsDateFromExcel(template.data[i][0])][5] > 0)
              template.data[i][17] = data[this.getJsDateFromExcel(template.data[i][0])][5].two()

            if (data[this.getJsDateFromExcel(template.data[i][0])][6] > 0)
              template.data[i][19] = data[this.getJsDateFromExcel(template.data[i][0])][6].two()
            if (data[this.getJsDateFromExcel(template.data[i][0])][7] > 0)
              template.data[i][20] = data[this.getJsDateFromExcel(template.data[i][0])][7].two()
            if (data[this.getJsDateFromExcel(template.data[i][0])][8] > 0)
              template.data[i][21] = data[this.getJsDateFromExcel(template.data[i][0])][8].two()
            if (data[this.getJsDateFromExcel(template.data[i][0])][9] > 0)
              template.data[i][22] = data[this.getJsDateFromExcel(template.data[i][0])][9].two()
            if (data[this.getJsDateFromExcel(template.data[i][0])][10] > 0)
              template.data[i][32] = data[this.getJsDateFromExcel(template.data[i][0])][10].two()
            if (data[this.getJsDateFromExcel(template.data[i][0])][11] > 0)
              template.data[i][33] = data[this.getJsDateFromExcel(template.data[i][0])][11].two()
          }
        }
      }
    }

    let repetidos: Array<string> = [];

    let keys2: any = {};
    let tmp2 = dashData.find(element => element.worksheetName === 'EFD - M105');
    if (tmp2 !== undefined) {
      for (let u = 0; u < tmp2.columns.length; u++) {
        if (tmp2.columns[u].title === "ID_DT_INI") {
          keys2['periodo'] = u;
        }
        if (tmp2.columns[u].title === "CST_PIS") {
          keys2['cst'] = u;
        }
        if (tmp2.columns[u].title === "COD_CRED") {
          keys2['cc'] = u;
        }
        if (tmp2.columns[u].title === "ALIQ_PIS") {
          keys2['aliq'] = u;
        }
        if (tmp2.columns[u].title === "VL_CRED") {
          keys2['vl1'] = u;
        }
        if (tmp2.columns[u].title === "VL_AJUS_ACRES") {
          keys2['vl2'] = u;
        }
        if (tmp2.columns[u].title === "VL_AJUS_REDUC") {
          keys2['vl3'] = u;
        }
        if (tmp2.columns[u].title === "VL_CRED_DIF") {
          keys2['vl4'] = u;
        }
        if (tmp2.columns[u].title === "VL_CRED_DISP") {
          keys2['vl5'] = u;
        }
        if (tmp2.columns[u].title === "VL_CRED_DESC") {
          keys2['vl6'] = u;
        }
        if (tmp2.columns[u].title === "SLD_CRED") {
          keys2['vl7'] = u;
        }
      }

      let m105 = {};

      for (let i = 10; i < 70; i++) {
        m105[this.getJsDateFromExcel(template.data[i][0])] = [0, 0, 0, 0, 0, 0, 0];
      }

      for (let u = 0; u < tmp2.data.length; u++) {
        if (m105[this.fromUS(tmp2.data[u][keys2['periodo']])]) {
          if (repetidos.includes(this.fromUS(tmp2.data[u][keys2['periodo']]) + tmp2.data[u][keys2['aliq']].replace(',', '.').fix().toFixed(4) + tmp2.data[u][keys2['cc']]) === false) {
            repetidos.push(this.fromUS(tmp2.data[u][keys2['periodo']]) + tmp2.data[u][keys2['aliq']].replace(',', '.').fix().toFixed(4) + tmp2.data[u][keys2['cc']]);
            m105[this.fromUS(tmp2.data[u][keys2['periodo']])][0] = m105[this.fromUS(tmp2.data[u][keys2['periodo']])][0] + tmp2.data[u][keys2['vl1']].fix();
            m105[this.fromUS(tmp2.data[u][keys2['periodo']])][1] = m105[this.fromUS(tmp2.data[u][keys2['periodo']])][1] + tmp2.data[u][keys2['vl2']].fix();
            m105[this.fromUS(tmp2.data[u][keys2['periodo']])][2] = m105[this.fromUS(tmp2.data[u][keys2['periodo']])][2] + tmp2.data[u][keys2['vl3']].fix();
            m105[this.fromUS(tmp2.data[u][keys2['periodo']])][3] = m105[this.fromUS(tmp2.data[u][keys2['periodo']])][3] + tmp2.data[u][keys2['vl4']].fix();
            m105[this.fromUS(tmp2.data[u][keys2['periodo']])][4] = m105[this.fromUS(tmp2.data[u][keys2['periodo']])][4] + tmp2.data[u][keys2['vl5']].fix();
            m105[this.fromUS(tmp2.data[u][keys2['periodo']])][5] = m105[this.fromUS(tmp2.data[u][keys2['periodo']])][5] + tmp2.data[u][keys2['vl6']].fix();
            m105[this.fromUS(tmp2.data[u][keys2['periodo']])][6] = m105[this.fromUS(tmp2.data[u][keys2['periodo']])][6] + tmp2.data[u][keys2['vl7']].fix();
          }
        }
      }

      for (let i = 10; i < 70; i++) {
        if (m105[this.getJsDateFromExcel(template.data[i][0])]) {
          template.data[i][24] = m105[this.getJsDateFromExcel(template.data[i][0])][0].two();
          template.data[i][25] = m105[this.getJsDateFromExcel(template.data[i][0])][1].two();
          template.data[i][26] = m105[this.getJsDateFromExcel(template.data[i][0])][2].two();
          template.data[i][27] = m105[this.getJsDateFromExcel(template.data[i][0])][3].two();
          template.data[i][28] = m105[this.getJsDateFromExcel(template.data[i][0])][4].two();
          template.data[i][29] = m105[this.getJsDateFromExcel(template.data[i][0])][5].two();
          template.data[i][30] = m105[this.getJsDateFromExcel(template.data[i][0])][6].two();
        }
      }
    }

    keys2 = {}
    tmp2 = dashData.find(element => element.worksheetName === 'EFD - M100');
    if (tmp2 !== undefined) {
      for (let u = 0; u < tmp2.columns.length; u++) {
        if (tmp2.columns[u].title === "ID_DT_INI") {
          keys2['periodo'] = u;
        }
        if (tmp2.columns[u].title === "COD_CRED") {
          keys2['cc'] = u;
        }
        if (tmp2.columns[u].title === "ALIQ_PIS") {
          keys2['aliq'] = u;
        }
        if (tmp2.columns[u].title === "VL_CRED") {
          keys2['vl1'] = u;
        }
        if (tmp2.columns[u].title === "VL_AJUS_ACRES") {
          keys2['vl2'] = u;
        }
        if (tmp2.columns[u].title === "VL_AJUS_REDUC") {
          keys2['vl3'] = u;
        }
        if (tmp2.columns[u].title === "VL_CRED_DIF") {
          keys2['vl4'] = u;
        }
        if (tmp2.columns[u].title === "VL_CRED_DISP") {
          keys2['vl5'] = u;
        }
        if (tmp2.columns[u].title === "VL_CRED_DESC") {
          keys2['vl6'] = u;
        }
        if (tmp2.columns[u].title === "SLD_CRED") {
          keys2['vl7'] = u;
        }
      }

      let m100 = {};

      for (let i = 10; i < 70; i++) {
        m100[this.getJsDateFromExcel(template.data[i][0])] = [0, 0, 0, 0, 0, 0, 0];
      }

      for (let u = 0; u < tmp2.data.length; u++) {
        if (m100[this.fromUS(tmp2.data[u][keys2['periodo']])]) {
          const rep = this.fromUS(tmp2.data[u][keys2['periodo']]) + parseFloat(tmp2.data[u][keys2['aliq']].replace(',', '.')).toFixed(4) + tmp2.data[u][keys2['cc']];
          if (repetidos.includes(rep) === false) {
            repetidos.push(rep);
            m100[this.fromUS(tmp2.data[u][keys2['periodo']])][0] = m100[this.fromUS(tmp2.data[u][keys2['periodo']])][0] + tmp2.data[u][keys2['vl1']].fix();
            m100[this.fromUS(tmp2.data[u][keys2['periodo']])][1] = m100[this.fromUS(tmp2.data[u][keys2['periodo']])][1] + tmp2.data[u][keys2['vl2']].fix();
            m100[this.fromUS(tmp2.data[u][keys2['periodo']])][2] = m100[this.fromUS(tmp2.data[u][keys2['periodo']])][2] + tmp2.data[u][keys2['vl3']].fix();
            m100[this.fromUS(tmp2.data[u][keys2['periodo']])][3] = m100[this.fromUS(tmp2.data[u][keys2['periodo']])][3] + tmp2.data[u][keys2['vl4']].fix();
            m100[this.fromUS(tmp2.data[u][keys2['periodo']])][4] = m100[this.fromUS(tmp2.data[u][keys2['periodo']])][4] + tmp2.data[u][keys2['vl5']].fix();
            m100[this.fromUS(tmp2.data[u][keys2['periodo']])][5] = m100[this.fromUS(tmp2.data[u][keys2['periodo']])][5] + tmp2.data[u][keys2['vl6']].fix();
            m100[this.fromUS(tmp2.data[u][keys2['periodo']])][6] = m100[this.fromUS(tmp2.data[u][keys2['periodo']])][6] + tmp2.data[u][keys2['vl7']].fix();
          }
        }
      }

      for (let i = 10; i < 70; i++) {
        if (m100[this.getJsDateFromExcel(template.data[i][0])]) {
          template.data[i][24] = (m100[this.getJsDateFromExcel(template.data[i][0])][0] + template.data[i][24].fix()).two()
          template.data[i][25] = (m100[this.getJsDateFromExcel(template.data[i][0])][1] + template.data[i][25].fix()).two()
          template.data[i][26] = (m100[this.getJsDateFromExcel(template.data[i][0])][2] + template.data[i][26].fix()).two()
          template.data[i][27] = (m100[this.getJsDateFromExcel(template.data[i][0])][3] + template.data[i][27].fix()).two()
          template.data[i][28] = (m100[this.getJsDateFromExcel(template.data[i][0])][4] + template.data[i][28].fix()).two()
          template.data[i][29] = (m100[this.getJsDateFromExcel(template.data[i][0])][5] + template.data[i][29].fix()).two()
          template.data[i][30] = (m100[this.getJsDateFromExcel(template.data[i][0])][6] + template.data[i][30].fix()).two()
        }
      }
    }

    for (let i = 3; i < 12; i++) {
      if (template.data[9][i].fix() === 0) {
        template.columns[i].visible = false;
      }
    }

    //COFINS
    let tmp_cofins_aliq: Array<number> = [];
    research = ['EFD - M610', 'EFD - M615', 'EFD - M620', 'EFD - M625', 'EFD - M630']
    aliquotas2:
    for (let current of research) {
      let keys: any = {};
      let tmp = dashData.find(element => element.worksheetName === current);
      if (tmp !== undefined) {
        for (let u = 0; u < tmp.columns.length; u++) {
          if (tmp.columns[u].title === "COD_CONT") {
            keys['cod'] = u;
          }
          if (tmp.columns[u].title === "ALIQ_COFINS") {
            keys['aliq'] = u;
          }
        }

        for (let u = 0; u < tmp.data.length; u++) {
          if (tmp_cofins_aliq.length > 8) {
            break aliquotas2;
          }
          if (tmp.data[u][keys['cod']] === "02") {
            let _tmp = tmp.data[u][keys['aliq']].replace(",", ".").fix();
            if (_tmp !== 4 && _tmp > 0) {
              if (tmp_cofins_aliq.includes(_tmp) === false) {
                tmp_cofins_aliq.push(_tmp);
              }
            }
          }
        }
      }
    }
    for (let i = 0; i < tmp_cofins_aliq.length; i++) {
      template.data[9][i + 44] = tmp_cofins_aliq[i].fix().two()
    }
    for (let i = 42; i < 53; i++) {
      if (template.data[9][i] > 0) {
        cofins_aliq.push(template.data[9][i].fix());
      }
    }

    research = ['EFD - M610', 'EFD - M615', 'EFD - M620', 'EFD - M625', 'EFD - M630']
    for (let current of research) {
      let keys: any = {};
      let tmp = dashData.find(element => element.worksheetName === current);
      if (tmp !== undefined) {
        for (let u = 0; u < tmp.columns.length; u++) {
          if (tmp.columns[u].title === "ID_DT_INI") {
            keys['periodo'] = u;
          }
          if (tmp.columns[u].title === "COD_CONT") {
            keys['cod'] = u;
          }
          if (tmp.columns[u].title === "ALIQ_COFINS") {
            keys['aliq'] = u;
          }
          if (tmp.columns[u].title === "VL_BC_CONT_AJUS") {
            keys['vl1'] = u;
          }
          if (tmp.columns[u].title === "VL_BC_CONT") {
            keys['vl1f'] = u;
          }
          if (tmp.columns[u].title === "VL_CONT_NC_REC") {
            keys['vl2'] = u;
          }
          if (tmp.columns[u].title === "VL_RET_NC") {
            keys['vl3'] = u;
          }
          if (tmp.columns[u].title === "VL_TOT_CRED_DESC_ANT") {
            keys['vl4'] = u;
          }
          if (tmp.columns[u].title === "VL_TOT_CRED_DESC") {
            keys['vl5'] = u;
          }
          if (tmp.columns[u].title === "VL_OUT_DED_NC") {
            keys['vl6'] = u;
          }
          if (tmp.columns[u].title === "VL_AJUS_ACRES") {
            keys['vl7'] = u;
          }
          if (tmp.columns[u].title === "VL_AJUS_REDUC") {
            keys['vl8'] = u;
          }
          if (tmp.columns[u].title === "VL_CONT_DIFER") {
            keys['vl9'] = u;
          }
          if (tmp.columns[u].title === "VL_CONT_DIFER_ANT") {
            keys['vl10'] = u;
          }
          if (tmp.columns[u].title === "VL_AJUS_ACRES_BC_COFINS") {
            keys['vl11'] = u;
          }
          if (tmp.columns[u].title === "VL_AJUS_REDUC_BC_COFINS") {
            keys['vl12'] = u;
          }
        }

        let data = {};

        for (let i = 10; i < 70; i++) {
          const aliq = new Array(cofins_aliq.length).fill(0);
          data[this.getJsDateFromExcel(template.data[i][0])] = [aliq, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        }

        let repetidos: Array<string> = []

        for (let u = 0; u < tmp.data.length; u++) {
          if (data[this.fromUS(tmp.data[u][keys['periodo']])]) {
            if (tmp.data[u][keys['cod']] === "01") {
              if (tmp.data[u][keys['aliq']].replace(',', '.').fix() === cofins_aliq[0]) {
                let _tmp = tmp.data[u][keys['vl1']].fix();
                if (_tmp > 0) {
                  data[this.fromUS(tmp.data[u][keys['periodo']])][0][0] = _tmp
                } else {
                  _tmp = tmp.data[u][keys['vl1f']].fix();
                  if (_tmp > 0) {
                    data[this.fromUS(tmp.data[u][keys['periodo']])][0][0] = _tmp
                  }
                }
              }
            }

            if (tmp.data[u][keys['cod']] === "02") {
              for (let z = 1; z < cofins_aliq.length; z++) {
                if (tmp.data[u][keys['aliq']].replace(',', '.').fix() === cofins_aliq[z]) {
                  let _tmp = tmp.data[u][keys['vl1']].fix();
                  if (_tmp > 0) {
                    data[this.fromUS(tmp.data[u][keys['periodo']])][0][z] = _tmp
                  } else {
                    _tmp = tmp.data[u][keys['vl1f']].fix();
                    if (_tmp > 0) {
                      data[this.fromUS(tmp.data[u][keys['periodo']])][0][z] = _tmp
                    }
                  }
                  break;
                }
              }
            }

            data[this.fromUS(tmp.data[u][keys['periodo']])][1] = tmp.data[u][keys['vl2']].fix();
            data[this.fromUS(tmp.data[u][keys['periodo']])][2] = tmp.data[u][keys['vl3']].fix();
            data[this.fromUS(tmp.data[u][keys['periodo']])][3] = tmp.data[u][keys['vl4']].fix();
            data[this.fromUS(tmp.data[u][keys['periodo']])][4] = tmp.data[u][keys['vl5']].fix();
            data[this.fromUS(tmp.data[u][keys['periodo']])][5] = tmp.data[u][keys['vl6']].fix();

            if (repetidos.includes(this.fromUS(tmp.data[u][keys['periodo']]) + tmp.data[u][keys['cod']] + parseFloat(tmp.data[u][keys['aliq']].replace(',', '.')).toFixed(2)) === false) {
              repetidos.push(this.fromUS(tmp.data[u][keys['periodo']]) + tmp.data[u][keys['cod']] + parseFloat(tmp.data[u][keys['aliq']].replace(',', '.')).toFixed(2));

              for (let z = 0; z < cofins_aliq.length; z++) {
                if (
                  (z === 0 && tmp.data[u][keys['cod']] === "01") ||
                  (z > 0 && tmp.data[u][keys['cod']] === "02")
                ) {
                  if (tmp.data[u][keys['aliq']].replace(',', '.').fix() === cofins_aliq[z]) {
                    data[this.fromUS(tmp.data[u][keys['periodo']])][6] = data[this.fromUS(tmp.data[u][keys['periodo']])][6] + tmp.data[u][keys['vl7']].fix()
                  }
                  if (tmp.data[u][keys['aliq']].replace(',', '.').fix() === cofins_aliq[z]) {
                    data[this.fromUS(tmp.data[u][keys['periodo']])][7] = data[this.fromUS(tmp.data[u][keys['periodo']])][7] + tmp.data[u][keys['vl8']].fix()
                  }
                  if (tmp.data[u][keys['aliq']].replace(',', '.').fix() === cofins_aliq[z]) {
                    data[this.fromUS(tmp.data[u][keys['periodo']])][8] = data[this.fromUS(tmp.data[u][keys['periodo']])][8] + tmp.data[u][keys['vl9']].fix()
                  }
                  if (tmp.data[u][keys['aliq']].replace(',', '.').fix() === cofins_aliq[z]) {
                    data[this.fromUS(tmp.data[u][keys['periodo']])][9] = data[this.fromUS(tmp.data[u][keys['periodo']])][9] + tmp.data[u][keys['vl10']].fix()
                  }
                  if (tmp.data[u][keys['aliq']].replace(',', '.').fix() === cofins_aliq[z]) {
                    data[this.fromUS(tmp.data[u][keys['periodo']])][10] = data[this.fromUS(tmp.data[u][keys['periodo']])][10] + tmp.data[u][keys['vl11']].fix()
                  }
                  if (tmp.data[u][keys['aliq']].replace(',', '.').fix() === cofins_aliq[z]) {
                    data[this.fromUS(tmp.data[u][keys['periodo']])][11] = data[this.fromUS(tmp.data[u][keys['periodo']])][11] + tmp.data[u][keys['vl12']].fix()
                  }
                }
              }
            }
          }
        }

        for (let i = 10; i < 70; i++) {
          if (data[this.getJsDateFromExcel(template.data[i][0])]) {
            for (let u = 0; u < data[this.getJsDateFromExcel(template.data[i][0])][0].length; u++) {
              if (data[this.getJsDateFromExcel(template.data[i][0])][0][u] > 0) {
                template.data[i][u + 42] = data[this.getJsDateFromExcel(template.data[i][0])][0][u].two()
              }
            }

            if (data[this.getJsDateFromExcel(template.data[i][0])][1] > 0)
              template.data[i][53] = data[this.getJsDateFromExcel(template.data[i][0])][1].two()
            if (data[this.getJsDateFromExcel(template.data[i][0])][2] > 0)
              template.data[i][55] = data[this.getJsDateFromExcel(template.data[i][0])][2].two()
            if (data[this.getJsDateFromExcel(template.data[i][0])][3] > 0)
              template.data[i][56] = data[this.getJsDateFromExcel(template.data[i][0])][3].two()
            if (data[this.getJsDateFromExcel(template.data[i][0])][4] > 0)
              template.data[i][57] = data[this.getJsDateFromExcel(template.data[i][0])][4].two()
            if (data[this.getJsDateFromExcel(template.data[i][0])][5] > 0)
              template.data[i][58] = data[this.getJsDateFromExcel(template.data[i][0])][5].two()

            if (data[this.getJsDateFromExcel(template.data[i][0])][6] > 0)
              template.data[i][60] = data[this.getJsDateFromExcel(template.data[i][0])][6].two()
            if (data[this.getJsDateFromExcel(template.data[i][0])][7] > 0)
              template.data[i][61] = data[this.getJsDateFromExcel(template.data[i][0])][7].two()
            if (data[this.getJsDateFromExcel(template.data[i][0])][8] > 0)
              template.data[i][62] = data[this.getJsDateFromExcel(template.data[i][0])][8].two()
            if (data[this.getJsDateFromExcel(template.data[i][0])][9] > 0)
              template.data[i][63] = data[this.getJsDateFromExcel(template.data[i][0])][9].two()
            if (data[this.getJsDateFromExcel(template.data[i][0])][10] > 0)
              template.data[i][73] = data[this.getJsDateFromExcel(template.data[i][0])][10].two()
            if (data[this.getJsDateFromExcel(template.data[i][0])][11] > 0)
              template.data[i][74] = data[this.getJsDateFromExcel(template.data[i][0])][11].two()
          }
        }
      }
    }

    repetidos = [];

    keys2 = {};
    tmp2 = dashData.find(element => element.worksheetName === 'EFD - M505');
    if (tmp2 !== undefined) {
      for (let u = 0; u < tmp2.columns.length; u++) {
        if (tmp2.columns[u].title === "ID_DT_INI") {
          keys2['periodo'] = u;
        }
        if (tmp2.columns[u].title === "CST_COFINS") {
          keys2['cst'] = u;
        }
        if (tmp2.columns[u].title === "COD_CRED") {
          keys2['cc'] = u;
        }
        if (tmp2.columns[u].title === "ALIQ_COFINS") {
          keys2['aliq'] = u;
        }
        if (tmp2.columns[u].title === "VL_CRED") {
          keys2['vl1'] = u;
        }
        if (tmp2.columns[u].title === "VL_AJUS_ACRES") {
          keys2['vl2'] = u;
        }
        if (tmp2.columns[u].title === "VL_AJUS_REDUC") {
          keys2['vl3'] = u;
        }
        if (tmp2.columns[u].title === "VL_CRED_DIFER") {
          keys2['vl4'] = u;
        }
        if (tmp2.columns[u].title === "VL_CRED_DISP") {
          keys2['vl5'] = u;
        }
        if (tmp2.columns[u].title === "VL_CRED_DESC") {
          keys2['vl6'] = u;
        }
        if (tmp2.columns[u].title === "SLD_CRED") {
          keys2['vl7'] = u;
        }
      }

      let m505 = {};

      for (let i = 10; i < 70; i++) {
        m505[this.getJsDateFromExcel(template.data[i][0])] = [0, 0, 0, 0, 0, 0, 0];
      }

      for (let u = 0; u < tmp2.data.length; u++) {
        if (m505[this.fromUS(tmp2.data[u][keys2['periodo']])]) {
          if (repetidos.includes(this.fromUS(tmp2.data[u][keys2['periodo']]) + tmp2.data[u][keys2['aliq']].replace(',', '.').fix().toFixed(4) + tmp2.data[u][keys2['cc']]) === false) {
            repetidos.push(this.fromUS(tmp2.data[u][keys2['periodo']]) + tmp2.data[u][keys2['aliq']].replace(',', '.').fix().toFixed(4) + tmp2.data[u][keys2['cc']]);
            m505[this.fromUS(tmp2.data[u][keys2['periodo']])][0] = m505[this.fromUS(tmp2.data[u][keys2['periodo']])][0] + tmp2.data[u][keys2['vl1']].fix();
            m505[this.fromUS(tmp2.data[u][keys2['periodo']])][1] = m505[this.fromUS(tmp2.data[u][keys2['periodo']])][1] + tmp2.data[u][keys2['vl2']].fix();
            m505[this.fromUS(tmp2.data[u][keys2['periodo']])][2] = m505[this.fromUS(tmp2.data[u][keys2['periodo']])][2] + tmp2.data[u][keys2['vl3']].fix();
            m505[this.fromUS(tmp2.data[u][keys2['periodo']])][3] = m505[this.fromUS(tmp2.data[u][keys2['periodo']])][3] + tmp2.data[u][keys2['vl4']].fix();
            m505[this.fromUS(tmp2.data[u][keys2['periodo']])][4] = m505[this.fromUS(tmp2.data[u][keys2['periodo']])][4] + tmp2.data[u][keys2['vl5']].fix();
            m505[this.fromUS(tmp2.data[u][keys2['periodo']])][5] = m505[this.fromUS(tmp2.data[u][keys2['periodo']])][5] + tmp2.data[u][keys2['vl6']].fix();
            m505[this.fromUS(tmp2.data[u][keys2['periodo']])][6] = m505[this.fromUS(tmp2.data[u][keys2['periodo']])][6] + tmp2.data[u][keys2['vl7']].fix();
          }
        }
      }

      for (let i = 10; i < 70; i++) {
        if (m505[this.getJsDateFromExcel(template.data[i][0])]) {
          template.data[i][65] = m505[this.getJsDateFromExcel(template.data[i][0])][0].two()
          template.data[i][66] = m505[this.getJsDateFromExcel(template.data[i][0])][1].two()
          template.data[i][67] = m505[this.getJsDateFromExcel(template.data[i][0])][2].two()
          template.data[i][68] = m505[this.getJsDateFromExcel(template.data[i][0])][3].two()
          template.data[i][69] = m505[this.getJsDateFromExcel(template.data[i][0])][4].two()
          template.data[i][70] = m505[this.getJsDateFromExcel(template.data[i][0])][5].two()
          template.data[i][71] = m505[this.getJsDateFromExcel(template.data[i][0])][6].two()
        }
      }
    }

    keys2 = {}
    tmp2 = dashData.find(element => element.worksheetName === 'EFD - M500');
    if (tmp2 !== undefined) {
      for (let u = 0; u < tmp2.columns.length; u++) {
        if (tmp2.columns[u].title === "ID_DT_INI") {
          keys2['periodo'] = u;
        }
        if (tmp2.columns[u].title === "COD_CRED") {
          keys2['cc'] = u;
        }
        if (tmp2.columns[u].title === "ALIQ_COFINS") {
          keys2['aliq'] = u;
        }
        if (tmp2.columns[u].title === "VL_CRED") {
          keys2['vl1'] = u;
        }
        if (tmp2.columns[u].title === "VL_AJUS_ACRES") {
          keys2['vl2'] = u;
        }
        if (tmp2.columns[u].title === "VL_AJUS_REDUC") {
          keys2['vl3'] = u;
        }
        if (tmp2.columns[u].title === "VL_CRED_DIFER") {
          keys2['vl4'] = u;
        }
        if (tmp2.columns[u].title === "VL_CRED_DISP") {
          keys2['vl5'] = u;
        }
        if (tmp2.columns[u].title === "VL_CRED_DESC") {
          keys2['vl6'] = u;
        }
        if (tmp2.columns[u].title === "SLD_CRED") {
          keys2['vl7'] = u;
        }
      }

      let m500 = {};

      for (let i = 10; i < 70; i++) {
        m500[this.getJsDateFromExcel(template.data[i][0])] = [0, 0, 0, 0, 0, 0, 0];
      }

      for (let u = 1; u < tmp2.data.length; u++) {
        if (m500[this.fromUS(tmp2.data[u][keys2['periodo']])]) {
          const rep = this.fromUS(tmp2.data[u][keys2['periodo']]) + parseFloat(tmp2.data[u][keys2['aliq']].replace(',', '.')).toFixed(4) + tmp2.data[u][keys2['cc']];
          if (repetidos.includes(rep) === false) {
            repetidos.push(rep);
            m500[this.fromUS(tmp2.data[u][keys2['periodo']])][0] = m500[this.fromUS(tmp2.data[u][keys2['periodo']])][0] + tmp2.data[u][keys2['vl1']].fix();
            m500[this.fromUS(tmp2.data[u][keys2['periodo']])][1] = m500[this.fromUS(tmp2.data[u][keys2['periodo']])][1] + tmp2.data[u][keys2['vl2']].fix();
            m500[this.fromUS(tmp2.data[u][keys2['periodo']])][2] = m500[this.fromUS(tmp2.data[u][keys2['periodo']])][2] + tmp2.data[u][keys2['vl3']].fix();
            m500[this.fromUS(tmp2.data[u][keys2['periodo']])][3] = m500[this.fromUS(tmp2.data[u][keys2['periodo']])][3] + tmp2.data[u][keys2['vl4']].fix();
            m500[this.fromUS(tmp2.data[u][keys2['periodo']])][4] = m500[this.fromUS(tmp2.data[u][keys2['periodo']])][4] + tmp2.data[u][keys2['vl5']].fix();
            m500[this.fromUS(tmp2.data[u][keys2['periodo']])][5] = m500[this.fromUS(tmp2.data[u][keys2['periodo']])][5] + tmp2.data[u][keys2['vl6']].fix();
            m500[this.fromUS(tmp2.data[u][keys2['periodo']])][6] = m500[this.fromUS(tmp2.data[u][keys2['periodo']])][6] + tmp2.data[u][keys2['vl7']].fix();
          }
        }
      }

      for (let i = 10; i < 70; i++) {
        if (m500[this.getJsDateFromExcel(template.data[i][0])]) {
          template.data[i][65] = (m500[this.getJsDateFromExcel(template.data[i][0])][0] + template.data[i][65].fix()).two()
          template.data[i][66] = (m500[this.getJsDateFromExcel(template.data[i][0])][1] + template.data[i][66].fix()).two()
          template.data[i][67] = (m500[this.getJsDateFromExcel(template.data[i][0])][2] + template.data[i][67].fix()).two()
          template.data[i][68] = (m500[this.getJsDateFromExcel(template.data[i][0])][3] + template.data[i][68].fix()).two()
          template.data[i][69] = (m500[this.getJsDateFromExcel(template.data[i][0])][4] + template.data[i][69].fix()).two()
          template.data[i][70] = (m500[this.getJsDateFromExcel(template.data[i][0])][5] + template.data[i][70].fix()).two()
          template.data[i][71] = (m500[this.getJsDateFromExcel(template.data[i][0])][6] + template.data[i][71].fix()).two()
        }
      }
    }

    for (let i = 44; i < 53; i++) {
      if (template.data[9][i].fix() === 0) {
        template.columns[i].visible = false;
      }
    }

    for (let i = 10; i < 70; i++) {
      if (template.data[i][1].length == 0) {
        template.data[i][1] = 0;
      }
      if (template.data[i][2].length == 0) {
        template.data[i][2] = 0;
      }
      if (template.data[i][3].length == 0) {
        template.data[i][3] = 0;
      }
      if (template.data[i][4].length == 0) {
        template.data[i][4] = 0;
      }
      if (template.data[i][5].length == 0) {
        template.data[i][5] = 0;
      }
      if (template.data[i][6].length == 0) {
        template.data[i][6] = 0;
      }
      if (template.data[i][7].length == 0) {
        template.data[i][7] = 0;
      }
      if (template.data[i][8].length == 0) {
        template.data[i][8] = 0;
      }
      if (template.data[i][9].length == 0) {
        template.data[i][9] = 0;
      }
      if (template.data[i][10].length == 0) {
        template.data[i][10] = 0;
      }
      if (template.data[i][11].length == 0) {
        template.data[i][11] = 0;
      }
      if (template.data[i][12].length == 0) {
        template.data[i][12] = 0;
      }

      if (template.data[i][14].length == 0) {
        template.data[i][14] = 0;
      }
      if (template.data[i][15].length == 0) {
        template.data[i][15] = 0;
      }
      if (template.data[i][16].length == 0) {
        template.data[i][16] = 0;
      }
      if (template.data[i][17].length == 0) {
        template.data[i][17] = 0;
      }

      if (template.data[i][19].length == 0) {
        template.data[i][19] = 0;
      }
      if (template.data[i][20].length == 0) {
        template.data[i][20] = 0;
      }
      if (template.data[i][21].length == 0) {
        template.data[i][21] = 0;
      }
      if (template.data[i][22].length == 0) {
        template.data[i][22] = 0;
      }

      if (template.data[i][24].length == 0) {
        template.data[i][24] = 0;
      }
      if (template.data[i][25].length == 0) {
        template.data[i][25] = 0;
      }
      if (template.data[i][26].length == 0) {
        template.data[i][26] = 0;
      }
      if (template.data[i][27].length == 0) {
        template.data[i][27] = 0;
      }
      if (template.data[i][28].length == 0) {
        template.data[i][28] = 0;
      }
      if (template.data[i][29].length == 0) {
        template.data[i][29] = 0;
      }
      if (template.data[i][30].length == 0) {
        template.data[i][30] = 0;
      }

      if (template.data[i][32].length == 0) {
        template.data[i][32] = 0;
      }
      if (template.data[i][33].length == 0) {
        template.data[i][33] = 0;
      }

      if (template.data[i][42].length == 0) {
        template.data[i][42] = 0;
      }
      if (template.data[i][43].length == 0) {
        template.data[i][43] = 0;
      }
      if (template.data[i][44].length == 0) {
        template.data[i][44] = 0;
      }
      if (template.data[i][45].length == 0) {
        template.data[i][45] = 0;
      }
      if (template.data[i][46].length == 0) {
        template.data[i][46] = 0;
      }
      if (template.data[i][47].length == 0) {
        template.data[i][47] = 0;
      }
      if (template.data[i][48].length == 0) {
        template.data[i][48] = 0;
      }
      if (template.data[i][49].length == 0) {
        template.data[i][49] = 0;
      }
      if (template.data[i][50].length == 0) {
        template.data[i][50] = 0;
      }
      if (template.data[i][51].length == 0) {
        template.data[i][51] = 0;
      }
      if (template.data[i][52].length == 0) {
        template.data[i][52] = 0;
      }
      if (template.data[i][53].length == 0) {
        template.data[i][53] = 0;
      }

      if (template.data[i][55].length == 0) {
        template.data[i][55] = 0;
      }
      if (template.data[i][56].length == 0) {
        template.data[i][56] = 0;
      }
      if (template.data[i][57].length == 0) {
        template.data[i][57] = 0;
      }
      if (template.data[i][58].length == 0) {
        template.data[i][58] = 0;
      }

      if (template.data[i][60].length == 0) {
        template.data[i][60] = 0;
      }
      if (template.data[i][61].length == 0) {
        template.data[i][61] = 0;
      }
      if (template.data[i][62].length == 0) {
        template.data[i][62] = 0;
      }
      if (template.data[i][63].length == 0) {
        template.data[i][63] = 0;
      }

      if (template.data[i][65].length == 0) {
        template.data[i][65] = 0;
      }
      if (template.data[i][66].length == 0) {
        template.data[i][66] = 0;
      }
      if (template.data[i][67].length == 0) {
        template.data[i][67] = 0;
      }
      if (template.data[i][68].length == 0) {
        template.data[i][68] = 0;
      }
      if (template.data[i][69].length == 0) {
        template.data[i][69] = 0;
      }
      if (template.data[i][70].length == 0) {
        template.data[i][70] = 0;
      }
      if (template.data[i][71].length == 0) {
        template.data[i][71] = 0;
      }

      if (template.data[i][73].length == 0) {
        template.data[i][73] = 0;
      }
      if (template.data[i][74].length == 0) {
        template.data[i][74] = 0;
      }
    }

    template.data[1][1] = configuracoes.header;
    template.data[71][1] = configuracoes.footer;

    return JSON.parse(JSON.stringify(template).replace(/#2e3757/g, configuracoes.data.toString()));
  }

  F06(template: any, dashData: any, configuracoes: any): any {
    const prescricional = this.getPrescricional();
    for (let i = 8; i < 68; i++) {
      template.data[i][0] = this.JSDateToExcelDate(prescricional[i - 8])
    }

    let nats: Array<string> = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18'];
    //let cod_creds: Array<string> = ['101', '102', '103', '104', '199', '201', '202', '299'];
    let repetidos: Array<string> = [];

    let keys: any = {};
    let tmp = dashData.find(element => element.worksheetName === 'EFD - M105');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "ID_DT_INI") {
          keys['periodo'] = u;
        }
        if (tmp.columns[u].title === "CST_PIS") {
          keys['cst'] = u;
        }
        if (tmp.columns[u].title === "ALIQ_PIS") {
          keys['aliq'] = u;
        }
        if (tmp.columns[u].title === "COD_CRED") {
          keys['cc'] = u;
        }
        if (tmp.columns[u].title === "NAT_BC_CRED") {
          keys['nat'] = u;
        }
        if (tmp.columns[u].title === "VL_BC_PIS") {
          keys['vl1'] = u;
        }
      }

      repetidos = [];

      let m105 = {};

      for (let i = 8; i < 68; i++) {
        m105[this.getJsDateFromExcel(template.data[i][0])] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        if (tmp.data[u][keys['aliq']].replace(',', '.').fix() !== 0) {
          if (m105[this.fromUS(tmp.data[u][keys['periodo']])]) {
            //if (cod_creds.includes(tmp.data[u][keys['cc']])) {
            if (nats.includes(tmp.data[u][keys['nat']])) {
              const rep = this.fromUS(tmp.data[u][keys['periodo']]) + tmp.data[u][keys['aliq']].replace(',', '.').fix().toFixed(4) + tmp.data[u][keys['cc']] + tmp.data[u][keys['nat']];
              if (repetidos.includes(rep) === false) {
                repetidos.push(rep);
                switch (tmp.data[u][keys['nat']]) {
                  case "01":
                    m105[this.fromUS(tmp.data[u][keys['periodo']])][0] = m105[this.fromUS(tmp.data[u][keys['periodo']])][0] + tmp.data[u][keys['vl1']].fix();
                    break;
                  case "02":
                    m105[this.fromUS(tmp.data[u][keys['periodo']])][1] = m105[this.fromUS(tmp.data[u][keys['periodo']])][1] + tmp.data[u][keys['vl1']].fix();
                    break;
                  case "03":
                    m105[this.fromUS(tmp.data[u][keys['periodo']])][2] = m105[this.fromUS(tmp.data[u][keys['periodo']])][2] + tmp.data[u][keys['vl1']].fix();
                    break;
                  case "04":
                    m105[this.fromUS(tmp.data[u][keys['periodo']])][3] = m105[this.fromUS(tmp.data[u][keys['periodo']])][3] + tmp.data[u][keys['vl1']].fix();
                    break;
                  case "05":
                    m105[this.fromUS(tmp.data[u][keys['periodo']])][4] = m105[this.fromUS(tmp.data[u][keys['periodo']])][4] + tmp.data[u][keys['vl1']].fix();
                    break;
                  case "06":
                    m105[this.fromUS(tmp.data[u][keys['periodo']])][5] = m105[this.fromUS(tmp.data[u][keys['periodo']])][5] + tmp.data[u][keys['vl1']].fix();
                    break;
                  case "07":
                    m105[this.fromUS(tmp.data[u][keys['periodo']])][6] = m105[this.fromUS(tmp.data[u][keys['periodo']])][6] + tmp.data[u][keys['vl1']].fix();
                    break;
                  case "08":
                    m105[this.fromUS(tmp.data[u][keys['periodo']])][7] = m105[this.fromUS(tmp.data[u][keys['periodo']])][7] + tmp.data[u][keys['vl1']].fix();
                    break;
                  case "09":
                    m105[this.fromUS(tmp.data[u][keys['periodo']])][8] = m105[this.fromUS(tmp.data[u][keys['periodo']])][8] + tmp.data[u][keys['vl1']].fix();
                    break;
                  case "10":
                    m105[this.fromUS(tmp.data[u][keys['periodo']])][9] = m105[this.fromUS(tmp.data[u][keys['periodo']])][9] + tmp.data[u][keys['vl1']].fix();
                    break;
                  case "11":
                    m105[this.fromUS(tmp.data[u][keys['periodo']])][10] = m105[this.fromUS(tmp.data[u][keys['periodo']])][10] + tmp.data[u][keys['vl1']].fix();
                    break;
                  case "12":
                    m105[this.fromUS(tmp.data[u][keys['periodo']])][11] = m105[this.fromUS(tmp.data[u][keys['periodo']])][11] + tmp.data[u][keys['vl1']].fix();
                    break;
                  case "13":
                    m105[this.fromUS(tmp.data[u][keys['periodo']])][12] = m105[this.fromUS(tmp.data[u][keys['periodo']])][12] + tmp.data[u][keys['vl1']].fix();
                    break;
                  case "14":
                    m105[this.fromUS(tmp.data[u][keys['periodo']])][13] = m105[this.fromUS(tmp.data[u][keys['periodo']])][13] + tmp.data[u][keys['vl1']].fix();
                    break;
                  case "15":
                    m105[this.fromUS(tmp.data[u][keys['periodo']])][14] = m105[this.fromUS(tmp.data[u][keys['periodo']])][14] + tmp.data[u][keys['vl1']].fix();
                    break;
                  case "16":
                    m105[this.fromUS(tmp.data[u][keys['periodo']])][15] = m105[this.fromUS(tmp.data[u][keys['periodo']])][15] + tmp.data[u][keys['vl1']].fix();
                    break;
                  case "17":
                    m105[this.fromUS(tmp.data[u][keys['periodo']])][16] = m105[this.fromUS(tmp.data[u][keys['periodo']])][16] + tmp.data[u][keys['vl1']].fix();
                    break;
                  case "18":
                    m105[this.fromUS(tmp.data[u][keys['periodo']])][17] = m105[this.fromUS(tmp.data[u][keys['periodo']])][17] + tmp.data[u][keys['vl1']].fix();
                    break;
                }
              }
            }
            //}
          }
        }
      }

      for (let i = 8; i < 68; i++) {
        if (m105[this.getJsDateFromExcel(template.data[i][0])]) {
          template.data[i][2] = m105[this.getJsDateFromExcel(template.data[i][0])][0].two()
          template.data[i][3] = m105[this.getJsDateFromExcel(template.data[i][0])][1].two()
          template.data[i][4] = m105[this.getJsDateFromExcel(template.data[i][0])][2].two()
          template.data[i][5] = m105[this.getJsDateFromExcel(template.data[i][0])][3].two()
          template.data[i][6] = m105[this.getJsDateFromExcel(template.data[i][0])][4].two()
          template.data[i][7] = m105[this.getJsDateFromExcel(template.data[i][0])][5].two()
          template.data[i][8] = m105[this.getJsDateFromExcel(template.data[i][0])][6].two()
          template.data[i][9] = m105[this.getJsDateFromExcel(template.data[i][0])][7].two()
          template.data[i][10] = m105[this.getJsDateFromExcel(template.data[i][0])][8].two()
          template.data[i][11] = m105[this.getJsDateFromExcel(template.data[i][0])][9].two()
          template.data[i][12] = m105[this.getJsDateFromExcel(template.data[i][0])][10].two()
          template.data[i][13] = m105[this.getJsDateFromExcel(template.data[i][0])][11].two()
          template.data[i][14] = m105[this.getJsDateFromExcel(template.data[i][0])][12].two()
          template.data[i][15] = m105[this.getJsDateFromExcel(template.data[i][0])][13].two()
          template.data[i][16] = m105[this.getJsDateFromExcel(template.data[i][0])][14].two()
          template.data[i][17] = m105[this.getJsDateFromExcel(template.data[i][0])][15].two()
          template.data[i][18] = m105[this.getJsDateFromExcel(template.data[i][0])][16].two()
          template.data[i][19] = m105[this.getJsDateFromExcel(template.data[i][0])][17].two()
        }
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'EFD - M100');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "ID_DT_INI") {
          keys['periodo'] = u;
        }
        if (tmp.columns[u].title === "ALIQ_PIS") {
          keys['aliq'] = u;
        }
        if (tmp.columns[u].title === "COD_CRED") {
          keys['cc'] = u;
        }
        if (tmp.columns[u].title === "VL_BC_PIS") {
          keys['vl1'] = u;
        }
      }

      let m100 = {};

      for (let i = 8; i < 68; i++) {
        m100[this.getJsDateFromExcel(template.data[i][0])] = [0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        if (m100[this.fromUS(tmp.data[u][keys['periodo']])]) {
          //if (cod_creds.includes(tmp.data[u][keys['cc']])) {
          const rep = tmp.data[u][keys['periodo']] + tmp.data[u][keys['aliq']].replace(',', '.').fix().toFixed(4) + tmp.data[u][keys['cc']];
          if (repetidos.includes(rep) === false) {
            repetidos.push(rep);
            m100[this.fromUS(tmp.data[u][keys['periodo']])][0] = m100[this.fromUS(tmp.data[u][keys['periodo']])][0] + tmp.data[u][keys['vl1']].fix();
          }
          //}
        }
      }

      for (let i = 8; i < 68; i++) {
        if (m100[this.getJsDateFromExcel(template.data[i][0])]) {
          template.data[i][20] = m100[this.getJsDateFromExcel(template.data[i][0])][0].two();
        }
      }
    }

    template.data[1][1] = configuracoes.header;
    template.data[70][1] = configuracoes.footer;

    return JSON.parse(JSON.stringify(template).replace(/#2e3757/g, configuracoes.data.toString()));
  }

  F07(template: any, dashData: any, configuracoes: any): any {
    const prescricional = this.getPrescricional();
    for (let i = 8; i < 68; i++) {
      template.data[i][0] = this.JSDateToExcelDate(prescricional[i - 8])
    }

    let pis_aliq: Array<string> = [];

    let tmp = dashData.find(element => element.worksheetName === 'F05B - SPED CT -  PC N CUMULAT');
    if (tmp !== undefined) {
      for (let i = 1; i < 12; i++) {
        if (tmp.data[9][i] > 0) {
          pis_aliq.push(tmp.data[9][i].fix());
        }
      }
    }

    let repetidos: Array<string> = [];
    let research = ['EFD - M210', 'EFD - M215', 'EFD - M220', 'EFD - M225', 'EFD - M230']

    let data = {};

    for (let i = 8; i < 68; i++) {
      data[this.getJsDateFromExcel(template.data[i][0])] = [0];
    }

    for (let current of research) {
      let keys: any = {};
      let tmp = dashData.find(element => element.worksheetName === current);
      if (tmp !== undefined) {
        for (let u = 0; u < tmp.columns.length; u++) {
          if (tmp.columns[u].title === "ID_DT_INI") {
            keys['periodo'] = u;
          }
          if (tmp.columns[u].title === "COD_CONT") {
            keys['cod'] = u;
          }
          if (tmp.columns[u].title === "ALIQ_PIS") {
            keys['aliq'] = u;
          }
          if (tmp.columns[u].title === "VL_REC_BRT") {
            keys['vl1'] = u;
          }
        }

        for (let u = 0; u < tmp.data.length; u++) {
          if (data[this.fromUS(tmp.data[u][keys['periodo']])]) {
            if (
              tmp.data[u][keys['cod']] === "31" ||
              tmp.data[u][keys['cod']] === "32" ||
              tmp.data[u][keys['cod']] === "51" ||
              tmp.data[u][keys['cod']] === "52" ||
              tmp.data[u][keys['cod']] === "01" ||
              tmp.data[u][keys['cod']] === "02"
            ) {
              if (pis_aliq.includes(tmp.data[u][keys['aliq']].replace(',', '.').fix())) {
                const rep = tmp.data[u][keys['periodo']] + tmp.data[u][keys['cod']].replace(',', '.').fix().toFixed(4) + tmp.data[u][keys['aliq']].replace(',', '.').fix().toFixed(4);
                if (repetidos.includes(rep) === false) {
                  repetidos.push(rep);
                  data[this.fromUS(tmp.data[u][keys['periodo']])][0] = data[this.fromUS(tmp.data[u][keys['periodo']])][0] + tmp.data[u][keys['vl1']].fix();
                }
              }
            }
          }
        }
      }
    }
    for (let i = 8; i < 68; i++) {
      if (data[this.getJsDateFromExcel(template.data[i][0])]) {
        data[this.getJsDateFromExcel(template.data[i][0])][0] > 0 ? template.data[i][1] = data[this.getJsDateFromExcel(template.data[i][0])][0].two() : null
      }
    }

    let csts: Array<string> = ['03', '04', '05', '06', '07', '08', '09', '49', '99'];

    let keys: any = {};
    tmp = dashData.find(element => element.worksheetName === 'EFD - M410');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "ID_DT_INI") {
          keys['periodo'] = u;
        }
        if (tmp.columns[u].title === "CST_PIS") {
          keys['cst'] = u;
        }
        if (tmp.columns[u].title === "VL_REC") {
          keys['vl1'] = u;
        }
      }

      let data = {};

      for (let i = 8; i < 68; i++) {
        data[this.getJsDateFromExcel(template.data[i][0])] = [0, 0, 0, 0, 0, 0, 0, 0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        if (data[this.fromUS(tmp.data[u][keys['periodo']])]) {
          if (csts.includes(tmp.data[u][keys['cst']])) {
            switch (tmp.data[u][keys['cst']]) {
              case "03":
                data[this.fromUS(tmp.data[u][keys['periodo']])][0] = data[this.fromUS(tmp.data[u][keys['periodo']])][0] + tmp.data[u][keys['vl1']].fix();
                break;
              case "04":
                data[this.fromUS(tmp.data[u][keys['periodo']])][1] = data[this.fromUS(tmp.data[u][keys['periodo']])][1] + tmp.data[u][keys['vl1']].fix();
                break;
              case "05":
                data[this.fromUS(tmp.data[u][keys['periodo']])][2] = data[this.fromUS(tmp.data[u][keys['periodo']])][2] + tmp.data[u][keys['vl1']].fix();
                break;
              case "06":
                data[this.fromUS(tmp.data[u][keys['periodo']])][3] = data[this.fromUS(tmp.data[u][keys['periodo']])][3] + tmp.data[u][keys['vl1']].fix();
                break;
              case "07":
                data[this.fromUS(tmp.data[u][keys['periodo']])][4] = data[this.fromUS(tmp.data[u][keys['periodo']])][4] + tmp.data[u][keys['vl1']].fix();
                break;
              case "08":
                data[this.fromUS(tmp.data[u][keys['periodo']])][5] = data[this.fromUS(tmp.data[u][keys['periodo']])][5] + tmp.data[u][keys['vl1']].fix();
                break;
              case "09":
                data[this.fromUS(tmp.data[u][keys['periodo']])][6] = data[this.fromUS(tmp.data[u][keys['periodo']])][6] + tmp.data[u][keys['vl1']].fix();
                break;
              case "49":
                data[this.fromUS(tmp.data[u][keys['periodo']])][7] = data[this.fromUS(tmp.data[u][keys['periodo']])][7] + tmp.data[u][keys['vl1']].fix();
                break;
              case "99":
                data[this.fromUS(tmp.data[u][keys['periodo']])][8] = data[this.fromUS(tmp.data[u][keys['periodo']])][8] + tmp.data[u][keys['vl1']].fix();
                break;
            }
          }
        }
      }

      for (let i = 8; i < 68; i++) {
        if (data[this.getJsDateFromExcel(template.data[i][0])]) {
          template.data[i][4] = data[this.getJsDateFromExcel(template.data[i][0])][0].two();
          template.data[i][5] = data[this.getJsDateFromExcel(template.data[i][0])][1].two();
          template.data[i][6] = data[this.getJsDateFromExcel(template.data[i][0])][2].two();
          template.data[i][7] = data[this.getJsDateFromExcel(template.data[i][0])][3].two();
          template.data[i][8] = data[this.getJsDateFromExcel(template.data[i][0])][4].two();
          template.data[i][9] = data[this.getJsDateFromExcel(template.data[i][0])][5].two();
          template.data[i][10] = data[this.getJsDateFromExcel(template.data[i][0])][6].two();
          template.data[i][11] = data[this.getJsDateFromExcel(template.data[i][0])][7].two();
          template.data[i][12] = data[this.getJsDateFromExcel(template.data[i][0])][8].two();
        }
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F05B - SPED CT -  PC N CUMULAT');
    let tmp2 = dashData.find(element => element.worksheetName === 'F05A - SPED CT - PC CUMULATIVO');
    if (tmp !== undefined && tmp2 !== undefined) {
      for (let i = 8; i < 68; i++) {
        let _tmp = 0;
        _tmp = _tmp + tmp.data[i + 2][1].fix();
        _tmp = _tmp + tmp2.data[i + 2][1].fix();
        _tmp = _tmp + tmp2.data[i + 2][2].fix();
        template.data[i][2] = _tmp.two();

        _tmp = 0;
        _tmp = _tmp + tmp.data[i + 2][2].fix();
        _tmp = _tmp + tmp.data[i + 2][3].fix();
        _tmp = _tmp + tmp.data[i + 2][4].fix();
        _tmp = _tmp + tmp.data[i + 2][5].fix();
        _tmp = _tmp + tmp.data[i + 2][6].fix();
        _tmp = _tmp + tmp.data[i + 2][7].fix();
        _tmp = _tmp + tmp.data[i + 2][8].fix();
        _tmp = _tmp + tmp.data[i + 2][9].fix();
        _tmp = _tmp + tmp.data[i + 2][10].fix();
        _tmp = _tmp + tmp.data[i + 2][11].fix();

        template.data[i][3] = _tmp.two();
      }
    }

    for (let i = 8; i < 68; i++) {
      if (template.data[i][1].length === 0) {
        template.data[i][1] = 0;
      }
    }

    template.data[1][1] = configuracoes.header;
    template.data[70][1] = configuracoes.footer;

    return JSON.parse(JSON.stringify(template).replace(/#2e3757/g, configuracoes.data.toString()));
  }

  async F08(template: any, dashData: any, configuracoes: any) {
    const anos = this.getAnual();
    const trimestres = this.getTrimestres();

    let i = 9;
    let loops = 0;
    while (i <= 29) {
      template.data[i][0] = anos[loops]
      i = i + 5;
      loops++;
    }

    i = 10;
    loops = 0;
    while (i <= 33) {
      template.data[i][0] = trimestres[loops];
      template.data[i + 1][0] = trimestres[loops + 1];
      template.data[i + 2][0] = trimestres[loops + 2];
      template.data[i + 3][0] = trimestres[loops + 3];
      i = i + 5;
      loops = loops + 4;
    }

    for (let i = 38; i < 58; i++) {
      template.data[i][0] = trimestres[i - 38]
    }

    let keys: any = {};
    let tmp = dashData.find(element => element.worksheetName === 'ECF - M300');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "ID_DT_INI") {
          keys['periodo'] = u;
        }
        if (tmp.columns[u].title === "PER_APUR") {
          keys['pa'] = u;
        }
        if (tmp.columns[u].title === "CODIGO") {
          keys['cod'] = u;
        }
        if (tmp.columns[u].title === "VALOR") {
          keys['vl1'] = u;
        }
      }

      let i = 9;
      while (i <= 29) {
        for (let u = 0; u < tmp.data.length; u++) {
          if (this.fromUS(tmp.data[u][keys['periodo']]).split("/")[2] === template.data[i][0]) {
            if (tmp.data[u][keys['pa']] == "A00" && tmp.data[u][keys['cod']] === "2") {
              template.data[i][1] = tmp.data[u][keys['vl1']].fix().two()
            }
            if (tmp.data[u][keys['pa']] == "A00" && tmp.data[u][keys['cod']] === "93") {
              template.data[i][2] = tmp.data[u][keys['vl1']].fix().two()
            }
            if (tmp.data[u][keys['pa']] == "A00" && tmp.data[u][keys['cod']] === "168") {
              template.data[i][3] = tmp.data[u][keys['vl1']].fix().two()
            }
          }
        }
        i = i + 5;
      }

      i = 10;
      loops = 0;
      while (i <= 33) {
        for (let z = i; z < (i + 4); z++) {
          for (let u = 0; u < tmp.data.length; u++) {
            if (this.fromUS(tmp.data[u][keys['periodo']]).split("/")[2] === template.data[z][0].substr(-4)) {
              if (tmp.data[u][keys['pa']] === "T0" + template.data[z][0].substr(0, 1)) {
                if (tmp.data[u][keys['cod']] === "2") {
                  template.data[z][1] = tmp.data[u][keys['vl1']].fix().two()
                }
                if (tmp.data[u][keys['cod']] === "93") {
                  template.data[z][2] = tmp.data[u][keys['vl1']].fix().two()
                }
                if (tmp.data[u][keys['cod']] === "168") {
                  template.data[z][3] = tmp.data[u][keys['vl1']].fix().two()
                }
              }
            }
          }
        }
        i = i + 5;
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'ECF - N630');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "ID_DT_INI") {
          keys['periodo'] = u;
        }
        if (tmp.columns[u].title === "PER_APUR") {
          keys['pa'] = u;
        }
        if (tmp.columns[u].title === "CODIGO") {
          keys['cod'] = u;
        }
        if (tmp.columns[u].title === "VALOR") {
          keys['vl1'] = u;
        }
      }

      let i = 9;
      while (i <= 29) {
        for (let u = 0; u < tmp.data.length; u++) {
          if (this.fromUS(tmp.data[u][keys['periodo']]).split("/")[2] === template.data[i][0]) {
            if (
              template.data[i][1].length === undefined ||
              template.data[i][2].length === undefined ||
              template.data[i][3].length === undefined
            ) {
              if (tmp.data[u][keys['pa']] == "A00" && tmp.data[u][keys['cod']] === "1") {
                template.data[i][5] = tmp.data[u][keys['vl1']].fix().two()
              }

              if (tmp.data[u][keys['pa']] == "A00") {
                if (
                  tmp.data[u][keys['cod']] === "20" ||
                  tmp.data[u][keys['cod']] === "21" ||
                  tmp.data[u][keys['cod']] === "22"
                ) {
                  let _tmp = 0;
                  if (template.data[i][11].length === undefined) {
                    _tmp = parseFloat(template.data[i][11]);
                  }
                  template.data[i][11] = (tmp.data[u][keys['vl1']].fix() + _tmp).two()
                }
              }

              if (tmp.data[u][keys['pa']] == "A00" && tmp.data[u][keys['cod']] === "25") {
                template.data[i][12] = tmp.data[u][keys['vl1']].fix().two()
              }

              if (tmp.data[u][keys['pa']] == "A00" && tmp.data[u][keys['cod']] === "24") {
                template.data[i][13] = tmp.data[u][keys['vl1']].fix().two()
              }

              if (tmp.data[u][keys['pa']] == "A00") {
                if (
                  tmp.data[u][keys['cod']] === "19" ||
                  tmp.data[u][keys['cod']] === "23"
                ) {
                  let _tmp = 0;
                  if (template.data[i][14].length === undefined) {
                    _tmp = parseFloat(template.data[i][14]);
                  }
                  template.data[i][14] = (tmp.data[u][keys['vl1']].fix() + _tmp).two()
                }
              }

              if (tmp.data[u][keys['pa']] == "A00") {
                if (
                  tmp.data[u][keys['cod']] === "6" ||
                  tmp.data[u][keys['cod']] === "7" ||
                  tmp.data[u][keys['cod']] === "8" ||
                  tmp.data[u][keys['cod']] === "9" ||
                  tmp.data[u][keys['cod']] === "10" ||
                  tmp.data[u][keys['cod']] === "11" ||
                  tmp.data[u][keys['cod']] === "12" ||
                  tmp.data[u][keys['cod']] === "13" ||
                  tmp.data[u][keys['cod']] === "14" ||
                  tmp.data[u][keys['cod']] === "15" ||
                  tmp.data[u][keys['cod']] === "16" ||
                  tmp.data[u][keys['cod']] === "17" ||
                  tmp.data[u][keys['cod']] === "18"
                ) {
                  let _tmp = 0;
                  if (template.data[i][15].length === undefined) {
                    _tmp = parseFloat(template.data[i][15]);
                  }
                  template.data[i][15] = (tmp.data[u][keys['vl1']].fix() + _tmp).two()
                }
              }

              if (tmp.data[u][keys['pa']] == "A00" && tmp.data[u][keys['cod']] === "26") {
                template.data[i][16] = tmp.data[u][keys['vl1']].fix().two()
              }
            }
          }
        }
        i = i + 5;
      }

      let z = 10;
      loops = 0;
      while (z <= 34) {
        for (let i = z; i < (z + 4); i++) {
          for (let u = 0; u < tmp.data.length; u++) {
            if (this.fromUS(tmp.data[u][keys['periodo']]).split("/")[2] === template.data[i][0].substr(-4)) {
              if (tmp.data[u][keys['pa']] === "T0" + template.data[i][0].substr(0, 1)) {
                if (
                  template.data[i][1].length === undefined ||
                  template.data[i][2].length === undefined ||
                  template.data[i][3].length === undefined
                ) {
                  if (tmp.data[u][keys['cod']] === "1") {
                    template.data[i][5] = tmp.data[u][keys['vl1']].fix().two()
                  }

                  if (
                    tmp.data[u][keys['cod']] === "20" ||
                    tmp.data[u][keys['cod']] === "21" ||
                    tmp.data[u][keys['cod']] === "22"
                  ) {
                    let _tmp = 0;
                    if (template.data[i][11].length === undefined) {
                      _tmp = template.data[i][11].fix();
                    }
                    template.data[i][11] = (tmp.data[u][keys['vl1']].fix() + _tmp).two()
                  }

                  if (tmp.data[u][keys['cod']] === "25") {
                    template.data[i][12] = tmp.data[u][keys['vl1']].fix().two()
                  }

                  if (tmp.data[u][keys['cod']] === "24") {
                    template.data[i][13] = tmp.data[u][keys['vl1']].fix().two()
                  }

                  if (
                    tmp.data[u][keys['cod']] === "19" ||
                    tmp.data[u][keys['cod']] === "23"
                  ) {
                    let _tmp = 0;
                    if (template.data[i][14].length === undefined) {
                      _tmp = template.data[i][14].fix();
                    }
                    template.data[i][14] = (tmp.data[u][keys['vl1']].fix() + _tmp).two()
                  }

                  if (
                    tmp.data[u][keys['cod']] === "6" ||
                    tmp.data[u][keys['cod']] === "7" ||
                    tmp.data[u][keys['cod']] === "8" ||
                    tmp.data[u][keys['cod']] === "9" ||
                    tmp.data[u][keys['cod']] === "10" ||
                    tmp.data[u][keys['cod']] === "11" ||
                    tmp.data[u][keys['cod']] === "12" ||
                    tmp.data[u][keys['cod']] === "13" ||
                    tmp.data[u][keys['cod']] === "14" ||
                    tmp.data[u][keys['cod']] === "15" ||
                    tmp.data[u][keys['cod']] === "16" ||
                    tmp.data[u][keys['cod']] === "17" ||
                    tmp.data[u][keys['cod']] === "18"
                  ) {
                    let _tmp = 0;
                    if (template.data[i][15].length === undefined) {
                      _tmp = template.data[i][15].fix();
                    }
                    template.data[i][15] = (tmp.data[u][keys['vl1']].fix() + _tmp).two()
                  }

                  if (tmp.data[u][keys['cod']] === "26") {
                    template.data[i][16] = tmp.data[u][keys['vl1']].fix().two()
                  }
                }
              }
            }
          }
        }
        z = z + 5;
      }

      for (let i = 9; i < 34; i++) {
        const tmp2 = dashData.find(element => element.worksheetInstance === 'F08 - ECF - IRPJ');
        if (tmp2 !== undefined && tmp2.data !== undefined) {
          if (template.data[i][9].length === undefined) {
            template.data[i][9] = tmp2.data[i][9].fix().two()
          } else {
            template.data[i][9] = 0;
          }
        } else {
          template.data[i][9] = 0;
        }

        if (i === 9) {
          let saldo_inicial = 0;

          const tmp2 = dashData.find(element => element.worksheetName === 'ECF - M010');
          if (tmp2 !== undefined) {
            const keys2 = {}

            for (let z = 0; z < tmp2.columns.length; z++) {
              if (tmp2.columns[z].title === "ID_DT_INI") {
                keys2['periodo'] = z;
              }
              if (tmp2.columns[z].title === "DESC_CTA_LAL") {
                keys2['desc'] = z;
              }
              if (tmp2.columns[z].title === "DT_AP_LAL") {
                keys2['dt'] = z;
              }
              if (tmp2.columns[z].title === "VL_SALDO_INI") {
                keys2['vl1'] = z;
              }
              if (tmp2.columns[z].title === "COD_TRIBUTO") {
                keys2['cod'] = z;
              }
            }

            await (async () => {
              for (let x = 0; x < anos.length; x++) {
                let opcoes: any = [];
                for (let z = 0; z < tmp2.data.length; z++) {
                  if (this.fromUS(tmp2.data[z][keys2['periodo']]).split("/")[2] === anos[x]) {
                    if (tmp2.data[z][keys2['cod']] === "I") {
                      opcoes.push([
                        this.fromUS(tmp2.data[z][keys2['periodo']]),
                        tmp2.data[z][keys2['desc']],
                        this.fromUS(tmp2.data[z][keys2['dt']]),
                        tmp2.data[z][keys2['vl1']].fix()
                      ]);
                    }
                  }
                }

                if (opcoes.length > 0) {
                  opcoes.push([
                    '-',
                    'DESCONSIDERAR PREJUÍZOS FISCAIS',
                    '-',
                    0
                  ]);

                  let opcoesText = "";
                  for (let z = 0; z < opcoes.length; z++) {
                    opcoesText = opcoesText + '<tr><td><div class="form-check"><input class="form-check-input prejuizo" type="checkbox" value="' + z + '"></div></td><td>' + opcoes[z][0] + '</td></td><td>' + opcoes[z][1] + '</td></td><td>' + opcoes[z][2] + '</td></td><td>' + opcoes[z][3].toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + '</td></tr>';
                  }

                  const res = await Swal.fire({
                    title: 'F08 - ECF - IRPJ',
                    html: 'Selecione o <span style="color:red">Saldo Inicial de Prejuízos Fiscais</span> de acordo com as informações identificadas no registro M010 da ECF referentes ao Prejuízo Fiscal acumulado de anos anteriores.' +
                      '<div class="mt-3" style="max-height: 260px; overflow: auto;"><table class="table table-responsive dataTable no-footer"><thead class="thead-primary"><tr><th><i class="bi bi-check2-square"></i></th><th>ID_DT_INI</th><th style="width: 30%">DESC_CTA_LAL</th><th>DT_AP_LAL</th><th>VL_SALDO_INI</th></tr></thead><tbody>' + opcoesText + '</tbody></table></div>',
                    icon: 'question',
                    heightAuto: false,
                    allowOutsideClick: false,
                    customClass: {
                      confirmButton: 'btn-swal'
                    },
                    width: 800,
                    confirmButtonText: 'Selecionar',
                    input: 'radio',
                    inputValidator: (value: any): any => {
                      const elements = document.querySelectorAll('.prejuizo');
                      for (const index of elements) {
                        if ((index as HTMLInputElement).checked) {
                          return
                        }
                      }
                      return 'É necessário selecionar uma opção!'
                    }
                  }).then((result) => {
                    const elements = document.querySelectorAll('.prejuizo');
                    for (const index of elements) {
                      if ((index as HTMLInputElement).checked) {
                        saldo_inicial = saldo_inicial + opcoes[(index as HTMLInputElement).value][3]
                      }
                    }
                  })
                  break;
                }
              }
            })();
          }

          template.data[i][6] = saldo_inicial.two();
        }
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'ECF - P200');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "ID_DT_INI") {
          keys['periodo'] = u;
        }
        if (tmp.columns[u].title === "PER_APUR") {
          keys['pa'] = u;
        }
        if (tmp.columns[u].title === "CODIGO") {
          keys['cod'] = u;
        }
        if (tmp.columns[u].title === "VALOR") {
          keys['vl1'] = u;
        }
      }

      for (let i = 38; i < 58; i++) {
        for (let u = 0; u < tmp.data.length; u++) {
          if (this.fromUS(tmp.data[u][keys['periodo']]).split("/")[2] === template.data[i][0].substr(-4)) {
            if (tmp.data[u][keys['pa']] === "T0" + template.data[i][0].substr(0, 1)) {
              if (
                tmp.data[u][keys['cod']] === "11" ||
                tmp.data[u][keys['cod']] === "12" ||
                tmp.data[u][keys['cod']] === "16" ||
                tmp.data[u][keys['cod']] === "18" ||
                tmp.data[u][keys['cod']] === "20"
              ) {
                let _tmp = 0;
                if (template.data[i][1] !== undefined) {
                  _tmp = template.data[i][1].fix();
                }
                template.data[i][1] = (tmp.data[u][keys['vl1']].fix() + _tmp).two()
              }

              if (tmp.data[u][keys['cod']] === "2") {
                template.data[i][2] = tmp.data[u][keys['vl1']].fix().two()
              }

              if (tmp.data[u][keys['cod']] === "4") {
                template.data[i][3] = tmp.data[u][keys['vl1']].fix().two()
              }

              if (tmp.data[u][keys['cod']] === "6") {
                template.data[i][4] = tmp.data[u][keys['vl1']].fix().two()
              }

              if (tmp.data[u][keys['cod']] === "8") {
                template.data[i][5] = tmp.data[u][keys['vl1']].fix().two()
              }
            }
          }
        }
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'ECF - P300');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "ID_DT_INI") {
          keys['periodo'] = u;
        }
        if (tmp.columns[u].title === "PER_APUR") {
          keys['pa'] = u;
        }
        if (tmp.columns[u].title === "CODIGO") {
          keys['cod'] = u;
        }
        if (tmp.columns[u].title === "VALOR") {
          keys['vl1'] = u;
        }
      }

      for (let i = 38; i < 58; i++) {
        for (let u = 0; u < tmp.data.length; u++) {
          if (this.fromUS(tmp.data[u][keys['periodo']]).split("/")[2] === template.data[i][0].substr(-4)) {
            if (tmp.data[u][keys['pa']] === "T0" + template.data[i][0].substr(0, 1)) {
              if (tmp.data[u][keys['cod']] === "15") {
                template.data[i][7] = tmp.data[u][keys['vl1']].fix().two()
              }

              if (
                tmp.data[u][keys['cod']] === "10" ||
                tmp.data[u][keys['cod']] === "11" ||
                tmp.data[u][keys['cod']] === "12" ||
                tmp.data[u][keys['cod']] === "13" ||
                tmp.data[u][keys['cod']] === "14"
              ) {
                let _tmp = 0;
                if (template.data[i][8] !== undefined) {
                  _tmp = template.data[i][8].fix();
                }
                template.data[i][8] = (tmp.data[u][keys['vl1']].fix() + _tmp).two()
              }

              if (
                tmp.data[u][keys['cod']] === "7" ||
                tmp.data[u][keys['cod']] === "8" ||
                tmp.data[u][keys['cod']] === "9"
              ) {
                let _tmp = 0;
                if (template.data[i][9] !== undefined) {
                  _tmp = template.data[i][9].fix();
                }
                template.data[i][9] = (tmp.data[u][keys['vl1']].fix() + _tmp).two()
              }
            }
          }
        }
      }
    }

    for (let i = 9; i < 34; i++) {
      if (template.data[i][1].length === 0) {
        template.data[i][1] = 0;
      }
      if (template.data[i][2].length === 0) {
        template.data[i][2] = 0;
      }
      if (template.data[i][3].length === 0) {
        template.data[i][3] = 0;
      }
      if (template.data[i][5].length === 0) {
        template.data[i][5] = 0;
      }

      if (template.data[i][11].length === 0) {
        template.data[i][11] = 0;
      }
      if (template.data[i][12].length === 0) {
        template.data[i][12] = 0;
      }
      if (template.data[i][13].length === 0) {
        template.data[i][13] = 0;
      }
      if (template.data[i][14].length === 0) {
        template.data[i][14] = 0;
      }
      if (template.data[i][15].length === 0) {
        template.data[i][15] = 0;
      }
      if (template.data[i][16].length === 0) {
        template.data[i][16] = 0;
      }
    }

    for (let i = 38; i < 58; i++) {
      if (template.data[i][1].length === 0) {
        template.data[i][1] = 0;
      }
      if (template.data[i][2].length === 0) {
        template.data[i][2] = 0;
      }
      if (template.data[i][3].length === 0) {
        template.data[i][3] = 0;
      }
      if (template.data[i][4].length === 0) {
        template.data[i][4] = 0;
      }
      if (template.data[i][5].length === 0) {
        template.data[i][5] = 0;
      }

      if (template.data[i][7].length === 0) {
        template.data[i][7] = 0;
      }
      if (template.data[i][8].length === 0) {
        template.data[i][8] = 0;
      }
      if (template.data[i][9].length === 0) {
        template.data[i][9] = 0;
      }
    }

    i = 9;
    while (i <= 29) {
      if (
        (template.data[i][1].fix() === 0) &&
        (template.data[i][2].fix() === 0) &&
        (template.data[i][3].fix() === 0)
      ) {
        template.rows[i] = { visible: false };
      }
      i = i + 5;
    }

    i = 10;
    while (i <= 33) {
      if (
        (template.data[i][1].fix() === 0) &&
        (template.data[i][2].fix() === 0) &&
        (template.data[i][3].fix() === 0)
      ) {
        template.rows[i] = { visible: false };
      }

      if (
        (template.data[i + 1][1].fix() === 0) &&
        (template.data[i + 1][2].fix() === 0) &&
        (template.data[i + 1][3].fix() === 0)
      ) {
        template.rows[i + 1] = { visible: false };
      }

      if (
        (template.data[i + 2][1].fix() === 0) &&
        (template.data[i + 2][2].fix() === 0) &&
        (template.data[i + 2][3].fix() === 0)
      ) {
        template.rows[i + 2] = { visible: false };
      }

      if (
        (template.data[i + 3][1].fix() === 0) &&
        (template.data[i + 3][2].fix() === 0) &&
        (template.data[i + 3][3].fix() === 0)
      ) {
        template.rows[i + 3] = { visible: false };
      }
      i = i + 5;
    }

    for (let i = 38; i < 58; i++) {
      if (template.data[i][7] === 0) {
        template.rows[i] = { visible: false };
      }
    }

    template.data[1][1] = configuracoes.header;
    template.data[59][1] = configuracoes.footer;

    return JSON.parse(JSON.stringify(template).replace(/#2e3757/g, configuracoes.data.toString()));
  }

  async F09(template: any, dashData: any, configuracoes: any) {
    const anos = this.getAnual();
    const trimestres = this.getTrimestres();

    let i = 9;
    let loops = 0;
    while (i <= 29) {
      template.data[i][0] = anos[loops]
      i = i + 5;
      loops++;
    }

    i = 10;
    loops = 0;
    while (i <= 33) {
      template.data[i][0] = trimestres[loops];
      template.data[i + 1][0] = trimestres[loops + 1];
      template.data[i + 2][0] = trimestres[loops + 2];
      template.data[i + 3][0] = trimestres[loops + 3];
      i = i + 5;
      loops = loops + 4;
    }

    for (let i = 38; i < 58; i++) {
      template.data[i][0] = trimestres[i - 38]
    }

    let keys: any = {};
    let tmp = dashData.find(element => element.worksheetName === 'ECF - M350');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "ID_DT_INI") {
          keys['periodo'] = u;
        }
        if (tmp.columns[u].title === "PER_APUR") {
          keys['pa'] = u;
        }
        if (tmp.columns[u].title === "CODIGO") {
          keys['cod'] = u;
        }
        if (tmp.columns[u].title === "VALOR") {
          keys['vl1'] = u;
        }
      }

      let i = 9;
      while (i <= 29) {
        for (let u = 0; u < tmp.data.length; u++) {
          if (this.fromUS(tmp.data[u][keys['periodo']]).split("/")[2] === template.data[i][0]) {
            if (tmp.data[u][keys['pa']] == "A00" && tmp.data[u][keys['cod']] === "2") {
              template.data[i][1] = tmp.data[u][keys['vl1']].fix().two()
            }
            if (tmp.data[u][keys['pa']] == "A00" && tmp.data[u][keys['cod']] === "93") {
              template.data[i][2] = tmp.data[u][keys['vl1']].fix().two()
            }
            if (tmp.data[u][keys['pa']] == "A00" && tmp.data[u][keys['cod']] === "168") {
              template.data[i][3] = tmp.data[u][keys['vl1']].fix().two()
            }
          }
        }
        i = i + 5;
      }

      i = 10;
      loops = 0;
      while (i <= 33) {
        for (let z = i; z < (i + 4); z++) {
          for (let u = 0; u < tmp.data.length; u++) {
            if (this.fromUS(tmp.data[u][keys['periodo']]).split("/")[2] === template.data[z][0].substr(-4)) {
              if (tmp.data[u][keys['pa']] === "T0" + template.data[z][0].substr(0, 1)) {
                if (tmp.data[u][keys['cod']] === "2") {
                  template.data[z][1] = tmp.data[u][keys['vl1']].fix().two()
                }
                if (tmp.data[u][keys['cod']] === "93") {
                  template.data[z][2] = tmp.data[u][keys['vl1']].fix().two()
                }
                if (tmp.data[u][keys['cod']] === "168") {
                  template.data[z][3] = tmp.data[u][keys['vl1']].fix().two()
                }
              }
            }
          }
        }
        i = i + 5;
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'ECF - N670');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "ID_DT_INI") {
          keys['periodo'] = u;
        }
        if (tmp.columns[u].title === "PER_APUR") {
          keys['pa'] = u;
        }
        if (tmp.columns[u].title === "CODIGO") {
          keys['cod'] = u;
        }
        if (tmp.columns[u].title === "VALOR") {
          keys['vl1'] = u;
        }
      }

      let i = 9;
      while (i <= 29) {
        for (let u = 0; u < tmp.data.length; u++) {
          if (this.fromUS(tmp.data[u][keys['periodo']]).split("/")[2] === template.data[i][0]) {
            if (
              template.data[i][1].length === undefined ||
              template.data[i][2].length === undefined ||
              template.data[i][3].length === undefined
            ) {
              if (tmp.data[u][keys['pa']] == "A00" && tmp.data[u][keys['cod']] === "1") {
                template.data[i][5] = tmp.data[u][keys['vl1']].fix().two()
              }

              if (tmp.data[u][keys['pa']] == "A00") {
                if (
                  tmp.data[u][keys['cod']] === "15" ||
                  tmp.data[u][keys['cod']] === "16" ||
                  tmp.data[u][keys['cod']] === "17" ||
                  tmp.data[u][keys['cod']] === "18"
                ) {
                  let _tmp = 0;
                  if (template.data[i][11].length === undefined) {
                    _tmp = parseFloat(template.data[i][11]);
                  }
                  template.data[i][11] = (tmp.data[u][keys['vl1']].fix() + _tmp).two()
                }
              }

              if (tmp.data[u][keys['pa']] == "A00" && tmp.data[u][keys['cod']] === "20") {
                template.data[i][12] = tmp.data[u][keys['vl1']].fix().two()
              }

              if (tmp.data[u][keys['pa']] == "A00" && tmp.data[u][keys['cod']] === "19") {
                template.data[i][13] = tmp.data[u][keys['vl1']].fix().two()
              }

              if (tmp.data[u][keys['pa']] == "A00" && tmp.data[u][keys['cod']] === "14") {
                template.data[i][14] = tmp.data[u][keys['vl1']].fix().two()
              }

              if (tmp.data[u][keys['pa']] == "A00") {
                if (
                  tmp.data[u][keys['cod']] === "6" ||
                  tmp.data[u][keys['cod']] === "7" ||
                  tmp.data[u][keys['cod']] === "8" ||
                  tmp.data[u][keys['cod']] === "9" ||
                  tmp.data[u][keys['cod']] === "10" ||
                  tmp.data[u][keys['cod']] === "11" ||
                  tmp.data[u][keys['cod']] === "12" ||
                  tmp.data[u][keys['cod']] === "13"
                ) {
                  let _tmp = 0;
                  if (template.data[i][15].length === undefined) {
                    _tmp = parseFloat(template.data[i][15]);
                  }
                  template.data[i][15] = (tmp.data[u][keys['vl1']].fix() + _tmp).two()
                }
              }

              if (tmp.data[u][keys['pa']] == "A00" && tmp.data[u][keys['cod']] === "21") {
                template.data[i][16] = tmp.data[u][keys['vl1']].fix().two()
              }
            }
          }
        }
        i = i + 5;
      }

      let z = 10;
      loops = 0;
      while (z <= 34) {
        for (let i = z; i < (z + 4); i++) {
          for (let u = 0; u < tmp.data.length; u++) {
            if (this.fromUS(tmp.data[u][keys['periodo']]).split("/")[2] === template.data[i][0].substr(-4)) {
              if (tmp.data[u][keys['pa']] === "T0" + template.data[i][0].substr(0, 1)) {
                if (
                  template.data[i][1].length === undefined ||
                  template.data[i][2].length === undefined ||
                  template.data[i][3].length === undefined
                ) {
                  if (tmp.data[u][keys['cod']] === "1") {
                    template.data[i][5] = tmp.data[u][keys['vl1']].fix().two()
                  }

                  if (
                    tmp.data[u][keys['cod']] === "15" ||
                    tmp.data[u][keys['cod']] === "16" ||
                    tmp.data[u][keys['cod']] === "17" ||
                    tmp.data[u][keys['cod']] === "18"
                  ) {
                    let _tmp = 0;
                    if (template.data[i][11].length === undefined) {
                      _tmp = template.data[i][11].fix();
                    }
                    template.data[i][11] = (tmp.data[u][keys['vl1']].fix() + _tmp).two()
                  }

                  if (tmp.data[u][keys['cod']] === "20") {
                    template.data[i][12] = tmp.data[u][keys['vl1']].fix().two()
                  }

                  if (tmp.data[u][keys['cod']] === "19") {
                    template.data[i][13] = tmp.data[u][keys['vl1']].fix().two()
                  }

                  if (
                    tmp.data[u][keys['cod']] === "19" ||
                    tmp.data[u][keys['cod']] === "23"
                  ) {
                    let _tmp = 0;
                    if (template.data[i][14].length === undefined) {
                      _tmp = template.data[i][14].fix();
                    }
                    template.data[i][14] = (tmp.data[u][keys['vl1']].fix() + _tmp).two()
                  }

                  if (
                    tmp.data[u][keys['cod']] === "6" ||
                    tmp.data[u][keys['cod']] === "7" ||
                    tmp.data[u][keys['cod']] === "8" ||
                    tmp.data[u][keys['cod']] === "9" ||
                    tmp.data[u][keys['cod']] === "10" ||
                    tmp.data[u][keys['cod']] === "11" ||
                    tmp.data[u][keys['cod']] === "12" ||
                    tmp.data[u][keys['cod']] === "13"
                  ) {
                    let _tmp = 0;
                    if (template.data[i][15].length === undefined) {
                      _tmp = template.data[i][15].fix();
                    }
                    template.data[i][15] = (tmp.data[u][keys['vl1']].fix() + _tmp).two()
                  }

                  if (tmp.data[u][keys['cod']] === "21") {
                    template.data[i][16] = tmp.data[u][keys['vl1']].fix().two()
                  }
                }
              }
            }
          }
        }
        z = z + 5;
      }

      for (let i = 9; i < 34; i++) {
        const tmp2 = dashData.find(element => element.worksheetInstance === 'F09 - ECF - CSLL');
        if (tmp2 !== undefined && tmp2.data !== undefined) {
          if (template.data[i][9].length === undefined) {
            template.data[i][9] = tmp2.data[i][9].fix().two()
          } else {
            template.data[i][9] = 0;
          }
        } else {
          template.data[i][9] = 0;
        }

        if (i === 9) {
          let saldo_inicial = 0;

          const tmp2 = dashData.find(element => element.worksheetName === 'ECF - M010');
          if (tmp2 !== undefined) {
            const keys2 = {}

            for (let z = 0; z < tmp2.columns.length; z++) {
              if (tmp2.columns[z].title === "ID_DT_INI") {
                keys2['periodo'] = z;
              }
              if (tmp2.columns[z].title === "DESC_CTA_LAL") {
                keys2['desc'] = z;
              }
              if (tmp2.columns[z].title === "DT_AP_LAL") {
                keys2['dt'] = z;
              }
              if (tmp2.columns[z].title === "VL_SALDO_INI") {
                keys2['vl1'] = z;
              }
              if (tmp2.columns[z].title === "COD_TRIBUTO") {
                keys2['cod'] = z;
              }
            }

            await (async () => {
              for (let x = 0; x < anos.length; x++) {
                let opcoes: any = [];
                for (let z = 0; z < tmp2.data.length; z++) {
                  if (this.fromUS(tmp2.data[z][keys2['periodo']]).split("/")[2] === anos[x]) {
                    if (tmp2.data[z][keys2['cod']] === "I") {
                      opcoes.push([
                        this.fromUS(tmp2.data[z][keys2['periodo']]),
                        tmp2.data[z][keys2['desc']],
                        this.fromUS(tmp2.data[z][keys2['dt']]),
                        tmp2.data[z][keys2['vl1']].fix()
                      ]);
                    }
                  }
                }

                if (opcoes.length > 0) {
                  opcoes.push([
                    '-',
                    'DESCONSIDERAR PREJUÍZOS FISCAIS',
                    '-',
                    0
                  ]);

                  let opcoesText = "";
                  for (let z = 0; z < opcoes.length; z++) {
                    opcoesText = opcoesText + '<tr><td><div class="form-check"><input class="form-check-input prejuizo" type="checkbox" value="' + z + '"></div></td><td>' + opcoes[z][0] + '</td></td><td>' + opcoes[z][1] + '</td></td><td>' + opcoes[z][2] + '</td></td><td>' + opcoes[z][3].toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + '</td></tr>';
                  }

                  const res = await Swal.fire({
                    title: 'F09 - ECF - CSLL',
                    html: 'Selecione o <span style="color:red">Saldo Inicial de Prejuízos Fiscais</span> de acordo com as informações identificadas no registro M010 da ECF referentes ao Prejuízo Fiscal acumulado de anos anteriores.' +
                      '<div class="mt-3" style="max-height: 260px; overflow: auto;"><table class="table table-responsive dataTable no-footer"><thead class="thead-primary"><tr><th><i class="bi bi-check2-square"></i></th><th>ID_DT_INI</th><th style="width: 30%">DESC_CTA_LAL</th><th>DT_AP_LAL</th><th>VL_SALDO_INI</th></tr></thead><tbody>' + opcoesText + '</tbody></table></div>',
                    icon: 'question',
                    heightAuto: false,
                    allowOutsideClick: false,
                    customClass: {
                      confirmButton: 'btn-swal'
                    },
                    width: 800,
                    confirmButtonText: 'Selecionar',
                    input: 'radio',
                    inputValidator: (value: any): any => {
                      const elements = document.querySelectorAll('.prejuizo');
                      for (const index of elements) {
                        if ((index as HTMLInputElement).checked) {
                          return
                        }
                      }
                      return 'É necessário selecionar uma opção!'
                    }
                  }).then((result) => {
                    const elements = document.querySelectorAll('.prejuizo');
                    for (const index of elements) {
                      if ((index as HTMLInputElement).checked) {
                        saldo_inicial = saldo_inicial + opcoes[(index as HTMLInputElement).value][3]
                      }
                    }
                  })
                  break;
                }
              }
            })();
          }

          template.data[i][6] = saldo_inicial.two();
        }
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F08 - ECF - IRPJ');
    if (tmp !== undefined) {
      for (let i = 38; i < 58; i++) {
        template.data[i][1] = tmp.data[i][1]
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'ECF - P400');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "ID_DT_INI") {
          keys['periodo'] = u;
        }
        if (tmp.columns[u].title === "PER_APUR") {
          keys['pa'] = u;
        }
        if (tmp.columns[u].title === "CODIGO") {
          keys['cod'] = u;
        }
        if (tmp.columns[u].title === "VALOR") {
          keys['vl1'] = u;
        }
      }

      for (let i = 38; i < 58; i++) {
        for (let u = 0; u < tmp.data.length; u++) {
          if (this.fromUS(tmp.data[u][keys['periodo']]).split("/")[2] === template.data[i][0].substr(-4)) {
            if (tmp.data[u][keys['pa']] === "T0" + template.data[i][0].substr(0, 1)) {
              if (tmp.data[u][keys['cod']] === "2") {
                template.data[i][2] = tmp.data[u][keys['vl1']].fix().two()
              }

              if (tmp.data[u][keys['cod']] === "4") {
                template.data[i][3] = tmp.data[u][keys['vl1']].fix().two()
              }
            }
          }
        }
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'ECF - P500');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "ID_DT_INI") {
          keys['periodo'] = u;
        }
        if (tmp.columns[u].title === "PER_APUR") {
          keys['pa'] = u;
        }
        if (tmp.columns[u].title === "CODIGO") {
          keys['cod'] = u;
        }
        if (tmp.columns[u].title === "VALOR") {
          keys['vl1'] = u;
        }
      }

      for (let i = 38; i < 58; i++) {
        for (let u = 0; u < tmp.data.length; u++) {
          if (this.fromUS(tmp.data[u][keys['periodo']]).split("/")[2] === template.data[i][0].substr(-4)) {
            if (tmp.data[u][keys['pa']] === "T0" + template.data[i][0].substr(0, 1)) {
              if (tmp.data[u][keys['cod']] === "13") {
                template.data[i][4] = tmp.data[u][keys['vl1']].fix().two()
              }

              if (
                tmp.data[u][keys['cod']] === "9" ||
                tmp.data[u][keys['cod']] === "10" ||
                tmp.data[u][keys['cod']] === "11" ||
                tmp.data[u][keys['cod']] === "12"
              ) {
                template.data[i][5] = (tmp.data[u][keys['vl1']].fix() + (template.data[i][5] !== undefined ? template.data[i][5]?.fix() : 0)).two()
              }

              if (
                tmp.data[u][keys['cod']] === "6" ||
                tmp.data[u][keys['cod']] === "7" ||
                tmp.data[u][keys['cod']] === "8"
              ) {
                template.data[i][6] = (tmp.data[u][keys['vl1']].fix() + (template.data[i][6] !== undefined ? template.data[i][6]?.fix() : 0)).two()
              }
            }
          }
        }
      }
    }

    for (let i = 9; i < 34; i++) {
      if (template.data[i][1].length === 0) {
        template.data[i][1] = 0;
      }
      if (template.data[i][2].length === 0) {
        template.data[i][2] = 0;
      }
      if (template.data[i][3].length === 0) {
        template.data[i][3] = 0;
      }
      if (template.data[i][5].length === 0) {
        template.data[i][5] = 0;
      }

      if (template.data[i][11].length === 0) {
        template.data[i][11] = 0;
      }
      if (template.data[i][12].length === 0) {
        template.data[i][12] = 0;
      }
      if (template.data[i][13].length === 0) {
        template.data[i][13] = 0;
      }
      if (template.data[i][14].length === 0) {
        template.data[i][14] = 0;
      }
      if (template.data[i][15].length === 0) {
        template.data[i][15] = 0;
      }
      if (template.data[i][16].length === 0) {
        template.data[i][16] = 0;
      }
    }

    for (let i = 38; i < 58; i++) {
      if (template.data[i][1].length === 0) {
        template.data[i][1] = 0;
      }
      if (template.data[i][2].length === 0) {
        template.data[i][2] = 0;
      }
      if (template.data[i][3].length === 0) {
        template.data[i][3] = 0;
      }
      if (template.data[i][4].length === 0) {
        template.data[i][4] = 0;
      }
      if (template.data[i][5].length === 0) {
        template.data[i][5] = 0;
      }
      if (template.data[i][6].length === 0) {
        template.data[i][6] = 0;
      }
    }

    i = 9;
    while (i <= 29) {
      if (
        (template.data[i][1].fix() === 0) &&
        (template.data[i][2].fix() === 0) &&
        (template.data[i][3].fix() === 0)
      ) {
        template.rows[i] = { visible: false };
      }
      i = i + 5;
    }

    i = 10;
    while (i <= 33) {
      if (
        (template.data[i][1].fix() === 0) &&
        (template.data[i][2].fix() === 0) &&
        (template.data[i][3].fix() === 0)
      ) {
        template.rows[i] = { visible: false };
      }

      if (
        (template.data[i + 1][1].fix() === 0) &&
        (template.data[i + 1][2].fix() === 0) &&
        (template.data[i + 1][3].fix() === 0)
      ) {
        template.rows[i + 1] = { visible: false };
      }

      if (
        (template.data[i + 2][1].fix() === 0) &&
        (template.data[i + 2][2].fix() === 0) &&
        (template.data[i + 2][3].fix() === 0)
      ) {
        template.rows[i + 2] = { visible: false };
      }

      if (
        (template.data[i + 3][1].fix() === 0) &&
        (template.data[i + 3][2].fix() === 0) &&
        (template.data[i + 3][3].fix() === 0)
      ) {
        template.rows[i + 3] = { visible: false };
      }
      i = i + 5;
    }

    for (let i = 38; i < 58; i++) {
      if (template.data[i][4] === 0) {
        template.rows[i] = { visible: false };
      }
    }

    template.data[1][1] = configuracoes.header;
    template.data[59][1] = configuracoes.footer;

    return JSON.parse(JSON.stringify(template).replace(/#2e3757/g, configuracoes.data.toString()));
  }

  F10(template: any, dashData: any, configuracoes: any): any {
    const anos = this.getAnual();
    for (let i = 1; i < 6; i++) {
      template.data[9][i] = anos[i - 1]
      template.data[16][i] = anos[i - 1]
      template.data[23][i] = anos[i - 1]
      template.data[30][i] = anos[i - 1]
    }

    let fp = {}
    let nao_encontrado: Array<any> = [];

    let tmp = dashData.find(element => element.worksheetName === 'Fontes Pagadoras');
    if (tmp !== undefined) {
      for (let i = 0; i < tmp.data.length; i++) {
        if (fp[tmp.data[i][0]] === undefined) {
          fp[tmp.data[i][0]] = {
            pis: 0,
            cofins: 0,
            irrf: 0,
            csll: 0,
            cods: {}
          }
        }

        if (fp[tmp.data[i][0]]['cods'][tmp.data[i][5]] === undefined) {
          fp[tmp.data[i][0]]['cods'][tmp.data[i][5]] = tmp.data[i][7].fix()
        } else {
          fp[tmp.data[i][0]]['cods'][tmp.data[i][5]] = fp[tmp.data[i][0]]['cods'][tmp.data[i][5]] + tmp.data[i][7].fix()
        }
      }

      for (let current of Object.keys(fp)) {
        for (let codigo of Object.keys(fp[current]['cods'])) {
          const _tmp = FPA['default'].find(element => element.cod === codigo);
          if (_tmp === undefined) {
            if (!nao_encontrado.includes(codigo)) {
              nao_encontrado.push(codigo);
            }
            console.log('Código não encontrado: ' + codigo)
            continue
          }

          if (_tmp['aliq'] > 0) {
            fp[current]['cods'][codigo] = fp[current]['cods'][codigo] * 100 / _tmp['aliq'];
          }
          if (_tmp['pis'] > 0) {
            fp[current]['pis'] = fp[current]['pis'] + (fp[current]['cods'][codigo] * _tmp['pis'] / 100)
          }
          if (_tmp['cofins'] > 0) {
            fp[current]['cofins'] = fp[current]['cofins'] + (fp[current]['cods'][codigo] * _tmp['cofins'] / 100)
          }
          if (_tmp['irrf'] > 0) {
            fp[current]['irrf'] = fp[current]['irrf'] + (fp[current]['cods'][codigo] * _tmp['irrf'] / 100)
          }
          if (_tmp['csll'] > 0) {
            fp[current]['csll'] = fp[current]['csll'] + (fp[current]['cods'][codigo] * _tmp['csll'] / 100)
          }
        }
      }

      for (let i = 1; i < 6; i++) {
        if (fp[template.data[9][i]] !== undefined) {
          template.data[10][i] = fp[template.data[9][i]]['pis'].two()
          template.data[17][i] = fp[template.data[9][i]]['cofins'].two()
          template.data[24][i] = fp[template.data[9][i]]['irrf'].two()
          template.data[31][i] = fp[template.data[9][i]]['csll'].two()
        }
      }
    }

    template.data[1][0] = nao_encontrado.join("/")

    tmp = dashData.find(element => element.worksheetName === 'F05A - SPED CT - PC CUMULATIVO');
    let tmp2 = dashData.find(element => element.worksheetName === 'F05B - SPED CT -  PC N CUMULAT');
    if (tmp !== undefined && tmp2 !== undefined) {
      let _tmp2 = 0;
      for (let i = 1; i < 6; i++) {
        let _tmp = 0;
        _tmp = _tmp + tmp.data[i + 9 + _tmp2][7].fix()
        _tmp = _tmp + tmp.data[i + 10 + _tmp2][7].fix()
        _tmp = _tmp + tmp.data[i + 11 + _tmp2][7].fix()
        _tmp = _tmp + tmp.data[i + 12 + _tmp2][7].fix()
        _tmp = _tmp + tmp.data[i + 13 + _tmp2][7].fix()
        _tmp = _tmp + tmp.data[i + 14 + _tmp2][7].fix()
        _tmp = _tmp + tmp.data[i + 15 + _tmp2][7].fix()
        _tmp = _tmp + tmp.data[i + 16 + _tmp2][7].fix()
        _tmp = _tmp + tmp.data[i + 17 + _tmp2][7].fix()
        _tmp = _tmp + tmp.data[i + 18 + _tmp2][7].fix()
        _tmp = _tmp + tmp.data[i + 19 + _tmp2][7].fix()
        _tmp = _tmp + tmp.data[i + 20 + _tmp2][7].fix()

        _tmp = _tmp + tmp2.data[i + 9 + _tmp2][14].fix()
        _tmp = _tmp + tmp2.data[i + 10 + _tmp2][14].fix()
        _tmp = _tmp + tmp2.data[i + 11 + _tmp2][14].fix()
        _tmp = _tmp + tmp2.data[i + 12 + _tmp2][14].fix()
        _tmp = _tmp + tmp2.data[i + 13 + _tmp2][14].fix()
        _tmp = _tmp + tmp2.data[i + 14 + _tmp2][14].fix()
        _tmp = _tmp + tmp2.data[i + 15 + _tmp2][14].fix()
        _tmp = _tmp + tmp2.data[i + 16 + _tmp2][14].fix()
        _tmp = _tmp + tmp2.data[i + 17 + _tmp2][14].fix()
        _tmp = _tmp + tmp2.data[i + 18 + _tmp2][14].fix()
        _tmp = _tmp + tmp2.data[i + 19 + _tmp2][14].fix()
        _tmp = _tmp + tmp2.data[i + 20 + _tmp2][14].fix()

        template.data[11][i] = _tmp.two()

        _tmp = 0;
        _tmp = _tmp + tmp.data[i + 9 + _tmp2][27].fix()
        _tmp = _tmp + tmp.data[i + 10 + _tmp2][27].fix()
        _tmp = _tmp + tmp.data[i + 11 + _tmp2][27].fix()
        _tmp = _tmp + tmp.data[i + 12 + _tmp2][27].fix()
        _tmp = _tmp + tmp.data[i + 13 + _tmp2][27].fix()
        _tmp = _tmp + tmp.data[i + 14 + _tmp2][27].fix()
        _tmp = _tmp + tmp.data[i + 15 + _tmp2][27].fix()
        _tmp = _tmp + tmp.data[i + 16 + _tmp2][27].fix()
        _tmp = _tmp + tmp.data[i + 17 + _tmp2][27].fix()
        _tmp = _tmp + tmp.data[i + 18 + _tmp2][27].fix()
        _tmp = _tmp + tmp.data[i + 19 + _tmp2][27].fix()
        _tmp = _tmp + tmp.data[i + 20 + _tmp2][27].fix()

        _tmp = _tmp + tmp2.data[i + 9 + _tmp2][55].fix()
        _tmp = _tmp + tmp2.data[i + 10 + _tmp2][55].fix()
        _tmp = _tmp + tmp2.data[i + 11 + _tmp2][55].fix()
        _tmp = _tmp + tmp2.data[i + 12 + _tmp2][55].fix()
        _tmp = _tmp + tmp2.data[i + 13 + _tmp2][55].fix()
        _tmp = _tmp + tmp2.data[i + 14 + _tmp2][55].fix()
        _tmp = _tmp + tmp2.data[i + 15 + _tmp2][55].fix()
        _tmp = _tmp + tmp2.data[i + 16 + _tmp2][55].fix()
        _tmp = _tmp + tmp2.data[i + 17 + _tmp2][55].fix()
        _tmp = _tmp + tmp2.data[i + 18 + _tmp2][55].fix()
        _tmp = _tmp + tmp2.data[i + 19 + _tmp2][55].fix()
        _tmp = _tmp + tmp2.data[i + 20 + _tmp2][55].fix()

        template.data[18][i] = _tmp.two()
        _tmp2 = _tmp2 + 11;
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F08 - ECF - IRPJ');
    tmp2 = dashData.find(element => element.worksheetName === 'F09 - ECF - CSLL');
    if (tmp !== undefined && tmp2 !== undefined) {
      let i = 9;
      let loops = 1;
      while (i <= 33) {
        let _tmp = 0;

        _tmp = _tmp + tmp.data[i][11].fix()
        _tmp = _tmp + tmp.data[i + 1][11].fix()
        _tmp = _tmp + tmp.data[i + 2][11].fix()
        _tmp = _tmp + tmp.data[i + 3][11].fix()
        _tmp = _tmp + tmp.data[i + 4][11].fix()
        template.data[25][loops] = _tmp.two()

        _tmp = 0;
        _tmp = _tmp + tmp2.data[i][11].fix()
        _tmp = _tmp + tmp2.data[i + 1][11].fix()
        _tmp = _tmp + tmp2.data[i + 2][11].fix()
        _tmp = _tmp + tmp2.data[i + 3][11].fix()
        _tmp = _tmp + tmp2.data[i + 4][11].fix()
        template.data[32][loops] = _tmp.two()

        i = i + 5;
        loops++;
      }

      for (let i = 1; i < 6; i++) {
        let _tmp = 0;
        for (let u = 38; u < 58; u++) {
          if (template.data[23][i] === tmp.data[u][0].substr(-4)) {
            _tmp = _tmp + tmp.data[u][8].fix()
          }
        }
        template.data[25][i] = (_tmp + template.data[25][i].fix()).two()

        _tmp = 0;
        for (let u = 38; u < 58; u++) {
          if (template.data[30][i] === tmp2.data[u][0].substr(-4)) {
            if (tmp2.data[u][5]) {
              _tmp = _tmp + tmp2.data[u][5].fix()
            }
          }
        }
        template.data[32][i] = (_tmp + template.data[32][i].fix()).two()
      }
    }

    let keys: any = {};
    tmp = dashData.find(element => element.worksheetName === 'EFD - F600');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "ID_DT_INI") {
          keys['periodo'] = u;
        }
        if (tmp.columns[u].title === "VL_RET_PIS") {
          keys['vl1'] = u;
        }
        if (tmp.columns[u].title === "VL_RET_COFINS") {
          keys['vl2'] = u;
        }
      }

      let f600 = {};
      for (let i = 1; i < 6; i++) {
        f600[template.data[9][i]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        if (f600[this.fromUS(tmp.data[u][keys['periodo']]).split("/")[2]] !== undefined) {
          f600[this.fromUS(tmp.data[u][keys['periodo']]).split("/")[2]][0] = f600[this.fromUS(tmp.data[u][keys['periodo']]).split("/")[2]][0] + tmp.data[u][keys['vl1']].fix()
          f600[this.fromUS(tmp.data[u][keys['periodo']]).split("/")[2]][1] = f600[this.fromUS(tmp.data[u][keys['periodo']]).split("/")[2]][1] + tmp.data[u][keys['vl2']].fix()
        }
      }

      for (let i = 1; i < 6; i++) {
        if (f600[template.data[9][i]]) {
          template.data[12][i] = f600[template.data[9][i]][0].two()
          template.data[19][i] = f600[template.data[9][i]][1].two()
        }
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'ECF - Y570');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "ID_DT_INI") {
          keys['periodo'] = u;
        }
        if (tmp.columns[u].title === "IR_RET") {
          keys['vl1'] = u;
        }
        if (tmp.columns[u].title === "CSLL_RET") {
          keys['vl2'] = u;
        }
      }

      let y570 = {};
      for (let i = 1; i < 6; i++) {
        y570[template.data[9][i]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        if (y570[this.fromUS(tmp.data[u][keys['periodo']]).split("/")[2]] !== undefined) {
          y570[this.fromUS(tmp.data[u][keys['periodo']]).split("/")[2]][0] = y570[this.fromUS(tmp.data[u][keys['periodo']]).split("/")[2]][0] + tmp.data[u][keys['vl1']].fix()
          y570[this.fromUS(tmp.data[u][keys['periodo']]).split("/")[2]][1] = y570[this.fromUS(tmp.data[u][keys['periodo']]).split("/")[2]][1] + tmp.data[u][keys['vl2']].fix()
        }
      }

      for (let i = 1; i < 6; i++) {
        if (y570[template.data[9][i]]) {
          template.data[26][i] = y570[template.data[9][i]][0].two()
          template.data[33][i] = y570[template.data[9][i]][1].two()
        }
      }
    }

    for (let i = 10; i < 13; i++) {
      if (template.data[i][1].length === 0) {
        template.data[i][1] = 0;
      }
      if (template.data[i][2].length === 0) {
        template.data[i][2] = 0;
      }
      if (template.data[i][3].length === 0) {
        template.data[i][3] = 0;
      }
      if (template.data[i][4].length === 0) {
        template.data[i][4] = 0;
      }
      if (template.data[i][5].length === 0) {
        template.data[i][5] = 0;
      }
    }

    for (let i = 17; i < 20; i++) {
      if (template.data[i][1].length === 0) {
        template.data[i][1] = 0;
      }
      if (template.data[i][2].length === 0) {
        template.data[i][2] = 0;
      }
      if (template.data[i][3].length === 0) {
        template.data[i][3] = 0;
      }
      if (template.data[i][4].length === 0) {
        template.data[i][4] = 0;
      }
      if (template.data[i][5].length === 0) {
        template.data[i][5] = 0;
      }
    }

    for (let i = 24; i < 27; i++) {
      if (template.data[i][1].length === 0) {
        template.data[i][1] = 0;
      }
      if (template.data[i][2].length === 0) {
        template.data[i][2] = 0;
      }
      if (template.data[i][3].length === 0) {
        template.data[i][3] = 0;
      }
      if (template.data[i][4].length === 0) {
        template.data[i][4] = 0;
      }
      if (template.data[i][5].length === 0) {
        template.data[i][5] = 0;
      }
    }

    for (let i = 31; i < 34; i++) {
      if (template.data[i][1].length === 0) {
        template.data[i][1] = 0;
      }
      if (template.data[i][2].length === 0) {
        template.data[i][2] = 0;
      }
      if (template.data[i][3].length === 0) {
        template.data[i][3] = 0;
      }
      if (template.data[i][4].length === 0) {
        template.data[i][4] = 0;
      }
      if (template.data[i][5].length === 0) {
        template.data[i][5] = 0;
      }
    }

    template.data[1][1] = configuracoes.header;
    template.data[37][1] = configuracoes.footer;

    return JSON.parse(JSON.stringify(template).replace(/#2e3757/g, configuracoes.data.toString()));
  }

  F11(template: any, dashData: any, configuracoes: any): any {
    const anos = this.getAnual();
    let data: any = [];
    for (let i = 10; i < 15; i++) {
      template.data[i][0] = anos[i - 10]
      data.push({
        "ano": anos[i - 10],
        "valores": [0, 0]
      });
    }

    let keys: any = {};
    let tmp = dashData.find(element => element.worksheetName === 'ECF - L300');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "ID_DT_INI") {
          keys['periodo'] = u;
        }
        if (tmp.columns[u].title === "PER_APUR") {
          keys['per'] = u;
        }
        if (tmp.columns[u].title === "CODIGO") {
          keys['cod'] = u;
        }
        if (tmp.columns[u].title === "VALOR") {
          keys['vl1'] = u;
        }
      }

      let l300 = {};

      for (let i = 10; i < 15; i++) {
        l300[template.data[i][0]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = this.fromUS(tmp.data[u][keys['periodo']]).substr(-4);
        if (l300[x]) {
          if (tmp.data[u][keys['per']] === "A00") {
            if (tmp.data[u][keys['cod']] === "3.01.01.01.01") {
              l300[x][0] = l300[x][0] + tmp.data[u][keys['vl1']].fix();
            }
            if (tmp.data[u][keys['cod']] === "3.01.01.05.01.05") {
              l300[x][1] = l300[x][1] + tmp.data[u][keys['vl1']].fix();
            }
          }

          if (
            tmp.data[u][keys['per']] === "T01" ||
            tmp.data[u][keys['per']] === "T02" ||
            tmp.data[u][keys['per']] === "T03" ||
            tmp.data[u][keys['per']] === "T04"
          ) {
            if (tmp.data[u][keys['cod']] === "3.01.01.01.01") {
              l300[x][0] = l300[x][0] + tmp.data[u][keys['vl1']].fix();
            }
            if (tmp.data[u][keys['cod']] === "3.01.01.05.01.05") {
              l300[x][1] = l300[x][1] + tmp.data[u][keys['vl1']].fix();
            }
          }
        }
      }

      for (let i = 10; i < 15; i++) {
        template.data[i][1] = l300[template.data[i][0]][0].two()
        template.data[i][2] = l300[template.data[i][0]][1].two()
      }
    }

    keys = {};
    tmp = dashData.find(element => element.worksheetName === 'ECF - P150');
    if (tmp !== undefined) {
      for (let u = 0; u < tmp.columns.length; u++) {
        if (tmp.columns[u].title === "ID_DT_INI") {
          keys['periodo'] = u;
        }
        if (tmp.columns[u].title === "PER_APUR") {
          keys['per'] = u;
        }
        if (tmp.columns[u].title === "CODIGO") {
          keys['cod'] = u;
        }
        if (tmp.columns[u].title === "VALOR") {
          keys['vl1'] = u;
        }
      }

      let p150 = {};

      for (let i = 10; i < 15; i++) {
        p150[template.data[i][0]] = [0, 0];
      }

      for (let u = 0; u < tmp.data.length; u++) {
        let x = this.fromUS(tmp.data[u][keys['periodo']]).substr(-4);
        if (p150[x]) {
          if (tmp.data[u][keys['per']] === "A00") {
            if (tmp.data[u][keys['cod']] === "3.01.01.01.01") {
              p150[x][0] = p150[x][0] + tmp.data[u][keys['vl1']].fix();
            }
            if (tmp.data[u][keys['cod']] === "3.01.01.05.01.05") {
              p150[x][1] = p150[x][1] + tmp.data[u][keys['vl1']].fix();
            }
          }

          if (
            tmp.data[u][keys['per']] === "T01" ||
            tmp.data[u][keys['per']] === "T02" ||
            tmp.data[u][keys['per']] === "T03" ||
            tmp.data[u][keys['per']] === "T04"
          ) {
            if (tmp.data[u][keys['cod']] === "3.01.01.01.01") {
              p150[x][0] = p150[x][0] + tmp.data[u][keys['vl1']].fix();
            }
            if (tmp.data[u][keys['cod']] === "3.01.01.05.01.05") {
              p150[x][1] = p150[x][1] + tmp.data[u][keys['vl1']].fix();
            }
          }
        }
      }

      for (let i = 10; i < 15; i++) {
        template.data[i][1] = ((template.data[i][1] !== undefined ? template.data[i][1].fix() : 0) + p150[template.data[i][0]][0]).two()
        template.data[i][2] = ((template.data[i][2] !== undefined ? template.data[i][2].fix() : 0) + p150[template.data[i][0]][1]).two()
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F07 - SPED CT - CST');
    if (tmp !== undefined) {
      for (let i = 8; i < 68; i++) {
        let _tmp = 0;
        _tmp = _tmp + tmp.data[i][2].fix()
        _tmp = _tmp + tmp.data[i][3].fix()
        _tmp = _tmp + tmp.data[i][4].fix()
        _tmp = _tmp + tmp.data[i][5].fix()
        _tmp = _tmp + tmp.data[i][6].fix()
        _tmp = _tmp + tmp.data[i][7].fix()
        _tmp = _tmp + tmp.data[i][8].fix()
        _tmp = _tmp + tmp.data[i][9].fix()
        _tmp = _tmp + tmp.data[i][10].fix()
        _tmp = _tmp + tmp.data[i][11].fix()
        _tmp = _tmp + tmp.data[i][12].fix()

        const key = data.findIndex(element => element.ano === this.getJsDateFromExcel(tmp.data[i][0]).substr(-4));
        data[key]['valores'][0] = data[key]['valores'][0] + _tmp

        _tmp = tmp.data[i][1].fix()
        data[key]['valores'][1] = data[key]['valores'][1] + _tmp
      }
    }

    for (let i = 10; i < 15; i++) {
      template.data[i][3] = data[i - 10]['valores'][0].two()
      template.data[i][4] = data[i - 10]['valores'][1].two()
    }

    template.data[1][1] = configuracoes.header;
    template.data[16][1] = configuracoes.footer;

    return JSON.parse(JSON.stringify(template).replace(/#2e3757/g, configuracoes.data.toString()));
  }

  F12A(template: any, dashData: any, configuracoes: any): any {
    const prescricional = this.getPrescricional();

    for (let i = 9; i < 69; i++) {
      template.data[i][0] = this.JSDateToExcelDate(prescricional[i - 9])
      template.data[i][8] = this.JSDateToExcelDate(prescricional[i - 9])
    }

    let tmp = dashData.find(element => element.worksheetName === 'F02 - DARFs');
    if (tmp !== undefined) {
      for (let i = 10; i < 70; i++) {
        let _tmp = 0;
        _tmp = _tmp + tmp.data[i][1].fix()
        template.data[i - 1][1] = _tmp.two()

        _tmp = 0;
        _tmp = _tmp + tmp.data[i][3].fix()
        template.data[i - 1][9] = _tmp.two()
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F05A - SPED CT - PC CUMULATIVO');
    if (tmp !== undefined) {
      for (let i = 10; i < 70; i++) {
        template.data[i - 1][2] = tmp.data[i][5].fix().two()
        template.data[i - 1][10] = tmp.data[i][25].fix().two()
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F03A - DCTF - PC CUMULATIVO');
    if (tmp !== undefined) {
      for (let i = 9; i < 69; i++) {
        template.data[i][3] = tmp.data[i][1].fix().two()
        template.data[i][4] = tmp.data[i][3].fix().two()
        template.data[i][5] = tmp.data[i][4].fix().two()
        template.data[i][11] = tmp.data[i][11].fix().two()
        template.data[i][12] = tmp.data[i][13].fix().two()
        template.data[i][13] = tmp.data[i][14].fix().two()
      }
    }

    template.data[1][1] = configuracoes.header;
    template.data[70][1] = configuracoes.footer;

    return JSON.parse(JSON.stringify(template).replace(/#2e3757/g, configuracoes.data.toString()));
  }

  F12B(template: any, dashData: any, configuracoes: any): any {
    const prescricional = this.getPrescricional();

    for (let i = 9; i < 69; i++) {
      template.data[i][0] = this.JSDateToExcelDate(prescricional[i - 9])
      template.data[i][8] = this.JSDateToExcelDate(prescricional[i - 9])
    }

    let tmp = dashData.find(element => element.worksheetName === 'F02 - DARFs');
    if (tmp !== undefined) {
      for (let i = 10; i < 70; i++) {
        let _tmp = 0;
        _tmp = _tmp + tmp.data[i][5].fix()
        template.data[i - 1][1] = _tmp.two()

        _tmp = 0;
        _tmp = _tmp + tmp.data[i][7].fix()
        template.data[i - 1][9] = _tmp.two()
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F05B - SPED CT -  PC N CUMULAT');
    if (tmp !== undefined) {
      for (let i = 10; i < 70; i++) {
        template.data[i - 1][2] = tmp.data[i][12].fix().two()
        template.data[i - 1][10] = tmp.data[i][53].fix().two()
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F03B - DCTF - PC NAO CUMULATIVO');
    if (tmp !== undefined) {
      for (let i = 9; i < 69; i++) {
        template.data[i][3] = tmp.data[i][1].fix().two()
        template.data[i][4] = tmp.data[i][3].fix().two()
        template.data[i][5] = tmp.data[i][4].fix().two()
        template.data[i][11] = tmp.data[i][11].fix().two()
        template.data[i][12] = tmp.data[i][13].fix().two()
        template.data[i][13] = tmp.data[i][14].fix().two()
      }
    }

    template.data[1][1] = configuracoes.header;
    template.data[70][1] = configuracoes.footer;

    return JSON.parse(JSON.stringify(template).replace(/#2e3757/g, configuracoes.data.toString()));
  }

  F13A(template: any, dashData: any, configuracoes: any): any {
    const trimestres = this.getTrimestres();

    for (let i = 9; i < 29; i++) {
      template.data[i][0] = trimestres[i - 9];
      template.data[i][8] = trimestres[i - 9]
    }

    let tmp = dashData.find(element => element.worksheetName === 'F02 - DARFs');
    if (tmp !== undefined) {
      for (let i = 10; i < 30; i++) {
        template.data[i - 1][1] = tmp.data[i][17].fix().two()
        template.data[i - 1][9] = tmp.data[i][19].fix().two()
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F08 - ECF - IRPJ');
    if (tmp !== undefined) {
      for (let i = 38; i < 58; i++) {
        template.data[i - 29][2] = tmp.data[i][7].fix().two()
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F09 - ECF - CSLL');
    if (tmp !== undefined) {
      for (let i = 38; i < 58; i++) {
        template.data[i - 29][10] = tmp.data[i][4].fix().two()
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F04A - DCTF - IRCS PRESUMIDO');
    if (tmp !== undefined) {
      for (let i = 9; i < 29; i++) {
        template.data[i][3] = tmp.data[i][1].fix().two()
        template.data[i][4] = tmp.data[i][3].fix().two()
        template.data[i][5] = tmp.data[i][4].fix().two()
        template.data[i][11] = tmp.data[i + 24][1].fix().two()
        template.data[i][12] = tmp.data[i + 24][3].fix().two()
        template.data[i][13] = tmp.data[i + 24][4].fix().two()
      }
    }

    template.data[1][1] = configuracoes.header;
    template.data[30][1] = configuracoes.footer;

    return JSON.parse(JSON.stringify(template).replace(/#2e3757/g, configuracoes.data.toString()));
  }

  F13B(template: any, dashData: any, configuracoes: any): any {
    const trimestres = this.getTrimestres();

    for (let i = 9; i < 29; i++) {
      template.data[i][0] = trimestres[i - 9];
      template.data[i][8] = trimestres[i - 9]
    }

    let tmp = dashData.find(element => element.worksheetName === 'F02 - DARFs');
    if (tmp !== undefined) {
      for (let i = 10; i < 30; i++) {
        template.data[i - 1][1] = tmp.data[i][23].fix().two()
        template.data[i - 1][9] = tmp.data[i][25].fix().two()
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F08 - ECF - IRPJ');
    if (tmp !== undefined) {
      let i = 10;
      let loops = 9;
      while (i <= 33) {
        template.data[loops][2] = tmp.data[i][16].fix().two()
        template.data[loops + 1][2] = tmp.data[i + 1][16].fix().two()
        template.data[loops + 2][2] = tmp.data[i + 2][16].fix().two()
        template.data[loops + 3][2] = tmp.data[i + 3][16].fix().two()
        i = i + 5;
        loops = loops + 4;
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F09 - ECF - CSLL');
    if (tmp !== undefined) {
      let i = 10;
      let loops = 9;
      while (i <= 33) {
        template.data[loops][10] = tmp.data[i][16].fix().two()
        template.data[loops + 1][10] = tmp.data[i + 1][16].fix().two()
        template.data[loops + 2][10] = tmp.data[i + 2][16].fix().two()
        template.data[loops + 3][10] = tmp.data[i + 3][16].fix().two()
        i = i + 5;
        loops = loops + 4;
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F04B - DCTF - IRCS REAL TRIMEST');
    if (tmp !== undefined) {
      for (let i = 9; i < 29; i++) {
        template.data[i][3] = tmp.data[i][1].fix().two()
        template.data[i][4] = tmp.data[i][3].fix().two()
        template.data[i][5] = tmp.data[i][4].fix().two()
        template.data[i][11] = tmp.data[i + 24][1].fix().two()
        template.data[i][12] = tmp.data[i + 24][3].fix().two()
        template.data[i][13] = tmp.data[i + 24][4].fix().two()
      }
    }

    template.data[1][1] = configuracoes.header;
    template.data[30][1] = configuracoes.footer;

    return JSON.parse(JSON.stringify(template).replace(/#2e3757/g, configuracoes.data.toString()));
  }

  F13C(template: any, dashData: any, configuracoes: any): any {
    const anos = this.getAnual();
    for (let i = 8; i < 13; i++) {
      template.data[i][0] = anos[i - 8]
      template.data[i][5] = anos[i - 8]
      template.data[i + 9][0] = anos[i - 8]
      template.data[i + 9][5] = anos[i - 8]
    }

    let tmp = dashData.find(element => element.worksheetName === 'F02 - DARFs');
    if (tmp !== undefined) {
      for (let i = 8; i < 13; i++) {
        let _tmp = 0;
        for (let u = 10; u < 15; u++) {
          if (template.data[i][5] === tmp.data[u][28]) {
            if (tmp.data[u][29]) {
              _tmp = _tmp + tmp.data[u][29].fix()
            }
          }
        }
        template.data[i][6] = _tmp.two()
      }

      for (let i = 17; i < 22; i++) {
        let _tmp = 0;
        for (let u = 10; u < 15; u++) {
          if (template.data[i][5] === tmp.data[u][28]) {
            if (tmp.data[u][31]) {
              _tmp = _tmp + tmp.data[u][31].fix()
            }
          }
        }
        template.data[i][6] = _tmp.two()
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F04C - DCTF - IRCS REAL ANUAL');
    if (tmp !== undefined) {
      for (let i = 8; i < 13; i++) {
        let _tmp = 0;
        for (let u = 9; u < 69; u++) {
          if (template.data[i][0] === this.getJsDateFromExcel(tmp.data[u][0]).split("/")[2]) {
            _tmp = _tmp + tmp.data[u][3].fix()
            _tmp = _tmp + tmp.data[u][4].fix()
            _tmp = _tmp + tmp.data[u][5].fix()
          }
        }
        template.data[i][1] = _tmp.two()
      }

      for (let i = 17; i < 22; i++) {
        let _tmp = 0;
        for (let u = 9; u < 69; u++) {
          if (template.data[i][0] === this.getJsDateFromExcel(tmp.data[u][0]).split("/")[2]) {
            _tmp = _tmp + tmp.data[u][13].fix()
            _tmp = _tmp + tmp.data[u][14].fix()
            _tmp = _tmp + tmp.data[u][15].fix()
          }
        }
        template.data[i][1] = _tmp.two()
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F08 - ECF - IRPJ');
    if (tmp !== undefined) {
      for (let i = 8; i < 13; i++) {
        let _tmp = 0;
        let _tmp2 = 0;
        for (let u = 9; u < 33; u++) {
          if (
            template.data[i][0] === tmp.data[u][0]
          ) {
            _tmp = _tmp + tmp.data[u][13].fix()
            _tmp2 = _tmp2 + tmp.data[u][16].fix()
          }
        }
        template.data[i][2] = _tmp.two()
        template.data[i][7] = _tmp2.two()
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F09 - ECF - CSLL');
    if (tmp !== undefined) {
      for (let i = 17; i < 22; i++) {
        let _tmp = 0;
        let _tmp2 = 0;
        for (let u = 9; u < 33; u++) {
          if (
            template.data[i][0] === tmp.data[u][0]
          ) {
            _tmp = _tmp + tmp.data[u][13].fix()
            _tmp2 = _tmp2 + tmp.data[u][16].fix()
          }
        }
        template.data[i][2] = _tmp.two()
        template.data[i][7] = _tmp2.two()
      }
    }

    template.data[1][1] = configuracoes.header;
    template.data[24][1] = configuracoes.footer;

    return JSON.parse(JSON.stringify(template).replace(/#2e3757/g, configuracoes.data.toString()));
  }

  F14A(template: any, dashData: any, configuracoes: any): any {
    const prescricional = this.getPrescricional();

    for (let i = 8; i < 68; i++) {
      template.data[i][0] = this.JSDateToExcelDate(prescricional[i - 8])
      template.data[i][5] = this.JSDateToExcelDate(prescricional[i - 8])
      template.data[i][10] = this.JSDateToExcelDate(prescricional[i - 8])
      template.data[i][15] = this.JSDateToExcelDate(prescricional[i - 8])
    }

    let tmp = dashData.find(element => element.worksheetName === 'F03A - DCTF - PC CUMULATIVO');
    if (tmp !== undefined) {
      for (let i = 9; i < 69; i++) {
        template.data[i - 1][1] = tmp.data[i][1].fix().two()
        template.data[i - 1][6] = tmp.data[i][11].fix().two()
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F03B - DCTF - PC NAO CUMULATIVO');
    if (tmp !== undefined) {
      for (let i = 9; i < 69; i++) {
        template.data[i - 1][11] = tmp.data[i][1].fix().two()
        template.data[i - 1][16] = tmp.data[i][11].fix().two()
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F05A - SPED CT - PC CUMULATIVO');
    if (tmp !== undefined) {
      for (let i = 10; i < 70; i++) {
        template.data[i - 2][2] = tmp.data[i][5].fix().two()
        template.data[i - 2][7] = tmp.data[i][25].fix().two()
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F05B - SPED CT -  PC N CUMULAT');
    if (tmp !== undefined) {
      for (let i = 10; i < 70; i++) {
        template.data[i - 2][12] = tmp.data[i][12].fix().two()
        template.data[i - 2][17] = tmp.data[i][53].fix().two()
      }
    }

    template.data[1][1] = configuracoes.header;
    template.data[69][1] = configuracoes.footer;

    return JSON.parse(JSON.stringify(template).replace(/#2e3757/g, configuracoes.data.toString()));
  }

  F14B(template: any, dashData: any, configuracoes: any): any {
    const trimestres = this.getTrimestres();

    for (let i = 9; i < 29; i++) {
      template.data[i][0] = trimestres[i - 9]
      template.data[i][5] = trimestres[i - 9]
    }

    for (let i = 32; i < 52; i++) {
      template.data[i][0] = trimestres[i - 32]
      template.data[i][5] = trimestres[i - 32]
    }

    let tmp = dashData.find(element => element.worksheetName === 'F04A - DCTF - IRCS PRESUMIDO');
    if (tmp !== undefined) {
      for (let i = 9; i < 29; i++) {
        template.data[i][1] = tmp.data[i][1].fix().two()
        template.data[i][6] = tmp.data[i + 24][1].fix().two()
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F13A - DARFxDCTFxECF IRCS PRESU');
    if (tmp !== undefined) {
      for (let i = 9; i < 29; i++) {
        template.data[i][2] = tmp.data[i][2].fix().two()
        template.data[i][7] = tmp.data[i][10].fix().two()
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F04B - DCTF - IRCS REAL TRIMEST');
    if (tmp !== undefined) {
      for (let i = 32; i < 52; i++) {
        template.data[i][1] = tmp.data[i - 23][1].fix().two()
        template.data[i][6] = tmp.data[i + 1][1].fix().two()
      }
    }

    tmp = dashData.find(element => element.worksheetName === 'F13B - DARFxDCTFxECF IRCS R TRI');
    if (tmp !== undefined) {
      for (let i = 32; i < 52; i++) {
        template.data[i][2] = tmp.data[i - 23][2].fix().two()
        template.data[i][7] = tmp.data[i - 23][10].fix().two()
      }
    }

    template.data[1][1] = configuracoes.header;
    template.data[53][1] = configuracoes.footer;

    return JSON.parse(JSON.stringify(template).replace(/#2e3757/g, configuracoes.data.toString()));
  }
}
